import React from "react";
import "./Form.css";
import {
  BiltyDataObjectForVerificationFromSuggestion,
  BiltyDataObjectForIdClearance,
} from "../config/Biltyform.js";
import { useRef, useState, useEffect, useMemo } from "react";
import { useApiState } from "./useApiState.js";
import { apiWrapper } from "./apis.js";
import "./AutoSuggest.css";
import {
  NEW_PRINT,
  SERVER_URL,
} from "../config/config";
import { date, object, ref } from "yup";
import { checkIfAnyError } from "../utils/generalUtils.js";
import { biltyAutoUpdationEffectsDummy } from "../utils/biltyUtils.js";
import { mrAutoUpdationEffectsDummy } from "../utils/mrUtils.js";
import { applySchema } from "../utils/apiUtils.js";
import print from "print-js";
import useSessionVariables from "./useSessionVariables";

var reqId = 0;

function formatDate(date) {
  var d = new Date(date),
    month = "" + (d.getMonth() + 1),
    day = "" + d.getDate(),
    year = d.getFullYear();

  if (month.length < 2) month = "0" + month;
  if (day.length < 2) day = "0" + day;

  return [year, month, day].join("-");
}

function formatDateToDDMMYYYY(dateString) {
  const date = new Date(dateString);
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();

  return `${day}-${month}-${year}`;
}

function formatTime(dateString) {
  if (!dateString || typeof dateString !== "string") {
    console.warn("Invalid dateString for formatTime:", dateString);
    return "";
  }

  const parts = dateString.split("T");

  if (parts.length < 2) {
    console.warn("Invalid datetime format:", dateString);
    return "";
  }

  const timePart = parts[1];
  let [hours, minutes] = timePart.split(":");

  hours = parseInt(hours, 10);

  const ampm = hours >= 12 ? "PM" : "AM";
  const displayHours = hours % 12 || 12;

  return `${displayHours}:${minutes} ${ampm}`;
}

function convertAmountToWords(amount) {
  const ones = [
    "",
    "One",
    "Two",
    "Three",
    "Four",
    "Five",
    "Six",
    "Seven",
    "Eight",
    "Nine",
  ];
  const tens = [
    "",
    "",
    "twenty",
    "thirty",
    "forty",
    "fifty",
    "sixty",
    "seventy",
    "eighty",
    "ninety",
  ];
  const teens = [
    "ten",
    "eleven",
    "twelve",
    "thirteen",
    "fourteen",
    "fifteen",
    "sixteen",
    "seventeen",
    "eighteen",
    "nineteen",
  ];
  const placeValues = ["", "thousand", "lakh", "crore"];

  if (amount === 0) return "zero";

  let words = "";

  // Handle crores
  if (amount / 10000000 >= 1) {
    words += convertAmountToWords(Math.floor(amount / 10000000)) + " crore ";
    amount %= 10000000;
  }

  // Handle lakhs
  if (amount / 100000 >= 1) {
    words += convertAmountToWords(Math.floor(amount / 100000)) + " lakh ";
    amount %= 100000;
  }

  // Handle thousands
  if (amount / 1000 >= 1) {
    words += convertAmountToWords(Math.floor(amount / 1000)) + " thousand ";
    amount %= 1000;
  }

  // Handle hundreds
  if (amount / 100 >= 1) {
    words += convertAmountToWords(Math.floor(amount / 100)) + " hundred ";
    amount %= 100;
  }

  // Handle tens and ones
  if (amount > 0) {
    if (words !== "") words += "and ";

    if (amount < 10) {
      words += ones[amount];
    } else if (amount < 20) {
      words += teens[amount - 10];
    } else {
      words += tens[Math.floor(amount / 10)];
      if (amount % 10 > 0) {
        words += "-" + ones[amount % 10];
      }
    }
  }

  return words.trim();
}

const useForm = (formName, validate, dataObject, apiConfig, itemNamesDict, isFreightEditable = false) => {
  const [pageState, setPageState] = useState(dataObject);
  const [initialpageState, setInitialPageState] = useState(dataObject);
  const [valueVerificationState, setValueVerificationState] = useState({});
  const [idClearancState, setIdClearancState] = useState({});
  const [pageMode, setPageMode] = useState("write");
  const [popupError, setPopupError] = useState("Error");
  const [internalValidationErrors, setInternalValidationErrors] = useState({
    username: "",
  });
  const [submitApiState, performSubmission, clearSubmitApiState] =
    useApiState(apiWrapper);
  const [suggestionApiState, performSuggestions, clearSuggestionApiState] =
    useApiState(apiWrapper);
  const [suggestions, setSuggestions] = useState([]);
  let refStoreObject = useRef({});
  const [previousPageMode, setPreviousPageMode] = useState("");
  const [serverPrintNeeded, setServerPrintNeeded] = useState(false);
  const [deletePopup, setDeletePopup] = useState(false);
  const [clearDataOnSave, setClearDataOnSave] = useState(false);
  const [overlay, setOverlay] = useState(false);

  const [isSubmitting, setIsSubmitting] = useState(false);
  const isSubmittingRef = useRef(false);

  const freightOverriddenRef = useRef(false);
  const prevItemInRef = useRef(null);
  const prevPageModeRef = useRef(null);
  const loadedBiltyIdRef = useRef(null);

  const sessionObject = useSessionVariables();

  const makeFocusOnParticularField = (fieldName) => {
    console.log(refStoreObject, fieldName);
    refStoreObject.current[fieldName].focus();
  };

  const makeFocusOnParticularFieldForItem = (groupName, row, fieldName) => {
    refStoreObject.current[groupName][row][fieldName].focus();
  };

  const onKeyPressForKeyNav = async (e, fieldInfoObject, formPageState) => {
    console.log({ e, fieldInfoObject, formPageState });
    if (
      process.env.REACT_APP_CLIENT === "bgtc" &&
      e.key === "Enter" &&
      (fieldInfoObject?.name === "station_to_Name" ||
        fieldInfoObject?.label === "Consignor")
    ) {

      if (
        fieldInfoObject?.name === "station_to_Name" &&
        formPageState.station_to_id &&
        formPageState.lastFetchedStationTo === formPageState.station_to_id &&
        Array.isArray(formPageState.bilty_ids) &&
        formPageState.bilty_ids.length > 0
      ) {
        setPageState(prev => ({
          ...prev,

          station_to_Name: "Bilties already added",
          station_to_id: "",
        }));

        return;
      }

      try {
        let url =
          fieldInfoObject?.name === "station_to_Name"
            ? `from_to_option?from_branch=${formPageState?.station_from}&to_branch=${formPageState?.station_to_id}&companyId=${formPageState?.company_id}&fyear=${formPageState?.fYear}`
            : `consignor_option?from_branch=${formPageState?.station_from}&consignor_id=${formPageState?.consignor_id}&companyId=${formPageState?.company_id || 1}&fyear=${formPageState?.fYear}`;

        setOverlay(true);

        const response = await fetch(`${SERVER_URL}/bilty/${url}`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "x-access-token": "token-value",
          },
        });

        const respData = await response.json();

        if (response?.ok) {
          setPageState(prevState => ({
            ...prevState,
            bilty_ids: [...(prevState.bilty_ids || []), ...(respData || [])],

            // remember which station we fetched
            lastFetchedStationTo: prevState.station_to_id,

            station_to_id: "",
            station_to_Name: "",
          }));
        } else {
          console.error("bilty fetch failed:", respData);
        }
      } catch (error) {
        console.error("Error fetching bilty data:", error);
      } finally {
        setOverlay(false);
      }
    }

    const isNumericValue = fieldInfoObject.isNumericValue || false;
    if (e.key == "Enter") {
      e.preventDefault();
      if ("onKeyPressEvent" in fieldInfoObject) {
        let inputObject = {
          pageState,
          setPageState,
          refStoreObject,
          setOverlay,
          setPageStateByField,
        };
        fieldInfoObject.onKeyPressEvent(inputObject);
      }
      // Block for keyboard navigation
      if ("keyboardNavigationMap" in fieldInfoObject) {
        if ("required" in fieldInfoObject.keyboardNavigationMap) {
          const goToNextField =
            fieldInfoObject.keyboardNavigationMap.required(formPageState);
          // console.log({goToNextField});
          if (goToNextField == false) return;
        }
        if (
          "conditionalNav" in fieldInfoObject.keyboardNavigationMap &&
          fieldInfoObject.keyboardNavigationMap.conditionalNav == true
        ) {
          const nextFieldToFocus =
            fieldInfoObject.keyboardNavigationMap.conditionalNavFunct(
              pageState
            );
          makeFocusOnParticularField(nextFieldToFocus);
          return;
        }
        if ("nextOnRow" in fieldInfoObject.keyboardNavigationMap) {
          const nextFieldToFocus =
            fieldInfoObject.keyboardNavigationMap.nextOnRowTableName;
          const nextFieldColumnToFocus =
            fieldInfoObject.keyboardNavigationMap.nextOnRowField;
          refStoreObject.current[nextFieldToFocus][0][
            nextFieldColumnToFocus
          ].focus();
        } else {
          const nextFieldToFocus =
            fieldInfoObject.keyboardNavigationMap["Enter"];
          makeFocusOnParticularField(nextFieldToFocus);
        }
      }
    }
    if (isNumericValue && (isNaN(Number(e.key)) || e.key === " ")) {
      e.preventDefault();
      return;
    }
  };

  const updateObjectInListInPageState = (idx, objectToUpdate, fieldName) => {
    const rows = [...pageState[fieldName]];
    let rowObject = rows[idx];
    rowObject = { ...rowObject, ...objectToUpdate };
    rows[idx] = rowObject;
    setPageStateByField(fieldName, rows);
  };

  const updateObjectInListInIdClearanceState = (
    idx,
    objectToUpdate,
    fieldName
  ) => {
    let rows = [];
    if (fieldName in idClearancState) {
      rows = [...idClearancState[fieldName]];
    }

    let rowObject = rows[idx];
    rowObject = { ...rowObject, ...objectToUpdate };
    rows[idx] = rowObject;
    setIdClearanceStateByField(fieldName, rows);
  };

  const updatePageStateForGetSuggestion = (responseForFrontend) => {
    setPageState({
      ...pageState,
      ...responseForFrontend,
    });
  };

  const storeInputReference = (
    autosuggest,
    isDyanmicTable,
    dynamicTableName
  ) => {
    if (autosuggest == null) {
      return;
    }
    if (!isDyanmicTable) {
      refStoreObject.current[autosuggest.props.id] = autosuggest.input;
    } else {
      // create list for dynamic table if it doesn't exist already
      if (!(dynamicTableName in refStoreObject.current)) {
        if (dynamicTableName == "item_in") {
          refStoreObject.current["item_in"] = [
            {
              item_name: null,
              unit: null,
              pkgs: null,
              weight: null,
              rate: null,
              amount: null,
              packing_type: null,
              truck_size: null,
            },
          ];
        }
        if (dynamicTableName == "eway_bill_no") {
          refStoreObject.current["eway_bill_no"] = [
            {
              eway_bill_no: "",
              new_row: "",
            },
          ];
        }
      }
      let [field_name, row_index] = autosuggest.props.id.split("#");
      if (row_index < refStoreObject.current[dynamicTableName].length) {
        refStoreObject.current[dynamicTableName][row_index][field_name] =
          autosuggest.input;
      }
    }
  };

  const storeInputReferenceForSelect = (refObject, fieldName) => {
    if (refObject == null) {
      return;
    }
    refStoreObject.current[fieldName] = refObject;
  };

  const storeInputReferenceForSelectForDynamicTable = (
    refObject,
    fieldName,
    index,
    dynamicTableName
  ) => {
    if (refObject == null) {
      return;
    }
    // create list for dynamic table if it doesn't exist already
    if (!(dynamicTableName in refStoreObject.current)) {
      if (dynamicTableName == "item_in") {
        refStoreObject.current["item_in"] = [
          {
            item_name: null,
            unit: null,
            pkgs: null,
            weight: null,
            rate: null,
            amount: null,
            packing_type: null,
          },
        ];
      }
      if (dynamicTableName == "eway_bill_no") {
        refStoreObject.current["eway_bill_no"] = [
          {
            eway_bill_no: "",
            new_row: "",
          },
        ];
      }
    }
    if (index < refStoreObject.current[dynamicTableName].length) {
      refStoreObject.current[dynamicTableName][index][fieldName] = refObject;
    }
  };

  function validator(values, value, regexp, valueVerification) {
    let errors = {};
    var regex = new RegExp(regexp);
    if (values.hasOwnProperty(value)) {
      if (!values[value] || !values[value].trim()) {
        errors[value] = "Required Field";
      } else if (!regex.test(values[value])) {
        errors[value] = "Validation Error";
      } else if (
        value in valueVerification &&
        values[value] != valueVerification[value]
      ) {
        errors[value] = "Invalid";
      } else {
        errors[value] = "";
      }
    }
    return errors;
  }

  const onblurValidator = async (fieldInfoObject) => {
    let fieldName = fieldInfoObject.name;
    let regexp = fieldInfoObject.regExpValidation;
    let dummyInternalValidationErrors = {};

    console.log({ fieldInfoObject });

    if ("toValidate" in fieldInfoObject && fieldInfoObject.toValidate) {
      /*  
                we want conditional validation in toPay field of Bilty module.
            */
      if (
        formName == "Bilty" &&
        (pageState.is_crossing != "Y" || pageState.pay_type != "1")
      ) {
        return;
      }

      dummyInternalValidationErrors = validator(
        { [fieldName]: pageState[fieldName] },
        fieldName,
        regexp,
        valueVerificationState
      );

      console.log({ dummyInternalValidationErrors });
      /**
       * If any field is supposed to select from suggestion and is not selected then
       * this block will throw internal validation error
       */
      if (
        "valueVerificationFromSuggestionNeeded" in fieldInfoObject &&
        fieldInfoObject.valueVerificationFromSuggestionNeeded &&
        pageState[fieldInfoObject.valueVerificationCompulsionField] == ""
      ) {
        if (
          (fieldName in dummyInternalValidationErrors &&
            dummyInternalValidationErrors[fieldName] == "") ||
          !fieldName in dummyInternalValidationErrors
        ) {
          dummyInternalValidationErrors[fieldName] = "Invalid";
        }
      }
      setInternalValidationErrors({
        ...internalValidationErrors,
        ...dummyInternalValidationErrors,
      });
    }

    /**
     * This part is independent of validation error.
     * This part won't do anything with internal validation error but it will only change
     * pageState and idClearanceState.
     *
     * Whenever we want to remove id of any field if we change its value, this block is used.
     * For example:- If we want to make the value of consignor_id = null when value of consignor_name
     * is changed, this block will come into picture.
     */
    if (fieldName in idClearancState) {
      // If Name from suggestion is not same as current name.
      if (pageState[fieldName] != idClearancState[fieldName].value) {
        let dummyObjectForPage = {};
        dummyObjectForPage[idClearancState[fieldName].fieldToClear] = null;
        setPageState({
          ...pageState,
          ...dummyObjectForPage,
        });
        let dummyObjectForClearance = {};
        dummyObjectForClearance[fieldName] = {
          value: "",
          fieldToClear: idClearancState[fieldName].fieldToClear,
        };
        setIdClearancState({
          ...idClearancState,
          ...dummyObjectForClearance,
        });
      }
    }

    if ("onBlurCustomEvent" in fieldInfoObject) {
      let inputObject = {
        pageState,
        setPageState,
        setPageStateByField,
      };
      fieldInfoObject.onBlurCustomEvent(inputObject);
    }
  };

  const onblurValidatorForTable = async (fieldMapping, idx, fieldName) => {
    if (fieldMapping in idClearancState) {
      // If Name from suggestion is not same as current name.
      if (
        pageState[fieldMapping][idx][fieldName] !=
        idClearancState[fieldMapping][idx][fieldName].value
      ) {
        //
        let dummyObjectForPage = {};
        dummyObjectForPage[
          idClearancState[fieldMapping][idx][fieldName].fieldToClear
        ] = null;
        updateObjectInListInPageState(idx, dummyObjectForPage, fieldMapping);
        let dummyObjectForClearance = {};
        dummyObjectForClearance = {
          value: "",
          fieldToClear:
            idClearancState[fieldMapping][idx][fieldName].fieldToClear,
        };
        updateObjectInListInIdClearanceState(
          idx,
          dummyObjectForClearance,
          fieldMapping
        );
      }
    }
  };

  const handleChange = async (e) => {
    const { name, value } = e.target;
    console.log("Temp ", name, value);
    setPageState({
      ...pageState,
      [name]: value,
    });
  };

  // Handle change for select i.e. dropdowns
  const handleChangeForSelect = function (e, selectName) {
    const { name, value } = e.target;
    if (selectName == "pay_type" && formName == "Bilty") {
      setPageState((oldState) => ({
        ...oldState,
        [selectName]: value,
        prev_pay_type: oldState.pay_type,
      }));
    } else {
      setPageState((oldState) => ({
        ...oldState,
        [selectName]: value,
      }));
    }
  };

  function getSuggestionValue(
    suggestion,
    fieldInfoObject,
    apiCallBack,
    updatePageStateForGetSuggestion,
    row_index
  ) {
    console.log({
      suggestion,
      fieldInfoObject,
      apiCallBack,
      updatePageStateForGetSuggestion,
      row_index,
    });
    /**
     * Extracting useful information from
     * field Info Object
     */
    const fieldName = fieldInfoObject["name"];
    const suggestionKeyword = fieldInfoObject["suggestionKeyword"];
    const suggestionSchema = fieldInfoObject["suggestionSchema"];

    console.log(fieldName, suggestionKeyword, suggestionSchema);

    if (
      "apiCallRequiredOnGetValue" in fieldInfoObject &&
      fieldInfoObject["apiCallRequiredOnGetValue"]
    ) {
      let data = {
        fieldName,
        suggestionSchema,
        apiType: "SugesstionValue",
        fieldInfoObject: fieldInfoObject,
        index: row_index,
      };
      data.apiConfig = apiConfig[fieldInfoObject["apiConfigKey"]];
      console.log("!!!", apiConfig[fieldInfoObject["apiConfigKey"]]);
      if (
        apiConfig[fieldInfoObject["apiConfigKey"]] &&
        !(
          "tailTruncate" in apiConfig[fieldInfoObject["apiConfigKey"]] &&
          apiConfig[fieldInfoObject["apiConfigKey"]].tailTruncate
        )
      ) {
        if ("suggestionChooseQueryKeywordCustom" in fieldInfoObject) {
          data.apiUrlTail = fieldInfoObject.suggestionChooseQueryKeywordCustom(
            suggestion,
            pageState
          );
        } else {
          data.apiUrlTail =
            suggestion[fieldInfoObject["suggestionChooseQueryKeyword"]];
        }
      }
      console.log("field Info Object", data);
      if (
        "inputDataNeededInSuggestions" in fieldInfoObject &&
        fieldInfoObject["inputDataNeededInSuggestions"]
      ) {
        if (row_index == null) {
          let dummyObject = {};
          for (let key in pageState) {
            if (key in fieldInfoObject.inputDataFilter) {
              if (fieldInfoObject.inputDataFilter[key] == "same") {
                dummyObject[key] = pageState[key];
              } else {
                dummyObject[fieldInfoObject.inputDataFilter[key]] =
                  pageState[key];
              }
            }
          }
          console.log("duundwd", dummyObject);
          data.apiInputData = dummyObject;
        } else {
          let dummyObject = {};
          for (let key in pageState) {
            if (key in fieldInfoObject.inputDataFilter) {
              if (fieldInfoObject.inputDataFilter[key] == "same") {
                dummyObject[key] = pageState[key];
              } else {
                dummyObject[fieldInfoObject.inputDataFilter[key]] =
                  pageState[key];
              }
            }
          }
          let itemObject = pageState[fieldInfoObject.parentName][row_index];
          for (let key in itemObject) {
            if (key in fieldInfoObject.inputDataFilter) {
              if (fieldInfoObject.inputDataFilter[key] == "same") {
                dummyObject[key] = itemObject[key];
              } else {
                dummyObject[fieldInfoObject.inputDataFilter[key]] =
                  itemObject[key];
              }
            }
          }
          if (formName == "Bilty") {
            if (process.env.REACT_APP_CLIENT == "nrab" || process.env.REACT_APP_CLIENT == "syt" || process.env.REACT_APP_CLIENT == "sangam") {
              dummyObject.unit = pageState.item_in[0].unit;
            } else {
              if (pageState.pay_type == "4") {
                dummyObject.consignee_id = null;
              } else {
                dummyObject.consignor_id = null;
              }
            }

            if (process.env.REACT_APP_CLIENT === "bbac") {
              dummyObject.station_to = pageState.destination;
            }
            
            dummyObject.item_id =
              suggestion[fieldInfoObject["suggestionChooseQueryKeyword"]];

            dummyObject.consignor = pageState.consignor_id || null;
            
          }
          data.apiInputData = dummyObject;
        }
      }
      console.log("Suggestion INput data fff", data);
      apiCallBack(data);
    } else {
      /**
       * If api call not required,
       * parse suggestion schema here only and update the page state.
       */
      let responseForFrontend = {};
      for (let key in suggestionSchema) {
        responseForFrontend[suggestionSchema[key]] = suggestion[key];
      }
      console.log("final suggestion fff", responseForFrontend, suggestion);
      updatePageStateForGetSuggestion(responseForFrontend);
    }
    return suggestion[suggestionKeyword];
  }

  function renderSuggestion(suggestion, fieldInfoObject) {
    /**
     * Extracting useful information from
     * field Info Object
     */
    const suggestionKeyword = fieldInfoObject["suggestionKeyword"];
    if ("suggestionKeywordExtra" in fieldInfoObject) {
      return (
        <div>
          <span>{suggestion[suggestionKeyword]}</span>
          <span>{"\n"}</span>
          <span style={{ color: "blue" }}>
            {suggestion[fieldInfoObject["suggestionKeywordExtra"]]}
          </span>
        </div>
      );
    }
    return <span>{suggestion[suggestionKeyword]}</span>;
  }

  const onSuggestionsFetchRequested = async ({ value }, suggestionFetchApi) => {
    /**
     * Business logic of suggestion fetch Api.
     */
    console.log({ suggestionFetchApi });
    const responseObject = await suggestionFetchApi(value);
    /**
     * Setting state of suggestions hook.
     */
    setSuggestions(responseObject);
  };

  const onSuggestionsFetchRequestedDebounced = useMemo(
    () => _.debounce(onSuggestionsFetchRequested, 400),
    []
  );

  const onSuggestionsClearRequested = (fieldInfoObject) => {
    /**
     * Extracting useful information from
     * field Info Object
     */
    const fieldName = fieldInfoObject["name"];

    setSuggestions([]);
  };

  const onChangeAutoSuggest = (
    _,
    { newValue },
    fieldInfoObject,
    handleChangeDT
  ) => {
    /**
     * Extracting useful information from
     * field Info Object
     */
    const fieldName = fieldInfoObject["name"];
    /**
     * Block for dynamic table auto suggest change.
     */
    if (handleChangeDT) {
      handleChangeDT(fieldName, newValue);
      return;
    }

    /**
     * Block for normal form Auto suggest change
     */
    setPageStateByField(fieldName, newValue);
  };

  async function handleSuccess() {
    let submitObject = pageState;

    if ("save_button" in refStoreObject.current) {
      refStoreObject.current["save_button"].setAttribute(
        "disabled",
        "disabled"
      );
    }
    if ("print_button" in refStoreObject.current) {
      refStoreObject.current["print_button"].setAttribute(
        "disabled",
        "disabled"
      );
    }

    /**
     * SUbmit object adding extra values.
     */
    if (formName == "Bilty") {
      if (pageMode == "write") {
        let apiObj = {
          url: SERVER_URL + "/bilty/",
          apiInputData: submitObject,
          apiConfig: apiConfig.saveBilty,
        };
        await performSubmission(apiObj);
      } else if (pageMode == "edit") {
        let apiObj = {
          url: SERVER_URL + "/bilty/",
          apiInputData: submitObject,
          apiConfig: apiConfig.modifyBilty,
        };
        await performSubmission(apiObj);
      }
    } else if (formName == "Challan") {
      if (pageMode == "write") {
        let apiObj = {
          url:
            process.env.REACT_APP_CLIENT === "xpress"
              ? SERVER_URL + "/challan/save_chalan_trip/"
              : SERVER_URL + "/challan/",
          apiInputData: submitObject,
          apiConfig: apiConfig.saveChallan,
        };
        await performSubmission(apiObj);
      } else if (pageMode == "edit") {
        let apiObj = {
          url:
            process.env.REACT_APP_CLIENT === "xpress"
              ? SERVER_URL + "/challan/update_chalan_trip/"
              : SERVER_URL + "/challan/",
          apiInputData: submitObject,
          apiConfig: apiConfig.modifyChallan,
        };
        await performSubmission(apiObj);
      }
    } else if (formName == "FleetManagement") {
      if (pageMode == "write") {
        let apiObj = {
          url: SERVER_URL + "/fleet_master/",
          apiInputData: submitObject,
          apiConfig: apiConfig.saveFleet,
        };
        await performSubmission(apiObj);
      } else if (pageMode == "edit") {
        let apiObj = {
          url: SERVER_URL + "/fleet_master/",
          apiInputData: submitObject,
          apiConfig: apiConfig.saveFleet,
        };
        await performSubmission(apiObj);
      }
    } else if (formName == "StockOutward") {
      if (pageMode == "write") {
        let apiObj = {
          url: SERVER_URL + "/stock_register/",
          apiInputData: submitObject,
          apiConfig: apiConfig.saveStockOutward,
        };
        await performSubmission(apiObj);
      } else if (pageMode == "edit") {
        let apiObj = {
          url: SERVER_URL + "/edit_stock_register/",
          apiInputData: submitObject,
          apiConfig: apiConfig.editStockOutward,
        };
        await performSubmission(apiObj);
      }
    } else if (formName == "StockInward") {
      if (pageMode == "write") {
        let apiObj = {
          url: SERVER_URL + "/stock_register/",
          apiInputData: submitObject,
          apiConfig: apiConfig.saveStockInward,
        };
        await performSubmission(apiObj);
      } else if (pageMode == "edit") {
        let apiObj = {
          url: SERVER_URL + "/edit_stock_register/",
          apiInputData: submitObject,
          apiConfig: apiConfig.editStockOutward,
        };
        await performSubmission(apiObj);
      }
    } else if (formName == "SeparateEwb") {
      if (pageMode == "write") {
        let apiObj = {
          url: SERVER_URL + "/challan/",
          apiInputData: submitObject,
          apiConfig: apiConfig.saveChallan,
        };
        await performSubmission(apiObj);
      } else if (pageMode == "edit") {
        let apiObj = {
          url: SERVER_URL + "/challan/",
          apiInputData: submitObject,
          apiConfig: apiConfig.modifyChallan,
        };
        await performSubmission(apiObj);
      }
    } else if (formName == "BiltyStatement") {
      if (pageMode == "write") {
        let apiObj = {
          url: SERVER_URL + "/challan/",
          apiInputData: submitObject,
          apiConfig: apiConfig.saveBiltyStatement,
        };
        await performSubmission(apiObj);
      } else if (pageMode == "edit" || pageMode == "view") {
        let apiObj = {
          url: SERVER_URL + "/challan/",
          apiInputData: submitObject,
          apiConfig: apiConfig.modifyBiltyStatement,
        };
        await performSubmission(apiObj);
      }
    } else if (formName == "MrStatement") {
      if (pageMode == "write" || pageMode == "view") {
        let apiObj = {
          url: SERVER_URL + "/challan/",
          apiInputData: submitObject,
          apiConfig: apiConfig.saveMrStatement,
        };
        await performSubmission(apiObj);
      } else if (pageMode == "edit") {
        let apiObj = {
          url: SERVER_URL + "/challan/",
          apiInputData: submitObject,
          apiConfig: apiConfig.modifyChallan,
        };
        await performSubmission(apiObj);
      }
    } else if (formName == "PodChallan") {
      if (pageMode == "write") {
        let apiObj = {
          url: SERVER_URL + "/pod/",
          apiInputData: submitObject,
          apiConfig: apiConfig.saveChallan,
        };
        await performSubmission(apiObj);
      } else if (pageMode == "edit") {
        let apiObj = {
          url: SERVER_URL + "/pod/",
          apiInputData: submitObject,
          apiConfig: apiConfig.modifyChallan,
        };
        await performSubmission(apiObj);
      }
    } else if (formName == "MR") {
      if (pageMode == "write") {
        let apiObj = {
          url: SERVER_URL + "/money_receipt/",
          apiInputData: submitObject,
          apiConfig: apiConfig.saveMr,
        };
        await performSubmission(apiObj);
      } else if (pageMode == "edit") {
        let apiObj = {
          url: SERVER_URL + "/money_receipt/",
          apiInputData: submitObject,
          apiConfig: apiConfig.modifyMr,
        };
        await performSubmission(apiObj);
      }
    } else if (formName == "Trip") {
      if (pageMode == "write") {
        let apiObj = {
          url: SERVER_URL + "/trip/",
          apiInputData: submitObject,
          apiConfig: apiConfig.saveTrip,
        };
        await performSubmission(apiObj);
      } else if (pageMode == "edit" || pageMode == "view") {
        let apiObj = {
          url: SERVER_URL + "/trip/",
          apiInputData: submitObject,
          apiConfig: apiConfig.modifyTrip,
        };
        await performSubmission(apiObj);
      }
    } else if (formName == "VehicleRegister") {
      console.log("Here BEFORE WRITE");
      if (pageMode == "write") {
        console.log("Here IN WRITE");
        let apiObj = {
          url: SERVER_URL + "/vehicleregister/",
          apiInputData: submitObject,
          apiConfig: apiConfig.saveVehicleRegister,
        };
        await performSubmission(apiObj);
      } else if (pageMode == "edit" || pageMode == "view") {
        let apiObj = {
          url: SERVER_URL + "/vehicleregister/",
          apiInputData: submitObject,
          apiConfig: apiConfig.modifyVehicleRegister,
        };
        await performSubmission(apiObj);
      }
    } else if (formName == "MrPendingAmount") {
      console.log("Here BEFORE WRITE");
      if (pageMode == "write") {
        console.log("Here IN WRITE");
        let apiObj = {
          url: SERVER_URL + "/saveMrPending/",
          apiInputData: submitObject,
          apiConfig: apiConfig.saveMrPending,
        };
        await performSubmission(apiObj);
      } else if (pageMode == "edit" || pageMode == "view") {
        let apiObj = {
          url: SERVER_URL + "/modifyMrPending/",
          apiInputData: submitObject,
          apiConfig: apiConfig.modifyMrPending,
        };
        await performSubmission(apiObj);
      }
    } else if (formName == "BankClearance") {
      if (pageMode == "write") {
        console.log("Here IN WRITE");
        let apiObj = {
          url: SERVER_URL + apiConfig.modifyBankClearance,
          apiInputData: submitObject,
          apiConfig: apiConfig.modifyBankClearance,
        };
        await performSubmission(apiObj);
      } else if (pageMode == "edit" || pageMode == "view") {
      }
    } else if (formName == "Vehicle") {
      if (pageMode == "write") {
        let apiObj = {
          url: SERVER_URL + "/vehicle/",
          apiInputData: submitObject,
          apiConfig: apiConfig.saveVehicle,
        };
        await performSubmission(apiObj);
      } else if (pageMode == "edit") {
        let apiObj = {
          url: SERVER_URL + "/vehicle/",
          apiInputData: submitObject,
          apiConfig: apiConfig.modifyVehicle,
        };
        await performSubmission(apiObj);
      }
    } else if (formName == "StationMaster") {
      if (pageMode == "write") {
        let apiObj = {
          url: SERVER_URL + "/branch/",
          apiInputData: submitObject,
          apiConfig: apiConfig.saveStationMaster,
        };
        await performSubmission(apiObj);
      } else if (pageMode == "edit") {
        let apiObj = {
          url: SERVER_URL + "/branch/",
          apiInputData: submitObject,
          apiConfig: apiConfig.modifyStationMaster,
        };
        await performSubmission(apiObj);
      }
    }  else if (formName == "SubStationMaster") {
      if (pageMode == "write") {
        let apiObj = {
          url: SERVER_URL + "/branch/",
          apiInputData: submitObject,
          apiConfig: apiConfig.saveSubStationMaster,
        };
        await performSubmission(apiObj);
      } else if (pageMode == "edit") {
        let apiObj = {
          url: SERVER_URL + "/branch/",
          apiInputData: submitObject,
          apiConfig: apiConfig.modifySubStationMaster,
        };
        await performSubmission(apiObj);
      }
    } else if (formName == "LrMaster") {
      if (pageMode == "write") {
        let apiObj = {
          url: SERVER_URL + "/branch/assign_bilty_no/",
          apiInputData: submitObject,
          apiConfig: apiConfig.saveLrMaster,
        };
        await performSubmission(apiObj);
        window.location.reload();
      }
    } else if (formName == "ItemMaster") {
      console.log("pagemode in item", pageMode);
      if (pageMode == "write") {
        let apiObj = {
          url: SERVER_URL + "/item/",
          apiInputData: submitObject,
          apiConfig: apiConfig.saveItemMaster,
        };
        await performSubmission(apiObj);
      } else if (pageMode == "edit") {
        let apiObj = {
          url: SERVER_URL + "/iteme/",
          apiInputData: submitObject,
          apiConfig: apiConfig.modifyItemMaster,
        };
        await performSubmission(apiObj);
      }
    } else if (formName == "PackingTypeMaster") {
      if (pageMode == "write") {
        let apiObj = {
          apiInputData: submitObject,
          apiConfig: apiConfig.savePackingMaster,
        };
        await performSubmission(apiObj);
      } else if (pageMode == "edit") {
        let apiObj = {
          apiInputData: submitObject,
          apiConfig: apiConfig.modifyPackingMaster,
        };
        await performSubmission(apiObj);
      }
    } else if (formName == "GroupMaster") {
      console.log("pagemode in group", pageMode);
      let apiObj = {
        url: SERVER_URL + "/group/",
        apiInputData: submitObject,
        apiConfig: apiConfig.saveGroupMaster,
      };
      // console.log();
      await performSubmission(apiObj);
      // if (pageMode == "write") {
      // } else if (pageMode == "edit") {
      //     let apiObj = {
      //         url: SERVER_URL + "/iteme/",
      //         apiInputData: submitObject,
      //         apiConfig: apiConfig.modifyItemMaster,
      //     };
      //     await performSubmission(apiObj);
      // }
    } else if (formName == "SubgroupMaster") {
      console.log("pagemode in group", pageMode);
      let apiObj = {
        // url: SERVER_URL + "/group/",
        apiInputData: submitObject,
        apiConfig: apiConfig.saveSubgroupMaster,
      };
      await performSubmission(apiObj);
      // if (pageMode == "write") {
      // } else if (pageMode == "edit") {
      //     let apiObj = {
      //         url: SERVER_URL + "/iteme/",
      //         apiInputData: submitObject,
      //         apiConfig: apiConfig.modifyItemMaster,
      //     };
      //     await performSubmission(apiObj);
      // }
    } else if (formName == "NarrationMaster") {
      console.log("pagemode in group", pageMode);
      let apiObj = {
        // url: SERVER_URL + "/group/",
        apiInputData: submitObject,
        apiConfig: apiConfig.saveNarrationMaster,
      };
      await performSubmission(apiObj);
    } else if (formName == "AccountMaster") {
      if (pageMode == "write") {
        let apiObj = {
          url: SERVER_URL + "/transporter/",
          apiInputData: submitObject,
          apiConfig: apiConfig.saveAccountMaster,
        };
        await performSubmission(apiObj);
      } else if (pageMode == "edit") {
        let apiObj = {
          url: SERVER_URL + "/transporter/",
          apiInputData: submitObject,
          apiConfig: apiConfig.modifyAccountMaster,
        };
        await performSubmission(apiObj);
      }
    } else if (formName == "CROSSINGIN") {
      if (pageMode == "write") {
        let apiObj = {
          url: SERVER_URL + "/crossing_inward/",
          apiInputData: submitObject,
          apiConfig: apiConfig.saveCrossingIn,
        };
        await performSubmission(apiObj);
      } else if (pageMode == "edit") {
        let apiObj = {
          url: SERVER_URL + "/crossing_inward/",
          apiInputData: submitObject,
          apiConfig: apiConfig.modifyCrossingIn,
        };
        await performSubmission(apiObj);
      }
    } else if (formName == "CROSSINGOUT") {
      if (pageMode == "write") {
        let apiObj = {
          url: SERVER_URL + "/crossing_outward/",
          apiInputData: submitObject,
          apiConfig: apiConfig.saveCrossingOut,
        };
        await performSubmission(apiObj);
      } else if (pageMode == "edit") {
        let apiObj = {
          url: SERVER_URL + "/crossing_outward/",
          apiInputData: submitObject,
          apiConfig: apiConfig.modifyCrossingOut,
        };
        await performSubmission(apiObj);
      }
    } else if (formName == "CONSIGNORBILLING") {
      if (pageMode == "write") {
        let apiObj = {
          url: SERVER_URL + "/money_receipt/",
          apiInputData: submitObject,
          apiConfig: apiConfig.saveCrossingBill,
        };
        await performSubmission(apiObj);
      } else if (pageMode == "edit" || pageMode == "view") {
        let apiObj = {
          url: SERVER_URL + "/money_receipt/",
          apiInputData: submitObject,
          apiConfig: apiConfig.modifyCrossingBill,
        };
        await performSubmission(apiObj);
      }
    } else if (formName == "MRBILLING") {
      if (pageMode == "write") {
        let apiObj = {
          url: SERVER_URL + "/money_receipt/",
          apiInputData: submitObject,
          apiConfig: apiConfig.saveCrossingBill,
        };
        await performSubmission(apiObj);
      } else if (pageMode == "edit" || pageMode == "view") {
        let apiObj = {
          url: SERVER_URL + "/money_receipt/",
          apiInputData: submitObject,
          apiConfig: apiConfig.modifyCrossingBill,
        };
        await performSubmission(apiObj);
      }
    } else if (formName == "TripBhada") {
      if (pageMode == "write") {
        let apiObj = {
          url: SERVER_URL + "/trip/",
          apiInputData: submitObject,
          apiConfig: apiConfig.saveTrip,
        };
        await performSubmission(apiObj);
      } else if (pageMode == "edit") {
        console.log("edit!!!");
        let apiObj = {
          url: SERVER_URL + "/trip/",
          apiInputData: submitObject,
          apiConfig: apiConfig.modifyTripBhada,
        };
        await performSubmission(apiObj);
      }
    } else if (formName == "CROSSINGBILLING") {
      if (pageMode == "write") {
        if (pageState.type == "1") {
          let apiObj = {
            url: SERVER_URL + "/trip/",
            apiInputData: submitObject,
            apiConfig: apiConfig.saveCrossingBillIn,
          };
          await performSubmission(apiObj);
        } else {
          let apiObj = {
            url: SERVER_URL + "/trip/",
            apiInputData: submitObject,
            apiConfig: apiConfig.saveCrossingBillOut,
          };
          await performSubmission(apiObj);
        }
      } else if (pageMode == "edit") {
        if (pageState.type == "1") {
          let apiObj = {
            url: SERVER_URL + "/trip/",
            apiInputData: submitObject,
            apiConfig: apiConfig.modifyCrossingBillIn,
          };
          await performSubmission(apiObj);
        } else {
          let apiObj = {
            url: SERVER_URL + "/trip/",
            apiInputData: submitObject,
            apiConfig: apiConfig.modifyCrossingBillOut,
          };
          await performSubmission(apiObj);
        }
      }
    } else if (formName == "PARTYRATEMASTER") {
      if (pageMode == "write") {
        let apiObj = {
          url: SERVER_URL + "/party_rate/",
          apiInputData: submitObject,
          apiConfig: apiConfig.savePartyRateMaster,
        };
        await performSubmission(apiObj);
      }
    } else if (formName == "GENERALRATEMASTER") {
      if (pageMode == "write") {
        let apiObj = {
          apiInputData: submitObject,
          apiConfig: apiConfig.saveGeneralRateMaster,
        };
        await performSubmission(apiObj);
      }
    } else if (formName == "PODSTATEMENT") {
      if (pageMode == "write" || pageMode == "view" || pageMode == "edit") {
        let apiObj = {
          url: SERVER_URL + "/money_receipt/",
          apiInputData: submitObject,
          apiConfig: apiConfig.savePage,
        };
        await performSubmission(apiObj);
      }
      // else if (pageMode == "edit") {
      //     let apiObj = {
      //         url: SERVER_URL + "/money_receipt/",
      //         apiInputData: submitObject,
      //         apiConfig: apiConfig.modifyPage,
      //     };
      //     await performSubmission(apiObj);
      // }
    } else if (formName == "AccountTransaction") {
      if (pageMode == "write") {
        let apiObj = {
          url: SERVER_URL + "/money_receipt/",
          apiInputData: submitObject,
          apiConfig: apiConfig.savePage,
        };
        await performSubmission(apiObj);
      } else if (pageMode == "edit") {
        let apiObj = {
          url: SERVER_URL + "/account_trans/",
          apiInputData: submitObject,
          apiConfig: apiConfig.savePage,
        };
        await performSubmission(apiObj);
      }
    }  else if (formName == "Marfatiya") {
        if (pageMode == "write") {
          let apiObj = {
            url: SERVER_URL + "/marfatiya/",
            apiInputData: submitObject,
            apiConfig: apiConfig.saveMarfatiya,
          };
          await performSubmission(apiObj);
        } else if (pageMode == "edit") {
          console.log("edit!!!");
          let apiObj = {
            url: SERVER_URL + "/marfatiya/",
            apiInputData: submitObject,
            apiConfig: apiConfig.modifyMarfatiya,
          };
          await performSubmission(apiObj);
        }
    }
  }

  async function suggestionFetchApi(fieldInfoObject, value, additionalInfo) {
    /**
     * Extracting useful information from
     * field Info Object
     */
    console.log("FIELD", { fieldInfoObject, value, additionalInfo });
    const fieldName = fieldInfoObject["name"];
    const url = fieldInfoObject["url"];
    const suggestionKeyword =
      fieldInfoObject["suggestionKeywordForFetchApiArgs"];
    let inputData = {};
    let dummyReqId = Math.floor(Math.random() * 100 + 1);
    reqId = dummyReqId;

    if (value == "") {
      return [];
    }

    // Conditional turn off suggestions block
    if ("conditionalTurnOffSuggestions" in fieldInfoObject) {
      if (fieldInfoObject.conditionalTurnOffSuggestions(value)) {
        return [];
      }
    }

    if (
      process.env.REACT_APP_CLIENT === "bbac" &&
      fieldName === "name" &&
      (formName === "StationMaster" || formName === "SubStationMaster")
    ) {
      // Force additional_info ONLY for station and sub station master
      const isBranchValue =
        formName === "StationMaster" ? 1 : 0;

      inputData = {
        [suggestionKeyword]: value,
        search: "like",
        limit: "10",
        companyId: pageState.company_id,
        additional_info: {
          is_branch: isBranchValue,
        },
      };
    }

    else if (
      process.env.REACT_APP_CLIENT === "bbac" &&
      formName === "Bilty" &&
      (fieldName === "station_to_name" || fieldName === "destination_name")
    ) {
      inputData = {
        [suggestionKeyword]: value,
        search: "like",
        limit: "10",
        companyId: pageState.company_id,
      };

      if (fieldName === "station_to_name") {
        inputData.additional_info = {
          is_branch: 1,
        };
      }

      /*
      Previous logic (kept for future reference)

      const isBranchValue =
        fieldName === "station_to_name" ? 1 : 0;

      inputData = {
        [suggestionKeyword]: value,
        search: "like",
        limit: "10",
        companyId: pageState.company_id,
        additional_info: {
          is_branch: isBranchValue,
        },
      };
      */
    }

    else if (additionalInfo != null) {
      let modifiedAdditionalInfo = { ...additionalInfo };

      if (
        process.env.REACT_APP_CLIENT === "bbac" &&
        formName === "Bilty" &&
        fieldName === "item_name"
      ) {
        modifiedAdditionalInfo.station_to = pageState.destination;
      }

      inputData = {
        [suggestionKeyword]: value,
        search: "like",
        limit: "10",
        companyId: pageState.company_id,
        additional_info: modifiedAdditionalInfo,
      };
    } else {
      // ***
      if (fieldInfoObject.label == "Narration") {
        console.log("INSIDE");
        inputData = {
          name: value,
          search: "like",
        };
      }
      // ***
      else {
        inputData = {
          [suggestionKeyword]: value,
          search: "like",
          limit: "10",
          companyId: pageState.company_id,
        };
      }
    }

    const rawResponse = await fetch(url, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(inputData),
    }).catch((err) => {
      console.log({ err });
      // throw new Error(err)
    });

    if (dummyReqId != reqId) {
      return [];
    }

    let responseObject = await rawResponse?.json();
    console.log("TEST", responseObject);

    if (
      process.env.REACT_APP_CLIENT === "bgtc" &&
      (fieldName === "station_from_name" || fieldName === "station_to_name")
    ) {
      responseObject = responseObject.filter(
        (item) => item.is_branch === true
      );
    }

    return responseObject;
  }

  const setPageStateByField = (name, newValue) => {
    setPageState((pageState) => ({
      ...pageState,
      [name]: newValue,
    }));
    if (name === "freight" && isFreightEditable) {
      freightOverriddenRef.current = true;
    }
  };

  const setIdClearanceStateByField = (name, newValue) => {
    setIdClearancState({
      ...idClearancState,
      [name]: newValue,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log("TEST_MONIKA", e, "AND -> ", pageState);
    // if(process.env.REACT_APP_CLIENT == "avr" && pageState?.bilty_ids?.length > 0){
    //     let last_bilty = parseInt(pageState.bilty_ids.length - 1);
    //     pageState.bilty_ids[last_bilty].extra_mr_freight = pageState.extra_mr_freight;
    // }

    // HARD BLOCK: prevent concurrent submits
    if (isSubmittingRef.current) {
      console.warn("Submission already in progress");
      return;
    }

    let internalErrorsDummy = validate(pageState);
    console.log(internalErrorsDummy);
    setInternalValidationErrors(internalErrorsDummy);

    if (!checkIfAnyError(internalErrorsDummy)) {
      isSubmittingRef.current = true;
      setIsSubmitting(true);
      try {
        await handleSuccess();
      } finally {
        isSubmittingRef.current = false;
        setIsSubmitting(false);
        setServerPrintNeeded(false);
      }
    }
  };

  const synchronousSave = async () => {
    let internalErrorsDummy = validate(pageState);
    setInternalValidationErrors(internalErrorsDummy);
    if (!checkIfAnyError(internalErrorsDummy)) {
      if ("save_button" in refStoreObject.current) {
        refStoreObject.current["save_button"].setAttribute(
          "disabled",
          "disabled"
        );
      }
      if ("print_button" in refStoreObject.current) {
        refStoreObject.current["print_button"].setAttribute(
          "disabled",
          "disabled"
        );
      }
      if (formName == "Bilty") {
        if (pageMode == "write") {
          let apiObj = {
            url: SERVER_URL + "/bilty/",
            apiInputData: pageState,
            apiConfig: apiConfig.saveBilty,
          };
          return await apiWrapper(apiObj);
        } else if (pageMode == "edit" || pageMode == "view") {
          let apiObj = {
            url: SERVER_URL + "/bilty/",
            apiInputData: pageState,
            apiConfig: apiConfig.modifyBilty,
          };
          return await apiWrapper(apiObj);
        }
      } else if (formName == "MR") {
        if (pageMode == "write") {
          let apiObj = {
            url: SERVER_URL + "/money_receipt/",
            apiInputData: pageState,
            apiConfig: apiConfig.saveMr,
          };
          return await apiWrapper(apiObj);
        } else if (pageMode == "edit" || pageMode == "view") {
          let apiObj = {
            url: SERVER_URL + "/money_receipt/",
            apiInputData: pageState,
            apiConfig: apiConfig.modifyMr,
          };
          return await apiWrapper(apiObj);
        }
      }
    }
  };

  const handleValueUpdate = (inputObject) => {
    let newObject = {};
    for (let key in pageState) {
      if (key in inputObject) {
        newObject[key] = inputObject[key];
      } else {
        newObject[key] = pageState[key];
      }
    }
    setPageState(newObject);
  };

  const renderSubmitApiResponseStatus = () => {
    if (submitApiState.loading) return "Loading...";

    if (submitApiState.error) return `Error: ${submitApiState.error.msg}`;

    if (submitApiState.data) {
      return `Data: ${JSON.stringify(submitApiState.data.response)}`;
    }
    return "Hit an APi for response";
  };

  const onKeyChange = (e) => {
    if (e.key == "Tab" || e.key == "Enter") {
      console.log("!2", e, e.key);
    }
  };

  const getSuffixesOfBilty = async (bilty_no, fyear) => {
    setPageStateByField("fyear_get_bilty", fyear);
    // setOverlay(true);
    const dataToSend = {
      bilty_no,
      fyear,
    };

    const url = SERVER_URL + "/bilty/suffix_option";
    const resp = await fetch(url, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(dataToSend),
    });

    if (resp.ok) {
      const suffixObj = await resp.json();
      console.log(suffixObj);

      if ("options" in suffixObj && suffixObj.options.length > 0) {
        suffixObj.options = suffixObj.options.map((suff) => {
          return suff == null ? "" : suff;
        });

        // console.log(suffixObj.options);

        setPageState((oldState) => ({
          ...oldState,
          suffix_options: suffixObj.options,
          suffix: suffixObj.options[0],
        }));
        makeFocusOnParticularField("suffix");
      } else {
        setPageState((oldState) => ({
          ...oldState,
          suffix_options: [],
          suffix: "",
        }));
      }
    } else {
      setPageState((oldState) => ({
        ...oldState,
        suffix_options: [],
        suffix: "",
      }));
    }

    // setOverlay(false);
  };

  const getFyearsOnKeyEnter = async (e, myFormName, page_id) => {
    if (e.key == "Enter") {
      e.persist();
      setOverlay(true);
      setPageStateByField("enterEvent", { ...e });

      // console.log(refStoreObject.current[e.target.name]);
      // console.log(e.target.name);
      // refStoreObject.current[e.target.name].blur();

      const company_id = pageState.company_id;
      let url = SERVER_URL;
      let dataToSend = {};
      let finalFyearList = [];

      if (myFormName == "Bilty Inquiry") {
        refStoreObject.current["bilty_no"].blur();
        if (page_id == "") {
          setOverlay(false);
          makeFocusOnParticularFieldForItem("eway_bill_no", 0, "eway_bill_no");
          return;
        }
        url += "/bilty/option";

        dataToSend = {
          companyId: company_id,
          bilty_no: page_id,
          suffix: null,
          fyear: pageState.fYear,
        };

        if (formName == "MR" || formName == "Challan") {
          dataToSend.owned_by = pageState.created_from;
        }

        // if(dataToSend.suffix == "") {
        //     dataToSend.suffix = null;
        // }
      } else if (myFormName == "Challan") {
        refStoreObject.current["challan_no"].blur();
        if (page_id == "") {
          setOverlay(false);
          makeFocusOnParticularField("manual_no");
          return;
        }

        url += "/challan/options";

        dataToSend = {
          companyId: company_id,
          chalan_no: page_id,
        };
      } else if (myFormName == "MR") {
        refStoreObject.current["mr_no"].blur();
        if (page_id == "") {
          setOverlay(false);
          makeFocusOnParticularField("bilty_type");
          return;
        }

        url += "/money_receipt/options";

        dataToSend = {
          companyId: company_id,
          created_from: pageState.created_from,
          mr_no: page_id,
        };
      }

      const resp = await fetch(url, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify(dataToSend),
      });

      if (resp.ok) {
        const fYearList = await resp.json();
        console.log(fYearList);

        fYearList.forEach((obj) => {
          if ("fyear" in obj) {
            finalFyearList.push(obj.fyear);
          }
        });
        finalFyearList.reverse();
      }

      if (finalFyearList.length == 1) {
        if (myFormName == "Bilty Inquiry") {
          console.log("CALLED");
          getSuffixesOfBilty(page_id, finalFyearList[0]);
        } else {
          console.log("CALLED.");
          // console.log(pageState["enterEvent"], e.target);
          getPageOnKeyEnter(e, e.target.value, finalFyearList[0]);
        }
      } else {
        console.log("CALLED...");
        setPageStateByField("fyearList", finalFyearList);
      }

      setOverlay(false);
    }
  };

  useEffect(() => {
    window.addEventListener("Fyear-Changed", () => {
      console.log("Helli");
      window.location.reload();
    });

    return () => {
      window.removeEventListener("Fyear-Changed", null);
    };
  }, []);

  const displayFyearPopup = (close) => (
    <div className="pop-up-container">
      <div className="pop-up-header">
        <div>Please Choose the Financial Year</div>
        <div>
          <a
            className="pop-up-close btn"
            onClick={() => {
              setPageStateByField("fyearList", []);
              close();
            }}
          >
            &times;
          </a>
        </div>
      </div>
      <div
        style={{
          padding: "20px",
          display: "flex",
          gap: "10px",
        }}
      >
        {pageState.fyearList.map((year) => {
          return (
            <button
              style={{
                fontSize: "20px",
              }}
              key={year}
              value={year}
              onClick={(e) => {
                const targetName = pageState.enterEvent.target.name;
                if (
                  targetName == "Bilty No" ||
                  targetName == "bilty_no" ||
                  targetName == "No"
                ) {
                  getSuffixesOfBilty(
                    pageState.enterEvent.target.value,
                    e.target.value
                  );
                } else {
                  getPageOnKeyEnter(
                    pageState.enterEvent,
                    pageState.enterEvent.target.value,
                    e.target.value
                  );
                }
                setPageStateByField("fyearList", []);
                close();
              }}
              onKeyPress={(e) => {
                if (e.key == "Enter") {
                  // console.log(e.target.value);
                  // console.log(pageState.enterEvent.target);
                  const targetName = pageState.enterEvent.target.name;
                  if (
                    targetName == "Bilty No" ||
                    targetName == "bilty_no" ||
                    targetName == "No"
                  ) {
                    getSuffixesOfBilty(
                      pageState.enterEvent.target.value,
                      e.target.value
                    );
                  } else {
                    getPageOnKeyEnter(
                      pageState.enterEvent,
                      pageState.enterEvent.target.value,
                      e.target.value
                    );
                  }
                  setPageStateByField("fyearList", []);
                  close();
                  // var temp = document.getElementById("bilty_no");
                  // console.log(temp, refStoreObject);
                  // document.getElementById("bilty_no").dispatchEvent(new KeyboardEvent("keypress",
                  // {key: "Enter", keyCode: 13, }
                  // ))
                }
              }}
            >
              {year}
            </button>
          );
        })}
      </div>

      {/* <div className="pop-up-actions">
                <button
                    className="pop-up-button"
                    onClick={() => {
                        setPageStateByField("fyearList", []);
                        close();
                    }}
                >
                    Okay
                </button>
            </div> */}
    </div>
  );

  const getPageOnKeyEnter = async (e, page_id, popupFyear) => {
    // console.log(popupFyear, page_id);
    // console.log(pageState);
    const fYear_fetch =
      popupFyear ??
      JSON.parse(sessionStorage.getItem("financial_year_for_fetch"))
        .financial_year_for_fetch;
    const companyId = pageState.company_id; // yet to set
    // console.log(fYear_fetch);

    // console.log(e.key, page_id);
    if (e.key == "Enter") {
      if (formName == "Bilty") {
        if (page_id == "") {
          if (process.env.REACT_APP_CLIENT == "sra") {
            makeFocusOnParticularField("station_from_name");
          } else if ( process.env.REACT_APP_CLIENT == "jncargo") {
            makeFocusOnParticularField("pay_type");
          } else if(process.env.REACT_APP_CLIENT == "guru"){
            refStoreObject.current?.input_date?.setFocus?.();
          } else if (process.env.REACT_APP_CLIENT != "shubham") {
            makeFocusOnParticularFieldForItem(
              "eway_bill_no",
              0,
              "eway_bill_no"
            );
          }
          return;
        }
        setOverlay(true);
        console.log(pageState);
        let suffix = pageState.suffix;
        if (suffix == "") {
          suffix = "null";
        }
        let data = {
          apiUrlTail:
            page_id +
            "?branch_id=" +
            pageState.created_from +
            "&suffix=" +
            suffix,
          apiType: "getBilty",
          apiConfig: apiConfig["getBilty"],
        };
        if (pageState.suffix != "") {
          data.apiUrlTail =
            page_id +
            "?branch_id=" +
            pageState.created_from +
            "&suffix=" +
            pageState.suffix;
        }
        data.apiUrlTail += "&fyear=" + fYear_fetch + "&companyId=" + companyId;
        if (pageState.is_crossing == "Y") {
          if (pageState.suffix == "") {
            setOverlay(false);
            return;
          }
          // data.apiUrlTail += "&transporter_id=" + pageState.transporter_id;
        }
        performSuggestions(data);
        if(process.env.REACT_APP_CLIENT == "guru") {
          let response = await fetch(
            `${SERVER_URL}/bilty/check_bilty_no/${page_id}`
          );
          if (response.ok) {
            setOverlay(false);
  
            let resData = await response.json();
            setPageStateByField("station_from_name", resData?.station_from);
            setPageStateByField("suffix", resData?.suffix);
            makeFocusOnParticularFieldForItem("eway_bill_no", 0, "eway_bill_no");
          } else if (response.status == 406) {
            setOverlay(false);
            performSuggestions(data);
          } else {
            setOverlay(false);
            console.log("there is some error");
          }
        }        
        
      } else if (formName == "Bilty Inquiry") {
        if (page_id == "") {
          makeFocusOnParticularFieldForItem("eway_bill_no", 0, "eway_bill_no");
          return;
        }
        setOverlay(true);
        let suffix = pageState.suffix;
        if (suffix == "") {
          suffix = "null";
        }

        let branchId = pageState.created_from;
        if (
          process.env.REACT_APP_CLIENT === "bgtc" &&
          (
            branchId === undefined ||
            branchId === null ||
            branchId === "" ||
            branchId === "undefined"
          )
        ) {
          branchId = Math.floor(Math.random() * 5) + 1;
        }

        let data = {
          apiUrlTail:
            "inquiry/" +
            page_id +
            "?branch_id=" +
            branchId +
            "&suffix=" +
            suffix,
          apiType: "getBiltyInquiry",
          apiConfig: apiConfig["getBiltyInquiry"],
        };
        if (pageState.suffix != "") {
          data.apiUrlTail =
            "inquiry/" +
            page_id +
            "?branch_id=" +
            branchId +
            "&suffix=" +
            pageState.suffix;
        }
        data.apiUrlTail += "&fyear=" + fYear_fetch + "&companyId=" + companyId;
        performSuggestions(data);
      } else if (formName == "Challan") {
        if (e.target.name == "challan_no") {
          if (page_id == "") {
            makeFocusOnParticularField("manual_no");
            return;
          }
          if ("challan_no" in refStoreObject.current) {
            refStoreObject.current.challan_no.blur();
          }
          setOverlay(true);
          let data = {
            apiUrlTail: page_id + "?branch_id=" + pageState.created_from,
            apiType: "getChallan",
            apiConfig: apiConfig["getChallan"],
          };
          console.log("Get page data fff", data);
          data.apiUrlTail +=
            "&fyear=" + fYear_fetch + "&companyId=" + companyId;
          performSuggestions(data);
        } else {
          if (page_id == "") {
            makeFocusOnParticularField("vehicle_no");
            return;
          }
          if ("manual_no" in refStoreObject.current) {
            refStoreObject.current.manual_no.blur();
          }
          setOverlay(true);
          let data = {
            apiUrlTail: page_id + "?branch_id=" + pageState.created_from,
            apiType: "getChallan",
            apiConfig: apiConfig["getManualChallan"],
          };
          data.apiUrlTail +=
            "&fyear=" + fYear_fetch + "&companyId=" + companyId;
          console.log("Get page data fff", data);
          performSuggestions(data);
        }
      } else if (formName == "FleetManagement") {
        if (e.target.name == "fleet_no") {
          if (page_id == "") {
            makeFocusOnParticularField("fleet_date");
            return;
          }
          if ("fleet_no" in refStoreObject.current) {
            refStoreObject.current.fleet_no.blur();
          }
          setOverlay(true);
          let data = {
            apiUrlTail: page_id + "?branch_id=" + pageState.created_from,
            apiType: "getFleet",
            apiConfig: apiConfig["getFleet"],
          };
          console.log("Get page data fff", data);
          data.apiUrlTail +=
            "&fyear=" + fYear_fetch + "&companyId=" + companyId;
          performSuggestions(data);
        } else {
          if (page_id == "") {
            makeFocusOnParticularField("vehicle_no");
            return;
          }
          if ("manual_no" in refStoreObject.current) {
            refStoreObject.current.manual_no.blur();
          }
          setOverlay(true);
          let data = {
            apiUrlTail: page_id + "?branch_id=" + pageState.created_from,
            apiType: "getChallan",
            apiConfig: apiConfig["getManualChallan"],
          };
          data.apiUrlTail +=
            "&fyear=" + fYear_fetch + "&companyId=" + companyId;
          console.log("Get page data fff", data);
          performSuggestions(data);
        }
      } else if (formName == "StockOutward") {
        if (e.target.name == "register_no") {
          if (page_id == "") {
            makeFocusOnParticularField("outward_date");
            return;
          }

          if ("register_no" in refStoreObject.current) {
            refStoreObject.current.register_no.blur();
          }

          setOverlay(true);
          let data = {
            apiUrlTail: page_id + "?type=2",
            apiType: "getStockOutward",
            apiConfig: apiConfig["getStockOutward"],
          };

          console.log("Get page data fff", data);
          data.apiUrlTail +=
            "&fyear=" + fYear_fetch + "&companyId=" + companyId;
          performSuggestions(data);
        } else {
          if (page_id == "") {
            makeFocusOnParticularField("vehicle_no");
            return;
          }
          if ("manual_no" in refStoreObject.current) {
            refStoreObject.current.manual_no.blur();
          }
          setOverlay(true);
          let data = {
            apiUrlTail: page_id + "?branch_id=" + pageState.created_from,
            apiType: "getChallan",
            apiConfig: apiConfig["getManualChallan"],
          };
          data.apiUrlTail +=
            "&fyear=" + fYear_fetch + "&companyId=" + companyId;
          console.log("Get page data fff", data);
          performSuggestions(data);
        }
      } else if (formName == "StockInward") {
        if (e.target.name == "register_no") {
          if (page_id == "") {
            makeFocusOnParticularField("inward_date");
            return;
          }

          if ("register_no" in refStoreObject.current) {
            refStoreObject.current.register_no.blur();
          }

          setOverlay(true);
          let data = {
            apiUrlTail: page_id + "?type=1",
            apiType: "getStockInward",
            apiConfig: apiConfig["getStockInward"],
          };

          console.log("Get page data fff", data);
          data.apiUrlTail +=
            "&fyear=" + fYear_fetch + "&companyId=" + companyId;
          performSuggestions(data);
        }
      } else if (formName == "SeparateEwb") {
        if (e.target.name == "challan_no") {
          if (page_id == "") {
            makeFocusOnParticularField("manual_no");
            return;
          }
          if ("challan_no" in refStoreObject.current) {
            refStoreObject.current.challan_no.blur();
          }
          setOverlay(true);
          let data = {
            apiUrlTail:
              page_id +
              "?branch_id=" +
              pageState.created_from +
              "&fyear=" +
              fYear_fetch +
              "&companyId=" +
              companyId,
            apiType: "getChallan",
            apiConfig: apiConfig["getChallan"],
          };
          console.log("Get page data fff", data);
          performSuggestions(data);
        } else {
          if (page_id == "") {
            makeFocusOnParticularField("vehicle_no");
            return;
          }
          if ("manual_no" in refStoreObject.current) {
            refStoreObject.current.manual_no.blur();
          }
          setOverlay(true);
          let data = {
            apiUrlTail: page_id + "?branch_id=" + pageState.created_from,
            apiType: "getChallan",
            apiConfig: apiConfig["getManualChallan"],
          };
          console.log("Get page data fff", data);
          performSuggestions(data);
        }
      } else if (formName == "MR") {
        if (page_id == "") {
          makeFocusOnParticularField("bilty_type");
          return;
        }
        let data = {
          apiUrlTail: page_id + "?branch_id=" + pageState.created_from,
          apiType: "getMr",
          apiConfig: apiConfig["getMr"],
        };
        data.apiUrlTail += "&fyear=" + fYear_fetch + "&companyId=" + companyId;
        console.log("Get page data fff", data);
        performSuggestions(data);
      } else if (formName == "MR Inquiry") {
        // if (page_id == "") {
        //   makeFocusOnParticularField("bilty_type");
        //   return;
        // }
        let data = {
          apiUrlTail:
            "inquiry/" + page_id + "?branch_id=" + pageState.created_from,
          apiType: "getMrInquiry",
          apiConfig: apiConfig["getMrInquiry"],
        };
        data.apiUrlTail += "&fyear=" + fYear_fetch + "&companyId=" + companyId;
        console.log("Get page data fff", data);
        performSuggestions(data);
      } else if (formName == "Trip") {
        if (page_id == "") {
          makeFocusOnParticularField("vehicle_no");
          return;
        }
        let data = {
          apiUrlTail: page_id + "?branch_id=" + pageState.created_from,
          apiType: "getTrip",
          apiConfig: apiConfig["getTrip"],
        };
        data.apiUrlTail += "&fyear=" + fYear_fetch + "&companyId=" + companyId;
        console.log("Get page data fff", data);
        performSuggestions(data);
      } else if (formName == "VehicleRegister") {
        if (page_id == "") {
          makeFocusOnParticularField("letter_no");
          return;
        }
        let data = {
          apiUrlTail: page_id,
          apiType: "getVehicleRegister",
          apiConfig: apiConfig["getVehicleRegister"],
        };
        data.apiUrlTail += "?fyear=" + fYear_fetch + "&companyId=" + companyId;
        console.log("Get page data fff", data);
        performSuggestions(data);
      } else if (formName == "MrPendingAmount") {
        if (page_id == "") {
          makeFocusOnParticularField("mr_no");
          return;
        }
        // branch id as well
        let data = {
          apiUrlTail: `${pageState.created_from}/${page_id}`,
          apiType: "getMrPending",
          apiConfig: apiConfig["getMrPending"],
        };
        data.apiUrlTail += "?fyear=" + fYear_fetch + "&companyId=" + companyId;
        console.log("Get page data fff", data);
        performSuggestions(data);
      } else if (formName == "Vehicle") {
        let data = {
          apiUrlTail: page_id + "?branch_id=" + pageState.created_from,
          apiType: "getVehicle",
          apiConfig: apiConfig["getVehicle"],
        };
        console.log("Get page data fff", data);
        performSuggestions(data);
      } else if (formName == "AccountMaster") {
        let data = {
          apiUrlTail: page_id + "?branch_id=" + pageState.created_from,
          apiType: "getTransporterSuggestions",
          apiConfig: apiConfig["getTransporterSuggestions"],
        };
        data.apiUrlTail += "&fyear=" + fYear_fetch + "&companyId=" + companyId;
        console.log("Get page data fff", data);
        performSuggestions(data);
      } else if (formName == "CROSSINGIN") {
        if (page_id == "") {
          makeFocusOnParticularField("transporter_name");
          return;
        }
        let data = {
          apiUrlTail: page_id + "?branch_id=" + pageState.created_from,
          apiType: "getCrossingIn",
          apiConfig: apiConfig["getCrossingIn"],
        };
        data.apiUrlTail += "&fyear=" + fYear_fetch + "&companyId=" + companyId;
        console.log("Get page data fff", data);
        performSuggestions(data);
      } else if (formName == "StationMaster") {
        let data = {
          apiUrlTail: page_id + "?branch_id=" + pageState.created_from,
          apiType: "getStationMaster",
          apiConfig: apiConfig["getStationMaster"],
        };
        console.log("Get page data fff", data);
        performSuggestions(data);
      } else if (formName == "ItemMaster") {
        let data = {
          apiUrlTail: page_id + "?branch_id=" + pageState.created_from,
          apiType: "getItemMaster",
          apiConfig: apiConfig["getItemMaster"],
        };
        console.log("Get page data fff", data);
        performSuggestions(data);
      } else if (formName == "PodChallan") {
        if ("pod_challan_no" in refStoreObject.current) {
          refStoreObject.current.pod_challan_no.blur();
        }
        if (page_id == "") {
          makeFocusOnParticularField("station_to_name");
          return;
        }
        setOverlay(true);
        let data = {
          apiUrlTail: page_id + "?branch_id=" + pageState.created_from,
          apiType: "getChallan",
          apiConfig: apiConfig["getChallan"],
        };
        data.apiUrlTail += "&fyear=" + fYear_fetch + "&companyId=" + companyId;
        console.log("Get page data fff", data);
        performSuggestions(data);
      } else if (formName == "CROSSINGOUT") {
        if (page_id == "") {
          makeFocusOnParticularField("transporter_name");
          return;
        }
        let data = {
          apiUrlTail: page_id + "?branch_id=" + pageState.created_from,
          apiType: "getCrossingOut",
          apiConfig: apiConfig["getCrossingOut"],
        };
        data.apiUrlTail += "&fyear=" + fYear_fetch + "&companyId=" + companyId;
        console.log("Get page data fff", data);
        performSuggestions(data);
      } else if (formName == "CONSIGNORBILLING") {
        if (page_id == "") {
          if (process.env.REACT_APP_CLIENT === "bgtc") {
            makeFocusOnParticularField("input_date_from");
          } else {
            makeFocusOnParticularField("amount");
          }
          return;
        }
        if ("bill_no" in refStoreObject.current) {
          refStoreObject.current.bill_no.blur();
        }
        setOverlay(true);
        let data = {
          apiUrlTail: page_id + "?branch_id=" + pageState.created_from,
          apiType: "getCrossingBill",
          apiConfig: apiConfig["getCrossingBill"],
        };
        data.apiUrlTail += "&fyear=" + fYear_fetch + "&companyId=" + companyId;
        console.log("Get page data fff", data);
        performSuggestions(data);
      } else if (formName == "MRBILLING") {
        if (page_id == "") {
          makeFocusOnParticularField("amount");
          return;
        }
        if ("bill_no" in refStoreObject.current) {
          refStoreObject.current.bill_no.blur();
        }
        setOverlay(true);
        let data = {
          apiUrlTail: page_id + "?branch_id=" + pageState.created_from,
          apiType: "getCrossingBill",
          apiConfig: apiConfig["getCrossingBill"],
        };
        data.apiUrlTail += "&fyear=" + fYear_fetch + "&companyId=" + companyId;
        console.log("Get page data fff", data);
        performSuggestions(data);
      } else if (formName == "TripBhada") {
        if (page_id == "") {
          makeFocusOnParticularField("vehicle_no");
          return;
        }
        let data = {
          // apiUrlTail: "payable/" + page_id + "?branch_id=" + pageState.created_from +"&station_from="+String(pageState.station_from),
          apiUrlTail:
            "payable/" +
            page_id +
            "?station_from=" +
            String(pageState.station_from),
          apiType: "getTrip",
          apiConfig: apiConfig["getTrip"],
        };
        data.apiUrlTail += "&fyear=" + fYear_fetch + "&companyId=" + companyId;
        console.log("Get page data fff", data);
        performSuggestions(data);
      } else if (formName == "CROSSINGBILLING") {
        if (page_id == "") {
          if (process.env.REACT_APP_CLIENT == "nrab" || process.env.REACT_APP_CLIENT == "syt" || process.env.REACT_APP_CLIENT == "sangam") {
            makeFocusOnParticularField("transporter_name");
          } else {
            makeFocusOnParticularField("date_to");
          }
          return;
        }
        if (pageState.type == "1") {
          let data = {
            apiUrlTail: page_id + "?branch_id=" + pageState.created_from,
            apiType: "getCrossingBill",
            apiConfig: apiConfig["getCrossingBill"],
          };
          console.log("Get page data fff", data);
          data.apiUrlTail +=
            "&fyear=" + fYear_fetch + "&companyId=" + companyId;
          performSuggestions(data);
        } else {
          let data = {
            apiUrlTail: page_id + "?branch_id=" + pageState.created_from,
            apiType: "getCrossingBill",
            apiConfig: apiConfig["getCrossingBillOut"],
          };
          console.log("Get page data fff", data);
          data.apiUrlTail +=
            "&fyear=" + fYear_fetch + "&companyId=" + companyId;
          performSuggestions(data);
        }
        // let data = {
        //   apiUrlTail: page_id + "?branch_id=" + pageState.created_from,
        //   apiType: "getCrossingBill",
        //   apiConfig: apiConfig["getCrossingBill"],
        // };
        // console.log("Get page data fff", data);
        // performSuggestions(data);
      } else if (formName == "PODSTATEMENT") {
        if (page_id == "") {
          makeFocusOnParticularField("consignor_name");
          return;
        }
        setOverlay(true);
        let data = {
          apiUrlTail: page_id + "?branch_id=" + pageState.created_from,
          apiType: "getPage",
          apiConfig: apiConfig["getPage"],
        };
        console.log("Get page data fff", data);
        data.apiUrlTail += "&fyear=" + fYear_fetch + "&companyId=" + companyId;
        performSuggestions(data);
      } else if (formName == "AccountTransaction") {
        if (page_id == "") {
          // if (pageState.voucher_type == "cr") {
          //   makeFocusOnParticularField("consignee_name");
          // }
          // else if (pageState.voucher_type == "br") {
          //   makeFocusOnParticularField("consignee_name");
          // }
          // else if (pageState.voucher_type == "bp") {
          //   makeFocusOnParticularField("consignor_name");
          // }
          // else {
          //   makeFocusOnParticularField("consignor_name");
          // }
          makeFocusOnParticularField("input_date");

          return;
        }
        let data = {
          // apiUrlTail:
          //   page_id +
          //   "?voucher_type=" +
          //   pageState.voucher_type +
          //   "&branch_id=" +
          //   pageState.created_from,
          apiType: "getPage",
          apiConfig: apiConfig["getPage"],
        };
        let tempUrl =
          page_id +
          "?voucher_type=" +
          pageState.voucher_type +
          "&branch_id=" +
          pageState.created_from;
        if (pageState.voucher_type == "jv") {
          tempUrl += `&account_id=${process.env.REACT_APP_ACCOUNT_ID}`;
        } else if (
          pageState.voucher_type == "cr" ||
          pageState.voucher_type == "br"
        ) {
          tempUrl += "&account_id=" + String(pageState.consignor_id);
        } else if (
          pageState.voucher_type == "cp" ||
          pageState.voucher_type == "bp"
        ) {
          tempUrl += "&account_id=" + String(pageState.consignee_id);
        }
        data.apiUrlTail = tempUrl;
        data.apiUrlTail += "&fyear=" + fYear_fetch + "&companyId=" + companyId;
        console.log("Get page data fff", data);
        performSuggestions(data);
      } else if (formName == "Marfatiya") {
        if (page_id == "") {
          makeFocusOnParticularField("bilty_no");
          return;
        }
        let data = {
          apiUrlTail: "get_marfatiya_by_mf_no?mf_no=" + page_id + 
            " &created_from=" + pageState.created_from ,
          apiType: "getMarfatiya",
          apiConfig: apiConfig["getMarfatiya"],
        };
        data.apiUrlTail += "&fyear=" + fYear_fetch + "&companyId=" + companyId;
        console.log("Get page data fff", data);
        performSuggestions(data);
      }
    }
  };

  const executeServerPrint = async (submitApiStateData) => {

    const roleId = Number(sessionObject.sessionVariables.role_id);

    let apiInputData = submitApiStateData.apiInputData;
    if (
      process.env.REACT_APP_CLIENT === "guru" &&
      formName === "CONSIGNORBILLING" &&
      Array.isArray(apiInputData.bilty_ids)
    ) {
      apiInputData.bilty_ids = apiInputData.bilty_ids.filter(
        (b) => b.checked === "1"
      );
    }

    let extraDataObject = {};
    let url = "";
    if (submitApiStateData.apiConfig.paramSchema) {
      apiInputData = applySchema(
        apiInputData,
        submitApiStateData.apiConfig.paramSchema
      );
    }
    if (formName == "Bilty") {

      url = NEW_PRINT + "/bilty/print/";

      const str = submitApiState.data.apiInputData.consignor_name;
      const division = str.match(/.{1,35}/g) ?? [];
      let consignor_name1 = division[0];
      let consignor_name2 = division[1] ?? "";
      let consignor_name3 = division[2] ?? "";
      extraDataObject.consignor_name1 = consignor_name1;
      extraDataObject.consignor_name2 = consignor_name2;
      extraDataObject.consignor_name3 = consignor_name3;

      const str2 = submitApiState.data.apiInputData.consignee_name;
      const division2 = str2.match(/.{1,35}/g) ?? [];
      let consignee_name1 = division2[0];
      let consignee_name2 = division2[1] ?? "";
      let consignee_name3 = division2[2] ?? "";
      extraDataObject.consignee_name1 = consignee_name1;
      extraDataObject.consignee_name2 = consignee_name2;
      extraDataObject.consignee_name3 = consignee_name3;

      let tempPayTypeObject = {
        1: "TO PAY",
        2: "PAID",
        3: "FOC",
        4: "TO BE BILLED",
      };
      
      if (process.env.REACT_APP_CLIENT === "bgtc") {
        tempPayTypeObject[4] = "TBB";
      }

      let tempDestTypeObject = {
        1: "DOOR",
        2: "GODOWN",
        3: "PRIORITY",
      };

      if (process.env.REACT_APP_CLIENT === "bgtc") {
        tempDestTypeObject = {
          1: "DOOR DELIVERY",
          2: "GODOWN TRANSPORT",
        };
      }

      if (process.env.REACT_APP_CLIENT === "arbuda") {
        tempDestTypeObject = {
          1: "DOOR",
          2: "GDW",
          3: "PRIORITY",
        };
      }

      for (
        let i = 0;
        i < submitApiState.data.apiInputData.item_in.length;
        i++
      ) {
        const itemNameKey = `item_name_${i}`;
        const packingTypeKey = `packing_type_${i}`;
        const rateKey = `rate_${i}`;
        const amountKey = `amount_${i}`;
        const pkgsKey = `pkgs_${i}`;
        const actualWeightKey = `actual_weight_${i}`;
        extraDataObject[itemNameKey] =
          submitApiState.data.apiInputData.item_in[i].item_name;
        extraDataObject[pkgsKey] =
          submitApiState.data.apiInputData.item_in[i].pkgs;
        extraDataObject[packingTypeKey] =
          itemNamesDict[
            String(submitApiState.data.apiInputData.item_in[i].packing_type)
          ];
        extraDataObject[rateKey] =
          submitApiState.data.apiInputData.item_in[i].rate;
        extraDataObject[amountKey] =
          submitApiState.data.apiInputData.item_in[i].amount;
        extraDataObject[actualWeightKey] =
          submitApiState.data.apiInputData.item_in[i].weight;
      }
      extraDataObject.packing_type =
        itemNamesDict[
          String(submitApiState.data.apiInputData.item_in[0].packing_type)
        ];
      extraDataObject.item_name =
        submitApiState.data.apiInputData.item_in[0].item_name;
      extraDataObject.amount =
        submitApiState.data.apiInputData.item_in[0].amount;
      extraDataObject.rate = submitApiState.data.apiInputData.item_in[0].rate;
      submitApiState.data.apiInputData.pay_type == 1
        ? (extraDataObject.to_pay_type =
            submitApiState.data.apiInputData.freight)
        : (extraDataObject.other_type =
            submitApiState.data.apiInputData.freight);
      extraDataObject.truck_size =
        submitApiState.data.apiInputData.item_in[0].truck_size;
      extraDataObject.new_freight =
        submitApiState.data.apiInputData.new_freight;
      // extraDataObject.package_in_words = converter.toWords(isFinite(parseInt(submitApiState.data.apiInputData.no_of_package))?submitApiState.data.apiInputData.no_of_package:0).toUpperCase()
      // extraDataObject.round_off = submitApiState.data.apiInputData.round_off
      extraDataObject.client_name =
        process.env.REACT_APP_CLIENT_NAME_FOR_BILTY_PRINT;
      if (pageState.extra_print) {
        extraDataObject.file_name = "consignorbilty";
      } else {
        extraDataObject.file_name = "bilty";
      }
      extraDataObject.bilty_no = submitApiState.data.response.bilty_no;
      extraDataObject.id = submitApiState.data.apiInputData.bilty_id;
      extraDataObject.created_by_name = pageState.created_by_name;
      extraDataObject.created_by = pageState.created_by_name;
      if (
        process.env.REACT_APP_CLIENT == "gdala_log" ||
        process.env.REACT_APP_CLIENT == "shubham" ||
        process.env.REACT_APP_CLIENT == "nrab" ||
        process.env.REACT_APP_CLIENT == "syt" ||
        process.env.REACT_APP_CLIENT == "sangam" ||
        process.env.REACT_APP_CLIENT == "xpress" ||
        process.env.REACT_APP_CLIENT == "sra" ||
        process.env.REACT_APP_CLIENT == "vihira" ||
        process.env.REACT_APP_CLIENT == "g_trans"
      ) {
        const inputDate = new Date(pageState.input_date);
        const day = String(inputDate.getDate()).padStart(2, "0");
        const month = String(inputDate.getMonth() + 1).padStart(2, "0");
        const year = inputDate.getFullYear();
        const formattedDate = `${day}-${month}-${year}`;
        extraDataObject.bilty_date = formattedDate;
      } else if (process.env.REACT_APP_CLIENT == "ravechi") {
        const inputDate = new Date(pageState.input_date);
        const day = String(inputDate.getDate()).padStart(2, "0");
        const month = String(inputDate.getMonth() + 1).padStart(2, "0");
        const year = inputDate.getFullYear();

        // Format time in 12-hour format with AM/PM
        let hours = inputDate.getHours();
        const minutes = String(inputDate.getMinutes()).padStart(2, "0");
        const ampm = hours >= 12 ? "PM" : "AM";
        hours = hours % 12;
        hours = hours ? hours : 12; // the hour '0' should be '12'
        const formattedHours = String(hours).padStart(2, "0");

        const formattedDateTime = `${day}-${month}-${year} ${formattedHours}:${minutes} ${ampm}`;
        extraDataObject.bilty_date = formattedDateTime;
      }

      if (process.env.REACT_APP_CLIENT == "guru") {
        const str = submitApiState.data.apiInputData.consignor_name;
        const division = str.match(/.{1,30}/g) ?? [];
        let consignor_name1 = division[0];
        let consignor_name2 = division[1] ?? "";
        let consignor_name3 = division[2] ?? "";
        extraDataObject.consignor_name1 = consignor_name1;
        extraDataObject.consignor_name2 = consignor_name2;
        extraDataObject.consignor_name3 = consignor_name3;

        const str2 = submitApiState.data.apiInputData.consignee_name;
        const division2 = str2.match(/.{1,30}/g) ?? [];
        let consignee_name1 = division2[0];
        let consignee_name2 = division2[1] ?? "";
        let consignee_name3 = division2[2] ?? "";
        extraDataObject.consignee_name1 = consignee_name1;
        extraDataObject.consignee_name2 = consignee_name2;
        extraDataObject.consignee_name3 = consignee_name3;

        extraDataObject.bilty_date = formatDateToDDMMYYYY(
          apiInputData.bilty_date
        );
        extraDataObject.delivery_dest_type =
          tempDestTypeObject[
            String(submitApiStateData.apiInputData.delivery_dest_type)
          ];

        for (
          let i = 0;
          i < submitApiState.data.apiInputData.eway_bill_no.length;
          i++
        ) {
          const ewayBillNoKey = `eway_bill_no_${i}`;
          extraDataObject[ewayBillNoKey] =
            submitApiState.data.apiInputData.eway_bill_no[i].eway_bill_no;
        }

        // const discountMap = {
        //     "0": 0,
        //     "1": 0.25,
        //     "2": 0.50,
        // };

        // const discountLabels = {
        //     "0": "0%",
        //     "1": "25%",
        //     "2": "50%",
        // };

        // const discountPercent = discountMap[apiInputData.discount] || 0;
        // const discountLabel = discountLabels[apiInputData.discount] || "0%";

        // const totalAmount =
        // (Number(apiInputData.freight) || 0) +
        // (Number(apiInputData.lc_charge) || 0) +
        // (Number(apiInputData.door_del_charge) || 0) +
        // (Number(apiInputData.other_amount) || 0) +
        // (Number(apiInputData.bilty_charge) || 0) +
        // (Number(apiInputData.hamali) || 0);
        // (Number(apiInputData.transporter_freight) || 0);

        // const discountAmount = totalAmount * discountPercent;
        // extraDataObject.discounted_price = `${discountAmount} (${discountLabel})`;



        if (submitApiState.data.apiInputData.pay_type == 1) {
          extraDataObject.to_pay_type_freight =
            submitApiState.data.apiInputData.freight;
          extraDataObject.to_pay_bilty_charge =
            submitApiState.data.apiInputData.bilty_charge;
          extraDataObject.to_pay_hamali =
            submitApiState.data.apiInputData.hamali;
          extraDataObject.to_pay_other_amount =
            submitApiState.data.apiInputData.other_amount;
          extraDataObject.to_pay_door_del_charge =
            submitApiState.data.apiInputData.door_del_charge;
          extraDataObject.to_pay_total_amount =
            submitApiState.data.apiInputData.total_amount;
          extraDataObject.to_pay_pf = submitApiState.data.apiInputData.pf;
          extraDataObject.to_pay_lc_charge =
            submitApiState.data.apiInputData.lc_charge;
        } else if (
          submitApiState.data.apiInputData.pay_type == 2 ||
          submitApiState.data.apiInputData.pay_type == 3 ||
          submitApiState.data.apiInputData.pay_type == 4
        ) {
          extraDataObject.other_type_bilty_charge =
            submitApiState.data.apiInputData.bilty_charge;
          extraDataObject.other_type_door_del_charge =
            submitApiState.data.apiInputData.door_del_charge;
          extraDataObject.other_type_freight =
            submitApiState.data.apiInputData.freight;
          extraDataObject.other_type_hamali =
            submitApiState.data.apiInputData.hamali;
          extraDataObject.other_type_other_amount =
            submitApiState.data.apiInputData.other_amount;
          extraDataObject.other_type_pf = submitApiState.data.apiInputData.pf;
          extraDataObject.other_type_total_amount =
            submitApiState.data.apiInputData.total_amount;
          extraDataObject.other_type_lc_charge =
            submitApiState.data.apiInputData.lc_charge;
        }
      }

      if (process.env.REACT_APP_CLIENT == "avr" || process.env.REACT_APP_CLIENT == "jtsa" || process.env.REACT_APP_CLIENT == "std" || process.env.REACT_APP_CLIENT ===  "arbuda" || process.env.REACT_APP_CLIENT == "bbac")  {
        if (parseInt(submitApiState.data.apiInputData.pay_type) == 4) {
          extraDataObject.bilty_charge = "";
          extraDataObject.door_del_charge = "";
          extraDataObject.freight = "";
          extraDataObject.hamali = "";
          extraDataObject.lc_charge = "";
          extraDataObject.other_amount = "";
          extraDataObject.total_amount = "";
        }
        for (
          let i = 0;
          i < submitApiState.data.apiInputData.item_in.length;
          i++
        ) {
          const itemNameKey = `item_name_${i}`;
          const packingTypeKey = `packing_type_${i}`;
          const pkgsKey = `pkgs_${i}`;
          extraDataObject[itemNameKey] =
            submitApiState.data.apiInputData.item_in[i].item_name;
          extraDataObject[pkgsKey] =
            submitApiState.data.apiInputData.item_in[i].pkgs;
          extraDataObject[packingTypeKey] =
            itemNamesDict[
              String(submitApiState.data.apiInputData.item_in[i].packing_type)
            ];
        }
        extraDataObject.delivery_dest_type =
          tempDestTypeObject[
            String(submitApiStateData.apiInputData.delivery_dest_type)
          ];
        extraDataObject.pay_type =
          tempPayTypeObject[String(submitApiStateData.apiInputData.pay_type)];
        let ewayBillNoCount = 0;
        for (
          let i = 0;
          i < submitApiState.data.apiInputData.eway_bill_no.length;
          i++
        ) {
          if (
            submitApiState.data.apiInputData.eway_bill_no[i].eway_bill_no !== ""
          ) {
            ewayBillNoCount++;
          }
        }
        extraDataObject.eway_bill_no_count = ewayBillNoCount;

        for (
          let i = 0;
          i < submitApiState.data.apiInputData.eway_bill_no.length;
          i++
        ) {
          const ewayBillNoKey = `eway_bill_no_${i}`;
          extraDataObject[ewayBillNoKey] =
            submitApiState.data.apiInputData.eway_bill_no[i].eway_bill_no;
        }
        const value = submitApiState.data.apiInputData.goods_invoice_value;

        if (value !== undefined && value !== null) {

          const markaArray = String(value)
            .split(",")
            .map(v => v.trim())
            .filter(Boolean);

          markaArray.forEach((val, index) => {
            extraDataObject[`goods_invoice_value_${index}`] = val;
          });

        }

        const inputDate = new Date(pageState.input_date);
        const day = String(inputDate.getDate()).padStart(2, "0");
        const month = String(inputDate.getMonth() + 1).padStart(2, "0");
        const year = inputDate.getFullYear();
        const hours = String(inputDate.getHours()).padStart(2, "0");
        const minutes = String(inputDate.getMinutes()).padStart(2, "0");
        const formattedDate = `${day}-${month}-${year} ${hours}:${minutes}`;
        if (process.env.REACT_APP_CLIENT === "arbuda") {
          extraDataObject.bilty_date = `${day}-${month}-${year}`;
        } else {
          const formattedDate = `${day}-${month}-${year} ${hours}:${minutes}`;
          extraDataObject.bilty_date = formattedDate;
        }

        if (
          process.env.REACT_APP_CLIENT === "bgtc" &&
          extraDataObject.bilty_date &&
          extraDataObject.bilty_date.includes(" ")
        ) {
          const [datePart, timePart] = extraDataObject.bilty_date.split(" ");
          extraDataObject.bilty_date = datePart;
          extraDataObject.bilty_time = timePart;
        }
      }

      if (process.env.REACT_APP_CLIENT == "bgtc")  {
        url = NEW_PRINT + "/bilty/print/";

        const apiData = submitApiState.data.apiInputData;
        const payType = parseInt(apiData.pay_type);
        const freightAmount = Number(apiData?.freight);

        for (
          let i = 0;
          i < submitApiState.data.apiInputData.item_in.length;
          i++
        ) {
          const baseAmountKey = `amount_${i}`;
          const amountValue = extraDataObject[baseAmountKey];

          const itemNameKey = `item_name_${i}`;
          const packingTypeKey = `packing_type_${i}`;
          const pkgsKey = `pkgs_${i}`;

          extraDataObject[itemNameKey] =
            submitApiState.data.apiInputData.item_in[i].item_name;
          extraDataObject[pkgsKey] =
            submitApiState.data.apiInputData.item_in[i].pkgs;
          extraDataObject[packingTypeKey] =
            itemNamesDict[
              String(submitApiState.data.apiInputData.item_in[i].packing_type)
            ];

          if (payType === 1) {
            extraDataObject[`to_pay_amount_${i}`] = amountValue;
          } else if (payType === 2) {
            extraDataObject[`paid_amount_${i}`] = amountValue;
          } else if (payType === 4) {
            extraDataObject[`tbb_amount_${i}`] = amountValue;
          }
        }

        extraDataObject.delivery_dest_type =
          tempDestTypeObject[
            String(submitApiStateData.apiInputData.delivery_dest_type)
          ];
        extraDataObject.pay_type =
          tempPayTypeObject[String(submitApiStateData.apiInputData.pay_type)];
        let ewayBillNoCount = 0;
        for (
          let i = 0;
          i < submitApiState.data.apiInputData.eway_bill_no.length;
          i++
        ) {
          if (
            submitApiState.data.apiInputData.eway_bill_no[i].eway_bill_no !== ""
          ) {
            ewayBillNoCount++;
          }
        }
        extraDataObject.eway_bill_no_count = ewayBillNoCount;
        const inputDate = new Date(pageState.input_date);
        const day = String(inputDate.getDate()).padStart(2, "0");
        const month = String(inputDate.getMonth() + 1).padStart(2, "0");
        const year = inputDate.getFullYear();
        const hours = String(inputDate.getHours()).padStart(2, "0");
        const minutes = String(inputDate.getMinutes()).padStart(2, "0");
        const formattedDate = `${day}-${month}-${year} ${hours}:${minutes}`;
        extraDataObject.bilty_date = formattedDate;

        if (extraDataObject.bilty_date && extraDataObject.bilty_date.includes(" ")) {
          const [datePart, timePart] = extraDataObject.bilty_date.split(" ");
          extraDataObject.bilty_date = datePart;
          extraDataObject.bilty_time = timePart;
        }

        const flooredTotalAmount = Math.floor(
          Number(apiData.total_amount || 0)
        );

        if (payType === 1) {
          extraDataObject.to_pay_freight = freightAmount;
        } else if (payType === 2) {
          extraDataObject.paid_freight = freightAmount;
        } else if (payType === 4) {
          extraDataObject.tbb_freight = freightAmount;
        }

        if (payType === 1) {
          extraDataObject.to_pay_bilty_charge = apiData.bilty_charge;
          extraDataObject.to_pay_hamali = apiData.hamali;
          extraDataObject.to_pay_door_del_charge = apiData.door_del_charge;
          extraDataObject.to_pay_lc_charge = apiData.lc_charge;
          extraDataObject.to_pay_other_amount = apiData.other_amount;
          extraDataObject.to_pay_total_amount = flooredTotalAmount;
        }

        if (payType === 2) {
          extraDataObject.paid_bilty_charge = apiData.bilty_charge;
          extraDataObject.paid_hamali = apiData.hamali;
          extraDataObject.paid_door_del_charge = apiData.door_del_charge;
          extraDataObject.paid_lc_charge = apiData.lc_charge;
          extraDataObject.paid_other_amount = apiData.other_amount;
          extraDataObject.paid_total_amount = flooredTotalAmount;
        }

        if (payType === 4) {
          extraDataObject.tbb_bilty_charge = apiData.bilty_charge;
          extraDataObject.tbb_hamali = apiData.hamali;
          extraDataObject.tbb_door_del_charge = apiData.door_del_charge;
          extraDataObject.tbb_lc_charge = apiData.lc_charge;
          extraDataObject.tbb_other_amount = apiData.other_amount;
          extraDataObject.tbb_total_amount = flooredTotalAmount;
        }

        if (
          submitApiState.data.apiInputData.private_marka_no &&
          typeof submitApiState.data.apiInputData.private_marka_no === "string"
        ) {
          const markaArray =
            submitApiState.data.apiInputData.private_marka_no
              .split(",")
              .map(v => v.trim())
              .filter(Boolean);

          markaArray.forEach((value, index) => {
            extraDataObject[`private_marka_no_${index}`] = value;
          });
        }
      }

      if (process.env.REACT_APP_CLIENT == "bbac")  {
        const apiData = submitApiState.data.apiInputData;
        const payType = parseInt(apiData.pay_type);
        const freightAmount = Number(apiData?.freight);

        const flooredTotalAmount = Math.floor(
          Number(apiData.total_amount || 0)
        );

        if (payType === 1) {
          extraDataObject.to_pay_freight = freightAmount;
        } else if (payType === 2) {
          extraDataObject.paid_freight = freightAmount;
        } else if (payType === 4) {
          extraDataObject.tbb_freight = freightAmount;
        }

        if (payType === 1) {
          extraDataObject.to_pay_bilty_charge = apiData.bilty_charge;
          extraDataObject.to_pay_hamali = apiData.hamali;
          extraDataObject.to_pay_door_del_charge = apiData.door_del_charge;
          extraDataObject.to_pay_lc_charge = apiData.lc_charge;
          extraDataObject.to_pay_other_amount = apiData.other_amount;
          extraDataObject.to_pay_crossing_charge = apiData.crossing_charge;
          extraDataObject.to_pay_total_amount = flooredTotalAmount;
        }

        if (payType === 2) {
          extraDataObject.paid_bilty_charge = apiData.bilty_charge;
          extraDataObject.paid_hamali = apiData.hamali;
          extraDataObject.paid_door_del_charge = apiData.door_del_charge;
          extraDataObject.paid_lc_charge = apiData.lc_charge;
          extraDataObject.paid_other_amount = apiData.other_amount;
          extraDataObject.paid_crossing_charge = apiData.crossing_charge;
          extraDataObject.paid_total_amount = flooredTotalAmount;
        }

        if (payType === 4) {
          extraDataObject.tbb_bilty_charge = apiData.bilty_charge;
          extraDataObject.tbb_hamali = apiData.hamali;
          extraDataObject.tbb_door_del_charge = apiData.door_del_charge;
          extraDataObject.tbb_lc_charge = apiData.lc_charge;
          extraDataObject.tbb_other_amount = apiData.other_amount;
          extraDataObject.tbb_crossing_charge = apiData.crossing_charge;
          extraDataObject.tbb_total_amount = flooredTotalAmount;
        }
      }

      if ( process.env.REACT_APP_CLIENT == "jncargo") {
        if (parseInt(submitApiState.data.apiInputData.pay_type) == 4) {
          extraDataObject.bilty_charge = "";
          extraDataObject.door_del_charge = "";
          extraDataObject.freight = "";
          extraDataObject.hamali = "";
          extraDataObject.lc_charge = "";
          extraDataObject.other_amount = "";
          extraDataObject.total_amount = "";
        }
        for (
          let i = 0;
          i < submitApiState.data.apiInputData.item_in.length;
          i++
        ) {
          const itemNameKey = `item_name_${i}`;
          const packingTypeKey = `packing_type_${i}`;
          const pkgsKey = `pkgs_${i}`;
          extraDataObject[itemNameKey] =
            submitApiState.data.apiInputData.item_in[i].item_name;
          extraDataObject[pkgsKey] =
            submitApiState.data.apiInputData.item_in[i].pkgs;
          extraDataObject[packingTypeKey] =
            itemNamesDict[
              String(submitApiState.data.apiInputData.item_in[i].packing_type)
            ];
        }
        extraDataObject.delivery_dest_type =
          tempDestTypeObject[
            String(submitApiStateData.apiInputData.delivery_dest_type)
          ];
        extraDataObject.pay_type =
          tempPayTypeObject[String(submitApiStateData.apiInputData.pay_type)];
        let ewayBillNoCount = 0;
        for (
          let i = 0;
          i < submitApiState.data.apiInputData.eway_bill_no.length;
          i++
        ) {
          if (
            submitApiState.data.apiInputData.eway_bill_no[i].eway_bill_no !== ""
          ) {
            ewayBillNoCount++;
          }
        }
        extraDataObject.consignee_mobile = submitApiState.data.apiInputData.consignee_mobile || pageState.consignee_mobile;
        extraDataObject.consignor_mobile = submitApiState.data.apiInputData.consignor_mobile || pageState.consignor_mobile;
        extraDataObject.consignee_address = submitApiState.data.apiInputData.consignee_address || pageState.consignee_address;
        extraDataObject.consignor_address = submitApiState.data.apiInputData.consignor_address || pageState.consignor_address;
        extraDataObject.eway_bill_no_count = ewayBillNoCount;
        const inputDate = new Date(pageState.input_date);
        const day = String(inputDate.getDate()).padStart(2, "0");
        const month = String(inputDate.getMonth() + 1).padStart(2, "0");
        const year = inputDate.getFullYear();
        const hours = String(inputDate.getHours()).padStart(2, "0");
        const minutes = String(inputDate.getMinutes()).padStart(2, "0");
        const formattedDate = `${day}-${month}-${year} ${hours}:${minutes}`;
        extraDataObject.bilty_date = formattedDate;
      }

      if (process.env.REACT_APP_CLIENT == "gdala_log") {
        extraDataObject.delivery_dest_type =
          tempDestTypeObject[
            String(submitApiStateData.apiInputData.delivery_dest_type)
          ];
        extraDataObject.pay_type =
          tempPayTypeObject[String(submitApiStateData.apiInputData.pay_type)];
      }
      if (process.env.REACT_APP_CLIENT == "vihira") {
        const private_marka_no =
          submitApiState.data.apiInputData.private_marka_no;
        const markaArray = private_marka_no.split(",");
        markaArray.forEach((value, index) => {
          extraDataObject[`private_marka_no_${index + 1}`] = value;
        });
        for (
          let i = 0;
          i < submitApiState.data.apiInputData.eway_bill_no.length;
          i++
        ) {
          const ewayBillNoKey = `eway_bill_no_${i}`;
          extraDataObject[ewayBillNoKey] =
            submitApiState.data.apiInputData.eway_bill_no[i].eway_bill_no;
        }
        extraDataObject.pay_type =
          tempPayTypeObject[String(submitApiStateData.apiInputData.pay_type)];
        extraDataObject.delivery_dest_type =
          tempDestTypeObject[
            String(submitApiStateData.apiInputData.delivery_dest_type)
          ];
      }
      if (process.env.REACT_APP_CLIENT == "shubham") {
        extraDataObject.pay_type =
          tempPayTypeObject[String(submitApiStateData.apiInputData.pay_type)];
        extraDataObject.delivery_dest_type =
          tempDestTypeObject[
            String(submitApiStateData.apiInputData.delivery_dest_type)
          ];
      }
      if (process.env.REACT_APP_CLIENT == "nrab" || process.env.REACT_APP_CLIENT == "syt" || process.env.REACT_APP_CLIENT == "sangam") {
        if (
          parseInt(submitApiState.data.apiInputData.pay_type) == 2 ||
          parseInt(submitApiState.data.apiInputData.pay_type) == 4
        ) {
          extraDataObject.freight = "";
          extraDataObject.bilty_charge = "";
          extraDataObject.hamali = "";
          extraDataObject.door_del_charge = "";
          extraDataObject.lc_charge = "";
          extraDataObject.other_amount = "";
          extraDataObject.rate = "";
          extraDataObject.total_amount = "";
        }
        extraDataObject.pay_type =
          tempPayTypeObject[String(submitApiStateData.apiInputData.pay_type)];
        extraDataObject.delivery_dest_type =
          tempDestTypeObject[
            String(submitApiStateData.apiInputData.delivery_dest_type)
          ];
      }
      if (process.env.REACT_APP_CLIENT == "ravechi") {
        extraDataObject.pay_type =
          tempPayTypeObject[String(submitApiStateData.apiInputData.pay_type)];
        extraDataObject.delivery_dest_type =
          tempDestTypeObject[
            String(submitApiStateData.apiInputData.delivery_dest_type)
          ];
        if (parseInt(submitApiState.data.apiInputData.pay_type) == 4) {
          extraDataObject.freight = "";
          extraDataObject.freight = "";
          extraDataObject.detention = "";
          extraDataObject.loading_charge = "";
          extraDataObject.unloading_charge = "";
          extraDataObject.hamali = "";
          extraDataObject.rto = "";
          extraDataObject.advance = "";
          extraDataObject.total_amount = "";
          extraDataObject.rate = "";
          extraDataObject.bilty_charge = "";
        }
        for (
          let i = 0;
          i < submitApiState.data.apiInputData.item_in.length;
          i++
        ) {
          const itemNameKey = `item_name_${i}`;
          const packingTypeKey = `packing_type_${i}`;
          const pkgsKey = `pkgs_${i}`;
          extraDataObject[itemNameKey] =
            submitApiState.data.apiInputData.item_in[i].item_name;
          extraDataObject[pkgsKey] =
            submitApiState.data.apiInputData.item_in[i].pkgs;
          extraDataObject[packingTypeKey] =
            itemNamesDict[
              String(submitApiState.data.apiInputData.item_in[i].packing_type)
            ];
        }
      }
      if (process.env.REACT_APP_CLIENT == "sra") {
        extraDataObject.booking_lr_date = formatDateToDDMMYYYY(
          apiInputData.booking_lr_date
        );
      }
      if (process.env.REACT_APP_CLIENT == "xpress") {
        extraDataObject.pay_type =
          tempPayTypeObject[String(submitApiStateData.apiInputData.pay_type)];
        extraDataObject.delivery_dest_type =
          tempDestTypeObject[
            String(submitApiStateData.apiInputData.delivery_dest_type)
          ];
        extraDataObject.weight =
          submitApiState.data.apiInputData.item_in[0].weight;
        if (parseInt(submitApiState.data.apiInputData.pay_type) == 4) {
          extraDataObject.freight = "";
          extraDataObject.detention = "";
          extraDataObject.loading_charge = "";
          extraDataObject.unloading_charge = "";
          extraDataObject.hamali = "";
          extraDataObject.rto = "";
          extraDataObject.advance = "";
          extraDataObject.total_amount = "";
          extraDataObject.rate = "";
        }
        if (submitApiState.data.apiInputData.no_of_consignors == 1) {
          const str = submitApiState.data.apiInputData.consignor_address;
          const division = str.match(/.{1,54}/g) ?? [];
          let consignor_address1 = division[0];
          let consignor_address2 = division[1] ?? "";
          let consignor_address3 = division[2] ?? "";
          let consignor_address4 = division[3] ?? "";
          extraDataObject.address_consignor1 = consignor_address1;
          extraDataObject.address_consignor2 = consignor_address2;
          extraDataObject.address_consignor3 = consignor_address3;
          extraDataObject.address_consignor4 = consignor_address4;
        } else if (submitApiState.data.apiInputData.no_of_consignors == 2) {
          const str = submitApiState.data.apiInputData.second_consignor_address;
          const division = str.match(/.{1,54}/g) ?? [];
          let consignor_address1 = division[0];
          let consignor_address2 = division[1] ?? "";
          let consignor_address3 = division[2] ?? "";
          let consignor_address4 = division[3] ?? "";
          extraDataObject.address_consignor1 = consignor_address1;
          extraDataObject.address_consignor2 = consignor_address2;
          extraDataObject.address_consignor3 = consignor_address3;
          extraDataObject.address_consignor4 = consignor_address4;
        } else if (submitApiState.data.apiInputData.no_of_consignors == 3) {
          const str = submitApiState.data.apiInputData.third_consignor_address;
          const division = str.match(/.{1,54}/g) ?? [];
          let consignor_address1 = division[0];
          let consignor_address2 = division[1] ?? "";
          let consignor_address3 = division[2] ?? "";
          let consignor_address4 = division[3] ?? "";
          extraDataObject.address_consignor1 = consignor_address1;
          extraDataObject.address_consignor2 = consignor_address2;
          extraDataObject.address_consignor3 = consignor_address3;
          extraDataObject.address_consignor4 = consignor_address4;
        }

        if (submitApiState.data.apiInputData.no_of_consignees == 1) {
          const str = submitApiState.data.apiInputData.consignee_address;
          const division = str.match(/.{1,54}/g) ?? [];
          let consignee_address1 = division[0];
          let consignee_address2 = division[1] ?? "";
          let consignee_address3 = division[2] ?? "";
          let consignee_address4 = division[3] ?? "";
          extraDataObject.address_consignee1 = consignee_address1;
          extraDataObject.address_consignee2 = consignee_address2;
          extraDataObject.address_consignee3 = consignee_address3;
          extraDataObject.address_consignee4 = consignee_address4;
        } else if (submitApiState.data.apiInputData.no_of_consignees == 2) {
          const str = submitApiState.data.apiInputData.second_consignee_address;
          const division = str.match(/.{1,54}/g) ?? [];
          let consignee_address1 = division[0];
          let consignee_address2 = division[1] ?? "";
          let consignee_address3 = division[2] ?? "";
          let consignee_address4 = division[3] ?? "";
          extraDataObject.address_consignee1 = consignee_address1;
          extraDataObject.address_consignee2 = consignee_address2;
          extraDataObject.address_consignee3 = consignee_address3;
          extraDataObject.address_consignee4 = consignee_address4;
        } else if (submitApiState.data.apiInputData.no_of_consignees == 3) {
          const str = submitApiState.data.apiInputData.third_consignee_address;
          const division = str.match(/.{1,54}/g) ?? [];
          let consignee_address1 = division[0];
          let consignee_address2 = division[1] ?? "";
          let consignee_address3 = division[2] ?? "";
          let consignee_address4 = division[3] ?? "";
          extraDataObject.address_consignee1 = consignee_address1;
          extraDataObject.address_consignee2 = consignee_address2;
          extraDataObject.address_consignee3 = consignee_address3;
          extraDataObject.address_consignee4 = consignee_address4;
        }
      }
    } else if (formName == "Challan") {
      if (process.env.REACT_APP_CLIENT == "gdala_cargo") {
        url = SERVER_URL + "/challan/print_with_tables/";
      } else if (process.env.REACT_APP_CLIENT === "xpress") {
        const no_challan = parseInt(pageState.challan_no);
        const url1 =
          SERVER_URL +
          `/bilty/get_account_details/?module=chalan&bilty_no=${no_challan}&fyear=${pageState.fYear}`;
        try {
          const response = await fetch(url1, {
            method: "GET",
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
            },
          });
          const responseData = await response.json();
          const account_details = responseData;
          apiInputData = { ...apiInputData, account_details };
        } catch (error) {
          console.error("Error fetching print data:", error);
        }

        url = NEW_PRINT + "/bilty/print_table/";
        extraDataObject.client_name =
          process.env.REACT_APP_CLIENT_NAME_FOR_BILTY_PRINT;
        extraDataObject.file_name = "trip_vocher";
        extraDataObject.booking_chalan_date = formatDateToDDMMYYYY(
          apiInputData.booking_chalan_date
        );

        extraDataObject.data = [];
        for (let i = 0; i < apiInputData.account_details.length; i++) {
          if (i % 2 === 0) {
            extraDataObject.data.push({
              charge: apiInputData.account_details[i].data.charge,
              amount: apiInputData.account_details[i + 1].data.credit,
              modified_date: formatDateToDDMMYYYY(
                apiInputData.account_details[i].data.modified_date
              ),
              voucher_id: apiInputData.account_details[i].data.voucher_id,
              credit_party_name:
                apiInputData.account_details[i].source_party_data.name,
            });
          }
        }
      } else if (process.env.REACT_APP_CLIENT === "guru") {
        url = `${NEW_PRINT}/bilty/print_table/`;
        extraDataObject.file_name = "bookingchallan";
        extraDataObject.client_name =
          process.env.REACT_APP_CLIENT_NAME_FOR_BILTY_PRINT;
        extraDataObject.booking_chalan_date = formatDateToDDMMYYYY(
          apiInputData.booking_chalan_date
        );

        let totals = {
          total_to_pay: 0,
          total_pkgs:0,
          total_weight:0,
          total_paid: 0,
          total_tbb: 0,
          total_pf: 0,
        };

        apiInputData.bilty_nos.forEach((bilty) => {
          if (bilty.pay_type === 1) totals.total_to_pay += bilty.total_amount;
          else if (bilty.pay_type === 2)
            totals.total_paid += bilty.total_amount;
          else if (bilty.pay_type === 4) totals.total_tbb += bilty.total_amount;
          totals.total_pf += bilty.pf;
          totals.total_pkgs += bilty.bilty_pkgs || 0
          totals.total_weight += bilty.bilty_weight || 0
        });
        Object.assign(extraDataObject, totals);

        extraDataObject.data = apiInputData.bilty_nos.map((bilty) => {
          let newInfo = { ...bilty };
          newInfo.print_to_pay =
            newInfo.pay_type === 1 ? Number(newInfo.total_amount) : 0;
          newInfo.print_paid =
            newInfo.pay_type === 2 ? Number(newInfo.total_amount) : 0;
          newInfo.print_foc =
            newInfo.pay_type === 3 ? Number(newInfo.total_amount) : 0;
          newInfo.print_tbb =
            newInfo.pay_type === 4 ? Number(newInfo.total_amount) : 0;
          newInfo.item_name = newInfo.item_info[0].item_name;
          newInfo.print_pkgs = newInfo.total_pkgs;
          newInfo.bilty_date = formatDateToDDMMYYYY(newInfo.bilty_date);
          newInfo.pf = newInfo.pf ?? 0;
          return newInfo;
        });
      } else if (process.env.REACT_APP_CLIENT === "gdala_log") {
        url = `${NEW_PRINT}/bilty/print_table/`;
        extraDataObject.file_name = "bookingchallan";
        extraDataObject.client_name =
          process.env.REACT_APP_CLIENT_NAME_FOR_BILTY_PRINT;
        extraDataObject.branch_mobile = pageState.branch_mobile;
        extraDataObject.branch_name = pageState.branch_name;
        extraDataObject.booking_chalan_date = formatDateToDDMMYYYY(
          apiInputData.booking_chalan_date
        );

        let totals = {
          total_to_pay: 0,
          total_paid: 0,
          total_tbb: 0,
          total_pkgs: 0,
        };

        apiInputData.bilty_nos.forEach((bilty) => {
          if (bilty.pay_type === 1)
            totals.total_to_pay += parseInt(bilty.total_amount);
          else if (bilty.pay_type === 2)
            totals.total_paid += parseInt(bilty.total_amount);
          else if (bilty.pay_type === 4)
            totals.total_tbb += parseInt(bilty.total_amount);
          totals.total_pkgs += bilty.no_of_package;
        });

        Object.assign(extraDataObject, totals);
        extraDataObject.data = apiInputData.bilty_nos.map((bilty) => {
          let newInfo = { ...bilty };
          newInfo.print_to_pay =
            newInfo.pay_type === 1 ? Number(newInfo.total_amount) : 0;
          newInfo.print_paid =
            newInfo.pay_type === 2 ? Number(newInfo.total_amount) : 0;
          newInfo.print_tbb =
            newInfo.pay_type === 4 ? Number(newInfo.total_amount) : 0;
          newInfo.item_name = newInfo.item_info[0].item_name;
          newInfo.packing_type =
            itemNamesDict[String(bilty.item_info[0].packing_type)];
          newInfo.bilty_date = formatDateToDDMMYYYY(newInfo.bilty_date);
          return newInfo;
        });
      } else if (process.env.REACT_APP_CLIENT === "nrab" || process.env.REACT_APP_CLIENT === "syt") {
        url = `${NEW_PRINT}/bilty/print_table/`;
        extraDataObject.file_name = "bookingchallan";
        extraDataObject.client_name =
          process.env.REACT_APP_CLIENT_NAME_FOR_BILTY_PRINT;
        extraDataObject.booking_chalan_date = formatDateToDDMMYYYY(
          apiInputData.booking_chalan_date
        );
        extraDataObject.branch_name =
          sessionObject.sessionVariables.branch_name;
        extraDataObject.branch_mobile =
          sessionObject.sessionVariables.branch_mobile;

        let totals = {
          total_to_pay: 0,
          total_paid: 0,
          total_tbb: 0,
          total_amount: 0,
          total_pkgs: 0,
        };

        apiInputData.bilty_nos.forEach((bilty) => {
          const amount = Number(bilty.total_amount) || 0;

          totals.total_amount += amount;
          totals.total_pkgs += bilty.no_of_package || 0;

          if (bilty.pay_type === 1) totals.total_to_pay += amount;
          else if (bilty.pay_type === 2) totals.total_paid += amount;
          else if (bilty.pay_type === 4) totals.total_tbb += amount;
        });

        Object.assign(extraDataObject, totals);

        extraDataObject.data = apiInputData.bilty_nos.map((bilty, index) => {
          let newInfo = { ...bilty };
          newInfo.sr_no = index + 1;
          newInfo.item_name = newInfo.item_info[0].item_name;
          newInfo.bilty_date = formatDateToDDMMYYYY(newInfo.bilty_date);
          return newInfo;
        });

      } else if (process.env.REACT_APP_CLIENT === "arbuda") {
        url = `${NEW_PRINT}/bilty/print_table/`;
        extraDataObject.file_name = "bookingchallan";
        extraDataObject.client_name =
          process.env.REACT_APP_CLIENT_NAME_FOR_BILTY_PRINT;
        extraDataObject.booking_chalan_date = formatDateToDDMMYYYY(
          apiInputData.booking_chalan_date
        );

        let totals = {
          total_amount: 0,
          total_pkgs: 0,
          total_weight: 0,
          total_pf: 0,
        };

        apiInputData.bilty_nos.forEach((bilty) => {
          const biltyAmount = Number(bilty.total_amount) || 0;
          const pfAmount = Number(bilty.pf) || 0;

          totals.total_amount += biltyAmount;
          totals.total_pf += pfAmount;
          totals.total_pkgs += Number(bilty.bilty_pkgs) || 0;
          totals.total_weight += Number(bilty.bilty_weight) || 0;
        });

        Object.assign(extraDataObject, totals);

        extraDataObject.data = apiInputData.bilty_nos.map((bilty, index) => {
          let newInfo = { ...bilty };
          newInfo.sr_no = index + 1;

          newInfo.print_to_pay =
            newInfo.pay_type === 1 ? Number(newInfo.total_amount) : 0;
          newInfo.print_paid =
            newInfo.pay_type === 2 ? Number(newInfo.total_amount) : 0;
          newInfo.print_foc =
            newInfo.pay_type === 3 ? Number(newInfo.total_amount) : 0;
          newInfo.print_tbb =
            newInfo.pay_type === 4 ? Number(newInfo.total_amount) : 0;
          newInfo.item_name = newInfo.item_info[0].item_name;

          newInfo.item_name = newInfo.item_info
            ?.map((item) => item.item_name)
            .join(", ");

          newInfo.packing_type = newInfo.item_info
            ?.map((item) => itemNamesDict[item.packing_type] ?? item.packing_type)
            .join(", ");

          newInfo.print_pkgs = newInfo.total_pkgs;
          newInfo.bilty_date = formatDateToDDMMYYYY(newInfo.bilty_date);
          newInfo.pf = newInfo.pf ?? 0;
          return newInfo;
        });
      } else if (process.env.REACT_APP_CLIENT === "bgtc") {
        url = `${NEW_PRINT}/bilty/print_table/`;
        extraDataObject.file_name = "bookingchallan";
        extraDataObject.client_name =
          process.env.REACT_APP_CLIENT_NAME_FOR_BILTY_PRINT;
        extraDataObject.booking_chalan_date = formatDateToDDMMYYYY(
          apiInputData.booking_chalan_date
        );
        extraDataObject.branch_name =
          sessionObject.sessionVariables.branch_name;
        extraDataObject.branch_mobile =
          sessionObject.sessionVariables.branch_mobile;

        const isAdmin = roleId === 1 || roleId === 2;

        let totals = {
          total_to_pay: 0,
          total_paid: 0,
          total_tbb: 0,
          total_amount: 0,
          total_pkgs: 0,
        };

        apiInputData.bilty_nos.forEach((bilty) => {
          const amount = Number(bilty.total_amount) || 0;
          const pkgs = bilty.no_of_package || 0;

          totals.total_pkgs += pkgs;

          if (bilty.pay_type === 1) {
            totals.total_to_pay += amount;
            totals.total_amount += amount;
          } else if (bilty.pay_type === 2 && isAdmin) {
            totals.total_paid += amount;
            totals.total_amount += amount;
          } else if (bilty.pay_type === 4 && isAdmin) {
            totals.total_tbb += amount;
            totals.total_amount += amount;
          }
        });

        extraDataObject.total_to_pay = totals.total_to_pay;
        extraDataObject.total_amount = totals.total_amount;
        extraDataObject.total_pkgs = totals.total_pkgs;

        if (isAdmin) {
          extraDataObject.total_paid = totals.total_paid;
          extraDataObject.total_tbb = totals.total_tbb;
        }

        extraDataObject.data = apiInputData.bilty_nos.map((bilty, index) => {
          let newInfo = { ...bilty };

          if (!isAdmin && (bilty.pay_type === 2 || bilty.pay_type === 4)) {
            delete newInfo.total_amount;
          }

          newInfo.sr_no = index + 1;
          newInfo.item_name = newInfo.item_info[0].item_name;
          newInfo.bilty_date = formatDateToDDMMYYYY(newInfo.bilty_date);

          if (newInfo.reference_no === null) {
            newInfo.reference_no = "";
          }

          return newInfo;
        });
      } else if (process.env.REACT_APP_CLIENT === "bbac") {
        url = `${NEW_PRINT}/bilty/print_table/`;
        extraDataObject.file_name = "bookingchallan";
        extraDataObject.client_name =
          process.env.REACT_APP_CLIENT_NAME_FOR_BILTY_PRINT;
        extraDataObject.booking_chalan_date = formatDateToDDMMYYYY(
          apiInputData.booking_chalan_date
        );
        extraDataObject.branch_name =
          sessionObject.sessionVariables.branch_name;
        extraDataObject.branch_mobile =
          sessionObject.sessionVariables.branch_mobile;

        let totals = {
          total_to_pay_amount: 0,
          total_other_amount: 0,
          total_amount: 0,
          total_pkgs: 0,
          y_crossing_charge: 0,
          crossing_charge: 0,
        };

        apiInputData.bilty_nos = apiInputData.bilty_nos.map((bilty) => {
          const isCrossing = !!bilty.transporter_id;
          
          const amount = bilty.transporter_id
            ? Number(bilty.transporter_freight) || 0
            : Number(bilty.total_amount) || 0;

          const crossingAmount = Number(bilty.total_amount) || 0;

          const payType = Number(bilty.pay_type);

          let updatedBilty = { ...bilty };

          if (isCrossing) {
            totals.y_crossing_charge += crossingAmount;
          } else {
            totals.crossing_charge += crossingAmount;
          }

          if (payType === 1) {
            updatedBilty.to_pay_total_amount = amount;
            updatedBilty.other_total_amount = "";
            totals.total_to_pay_amount += amount;
          } else if (payType === 2 || payType === 4) {
            updatedBilty.to_pay_total_amount = "";
            updatedBilty.other_total_amount = amount;
            totals.total_other_amount += amount;
          }

          totals.total_amount += amount;
          totals.total_pkgs += Number(bilty.no_of_pkgs) || 0;

          return updatedBilty;
        });
        Object.assign(extraDataObject, totals);

        extraDataObject.data = apiInputData.bilty_nos.map((bilty, index) => {
          let newInfo = { ...bilty };
          newInfo.sr_no = index + 1;
          
          newInfo.item_name = newInfo.item_info[0].item_name;
          newInfo.bilty_date = formatDateToDDMMYYYY(newInfo.bilty_date);

          const payType = Number(newInfo.pay_type);

          if (payType === 1) {
            newInfo.to_pay_type = "To Pay";
            newInfo.other_pay_type = "";
          } else {
            newInfo.to_pay_type = "";
            newInfo.other_pay_type =
              payType === 2
                ? "Paid"
                : payType === 4
                ? "TBB"
                : "";
          }

          return newInfo;
        });

      } else if (process.env.REACT_APP_CLIENT === "sangam") {
        url = `${NEW_PRINT}/bilty/print_table/`;
        extraDataObject.file_name = "bookingchallan";
        extraDataObject.client_name =
          process.env.REACT_APP_CLIENT_NAME_FOR_BILTY_PRINT;
        extraDataObject.booking_chalan_date = formatDateToDDMMYYYY(
          apiInputData.booking_chalan_date
        );

        let totals = {
          total_amount: 0,
          total_pkgs: 0,
          total_weight: 0,
          total_pf: 0,
        };

        apiInputData.bilty_nos.forEach((bilty) => {
          const biltyAmount = Number(bilty.total_amount) || 0;
          const pfAmount = Number(bilty.pf) || 0;

          totals.total_amount += biltyAmount;
          totals.total_pf += pfAmount;
          totals.total_pkgs += Number(bilty.bilty_pkgs) || 0;
          totals.total_weight += Number(bilty.bilty_weight) || 0;
        });

        Object.assign(extraDataObject, totals);

        extraDataObject.data = apiInputData.bilty_nos.map((bilty, index) => {
          let newInfo = { ...bilty };
          newInfo.sr_no = index + 1;

          newInfo.print_to_pay =
            newInfo.pay_type === 1 ? Number(newInfo.total_amount) : 0;
          newInfo.print_paid =
            newInfo.pay_type === 2 ? Number(newInfo.total_amount) : 0;
          newInfo.print_foc =
            newInfo.pay_type === 3 ? Number(newInfo.total_amount) : 0;
          newInfo.print_tbb =
            newInfo.pay_type === 4 ? Number(newInfo.total_amount) : 0;
          newInfo.item_name = newInfo.item_info[0].item_name;

          newInfo.item_name = newInfo.item_info
            ?.map((item) => item.item_name)
            .join(", ");

          newInfo.packing_type = newInfo.item_info
            ?.map((item) => itemNamesDict[item.packing_type] ?? item.packing_type)
            .join(", ");

          newInfo.print_pkgs = newInfo.total_pkgs;
          newInfo.bilty_date = formatDateToDDMMYYYY(newInfo.bilty_date);
          newInfo.pf = newInfo.pf ?? 0;
          return newInfo;
        });
      } else {
        url = SERVER_URL + "/challan/print/";
      }

      if (pageMode === "write") {
        extraDataObject.booking_chalan_no =
          submitApiState.data.response.challan_no;
        extraDataObject.id = submitApiState.data.response.challan_no
      }
    } else if (formName == "MRBILLING") {
      url = SERVER_URL + "/delivery_billing_statement/print/";
      if (pageMode == "write" || pageMode == "view") {
        console.log("Submit api satt", submitApiState.data);
        extraDataObject.id = submitApiState.data.response.bill_no;
      }
    } else if (formName == "BiltyStatement") {
      url = SERVER_URL + "/paid_statement/print/";
      if (pageMode == "write" || pageMode == "view") {
        console.log("Submit api satt", submitApiState.data);
        extraDataObject.id = submitApiState.data.response.paid_statement_no;
      }
    } else if (formName == "MrStatement") {
      url =
        SERVER_URL +
        (process.env.REACT_APP_CLIENT === "guru"
          ? "/mr_statement/print"
          : "/mr_statement/print/");

      if (pageMode == "write" || pageMode == "view" || pageMode == "edit") {
        console.log("Submit api satt", submitApiState.data);
        extraDataObject.mr_statement_no =
          submitApiState.data.response.mr_statement_no;
        extraDataObject.id = submitApiState.data.response.mr_statement_no

        const fYear_fetch =
          sessionObject.sessionVariables.financial_year_for_fetch;

        extraDataObject.fyear = fYear_fetch;
      }
    } else if (formName == "CROSSINGOUT") {
      if (process.env.REACT_APP_CLIENT === "vihira") {
        url = NEW_PRINT + "/bilty/print_table/";
        extraDataObject.client_name =
          process.env.REACT_APP_CLIENT_NAME_FOR_BILTY_PRINT;
        extraDataObject.file_name = "crossingoutwardmemo";
        extraDataObject.crossing_outward_date = formatDateToDDMMYYYY(
          apiInputData.crossing_outward_date
        );
        const totalChargeWeight = apiInputData.bilty_info.reduce(
          (total, info) => {
            return total + (parseFloat(info.charge_weight) || 0);
          },
          0
        );
        extraDataObject.total_charge_weight = totalChargeWeight.toFixed(2);
        extraDataObject.data = [];
        extraDataObject.data = [...apiInputData.bilty_info];
        extraDataObject.data = apiInputData.bilty_info.map((info) => {
          let newInfo = { ...info };
          if (newInfo.bilty_date) {
            newInfo.bilty_date = formatDateToDDMMYYYY(newInfo.bilty_date);
          }
          return newInfo;
        });
      } else if (process.env.REACT_APP_CLIENT == "guru") {
        function formatMobileNumbers(mobileNumbers) {
          const segments = mobileNumbers.split(",");
          return segments.map((number) => number.trim());
        }

        function breakAddressIntoLines(address, maxLength) {
          const lines = [];
          for (let i = 0; i < address.length; i += maxLength) {
            lines.push(address.substring(i, i + maxLength));
          }
          return lines;
        }

        url = NEW_PRINT + "/bilty/print/";
        extraDataObject.client_name =
          process.env.REACT_APP_CLIENT_NAME_FOR_BILTY_PRINT;
        extraDataObject.file_name = "crossingoutward";
        extraDataObject.branch_name =
          sessionObject.sessionVariables.branch_name;
        // extraDataObject.branch_mobile =  sessionObject.sessionVariables.branch_mobile
        const branchMobile = sessionObject.sessionVariables.branch_mobile;
        const formattedBranchMobileNumbers = formatMobileNumbers(branchMobile);

        // Assign formatted mobile numbers to extraDataObject with proper indexing
        formattedBranchMobileNumbers.forEach((number, index) => {
          extraDataObject[`branch_mobile_${index}`] = number;
        });

        extraDataObject.crossing_outward_date = formatDateToDDMMYYYY(
          apiInputData.crossing_outward_date
        );
        const branchId = parseInt(sessionObject.sessionVariables.branch_id);
        const branchInfoArray = sessionObject.sessionVariables.branch_info;
        const branchInfo = branchInfoArray.find(
          (branch) => branch.branch_id === branchId
        );
        // extraDataObject.branch_add = branchInfo?.add || '';

        // Format branch_add by breaking into lines of 60 characters
        const branchAddress = branchInfo?.add || "";
        const maxLineLength = 64;
        const addressLines = breakAddressIntoLines(
          branchAddress,
          maxLineLength
        );

        // Store address lines in extraDataObject with indexed keys
        addressLines.forEach((line, index) => {
          extraDataObject[`branch_add_${index}`] = line;
        });

        console.log("apiInputData:", apiInputData);
        console.log("apiInputData.bilty_nos:", apiInputData.bilty_info);

        for (let i = 0; i < apiInputData.bilty_info.length; i++) {
          const consignorKey = `consignor_name_${i}`;
          const consignorGst = `consignor_gst_${i}`;
          const consigneeKey = `consignee_name_${i}`;
          const consigneeGst = `consignee_gst_${i}`;
          const bilty_dateKey = `bilty_date_${i}`;
          const no_of_packageKey = `no_of_package_${i}`;
          const pay_type_nameKey = `pay_type_name_${i}`;
          const pfKey = `pf_${i}`;
          const suffixKey = `suffix_${i}`;
          const total_amount = `total_amount_${i}`;
          const bilty_noKey = `bilty_no_${i}`;

          extraDataObject[consignorKey] =
            apiInputData.bilty_info[i].consignor_name;
          extraDataObject[consignorGst] =
            apiInputData.bilty_info[i].consignor_gst;
          extraDataObject[consigneeKey] =
            apiInputData.bilty_info[i].consignee_name;
          extraDataObject[consigneeGst] =
            apiInputData.bilty_info[i].consignee_gst;
          extraDataObject[bilty_dateKey] = formatDateToDDMMYYYY(
            apiInputData.bilty_info[i].bilty_date
          );
          extraDataObject[no_of_packageKey] =
            apiInputData.bilty_info[i].no_of_package;
          extraDataObject[pay_type_nameKey] =
            apiInputData.bilty_info[i].pay_type_name;
          extraDataObject[pfKey] = apiInputData.bilty_info[i].pf;
          extraDataObject[suffixKey] = apiInputData.bilty_info[i].suffix;
          extraDataObject[total_amount] =
            apiInputData.bilty_info[i].total_amount;
          extraDataObject[bilty_noKey] = apiInputData.bilty_info[i].bilty_no;
        }
        extraDataObject.total_amount_words = `${convertAmountToWords(
          submitApiState.data.apiInputData.balance
        )} only`;
      } else if (["nrab", "syt", "sangam", "avr", "std", "nptc", "arbuda", "bbac", "jtsa"].includes(process.env.REACT_APP_CLIENT)) {
        url = NEW_PRINT + "/bilty/print_table/";
        extraDataObject.client_name =
          process.env.REACT_APP_CLIENT_NAME_FOR_BILTY_PRINT;
        extraDataObject.file_name = "crossingoutwardmemo";
        extraDataObject.user_name = sessionObject.sessionVariables.user_name;
        extraDataObject.branch_name =
          sessionObject.sessionVariables.branch_name;
        extraDataObject.branch_mobile =
          sessionObject.sessionVariables.branch_mobile;
        extraDataObject.crossing_outward_date = formatDateToDDMMYYYY(
          apiInputData.crossing_outward_date
        );
        extraDataObject.data = [];
        extraDataObject.data = [...apiInputData.bilty_info];
        extraDataObject.data = apiInputData.bilty_info.map((info) => {
          let newInfo = { ...info };
          if (newInfo.bilty_date) {
            newInfo.bilty_date = formatDateToDDMMYYYY(newInfo.bilty_date);
          }
          if (newInfo.pay_type_name != "To Pay") {
            newInfo.total_amount = 0;
          }
          return newInfo;
        });
      } else {
        url = SERVER_URL + "/crossing_outward/print/";
      }
      if (pageMode == "write" || pageMode == "view") {
        console.log("Submit api satt", submitApiState.data);
        extraDataObject.crossing_outward_no =
          submitApiState.data.response.crossing_out_no;
        extraDataObject.id =
          submitApiState.data.response.crossing_out_no;
      }
    } else if (formName == "MR") {
      if (process.env.REACT_APP_CLIENT == "guru") {
        function formatMobileNumbers(mobileNumbers) {
          const segments = mobileNumbers.split(",");
          return segments.map((number) => number.trim());
        }

        function breakAddressIntoLines(address, maxLength) {
          const lines = [];
          for (let i = 0; i < address.length; i += maxLength) {
            lines.push(address.substring(i, i + maxLength));
          }
          return lines;
        }

        url = NEW_PRINT + "/bilty/print/";
        extraDataObject.client_name =
          process.env.REACT_APP_CLIENT_NAME_FOR_BILTY_PRINT;
        extraDataObject.file_name = "moneyreceipt";
        extraDataObject.mr_date = formatDateToDDMMYYYY(apiInputData.mr_date);
        extraDataObject.user_name = sessionObject.sessionVariables.user_name;
        extraDataObject.branch_name =
          sessionObject.sessionVariables.branch_name;
        // extraDataObject.branch_mobile =  sessionObject.sessionVariables.branch_mobile
        const branchMobile = sessionObject.sessionVariables.branch_mobile;
        const formattedBranchMobileNumbers = formatMobileNumbers(branchMobile);

        // Assign formatted mobile numbers to extraDataObject with proper indexing
        formattedBranchMobileNumbers.forEach((number, index) => {
          extraDataObject[`branch_mobile_${index}`] = number;
        });

        const branchId = parseInt(sessionObject.sessionVariables.branch_id);
        const branchInfoArray = sessionObject.sessionVariables.branch_info;
        const branchInfo = branchInfoArray.find(
          (branch) => branch.branch_id === branchId
        );
        // extraDataObject.branch_add = branchInfo?.add || '';

        const branchAddress = branchInfo?.add || "";
        const maxLineLength = 64;
        const addressLines = breakAddressIntoLines(
          branchAddress,
          maxLineLength
        );

        // Store address lines in extraDataObject with indexed keys
        addressLines.forEach((line, index) => {
          extraDataObject[`branch_add_${index}`] = line;
        });

        for (let i = 0; i < apiInputData.bilty_nos.length; i++) {
          const consignorKey = `consignor_name_${i}`;
          const consignorKey1 = `consignor_gst_${i}`;
          const consigneeKey = `consignee_name_${i}`;
          const consigneeKey1 = `consignee_gst_${i}`;
          const suffixKey = `suffix_${i}`;
          const vehicle_nokey = `vehicle_no`;
          const booking_chalan_nokey = `booking_chalan_no`;
          const bilty_noKey = `bilty_no_${i}`;
          const no_of_packageKey = `no_of_package_${i}`;
          const pay_type_nameKey = `pay_type_name_${i}`;
          const total_amountKey = `total_amount_${i}`;
          const pfKey = `pf_${i}`;
          const bilty_dateKey = `bilty_date_${i}`;
          const actualWeight = `actual_weight_${i}`;
          const chargeWeight = `charge_weight_${i}`;
          extraDataObject[consignorKey] =
            apiInputData.bilty_nos[i].consignor_name;
          extraDataObject[consignorKey1] =
            apiInputData.bilty_nos[i].consignor_gst;
          extraDataObject[vehicle_nokey] = apiInputData.bilty_nos[i].vehicle_no;
          extraDataObject[booking_chalan_nokey] =
            apiInputData.bilty_nos[i].booking_chalan_no;
          extraDataObject[consigneeKey] =
            apiInputData.bilty_nos[i].consignee_name;
          extraDataObject[consigneeKey1] =
            apiInputData.bilty_nos[i].consignee_gst;
          extraDataObject[suffixKey] = apiInputData.bilty_nos[i].suffix;
          extraDataObject[bilty_noKey] = apiInputData.bilty_nos[i].bilty_no;
          extraDataObject[no_of_packageKey] =
            apiInputData.bilty_nos[i].no_of_package;
          extraDataObject[pay_type_nameKey] =
            apiInputData.bilty_nos[i].pay_type_name;
          extraDataObject[total_amountKey] =
            apiInputData.bilty_nos[i].total_amount;
          extraDataObject[bilty_dateKey] = formatDateToDDMMYYYY(
            apiInputData.bilty_nos[i].bilty_date
          );
          extraDataObject[pfKey] = apiInputData.bilty_nos[i].pf;
          extraDataObject[actualWeight] =
            apiInputData.bilty_nos[i].actual_weight;
          extraDataObject[chargeWeight] =
            apiInputData.bilty_nos[i].charge_weight;
        }
        extraDataObject.total_amount_words = `${convertAmountToWords(
          submitApiState.data.apiInputData.total_amount
        )} only`;
      } else if (process.env.REACT_APP_CLIENT == "gdala_log") {
        url = NEW_PRINT + "/bilty/print/";
        extraDataObject.client_name =
          process.env.REACT_APP_CLIENT_NAME_FOR_BILTY_PRINT;
        extraDataObject.file_name = "moneyreceipt";
        extraDataObject.mr_date = formatDateToDDMMYYYY(apiInputData.mr_date);
        extraDataObject.user_name = sessionObject.sessionVariables.user_name;
        extraDataObject.branch_name =
          sessionObject.sessionVariables.branch_name;
        extraDataObject.branch_mobile =
          sessionObject.sessionVariables.branch_mobile;
        extraDataObject.id = submitApiState.data.apiInputData.mr_no

        for (let i = 0; i < apiInputData.bilty_nos.length; i++) {
          const consignorKey = `consignor_name_${i}`;
          const consigneeKey = `consignee_name_${i}`;
          const suffixKey = `suffix_${i}`;
          const bilty_noKey = `bilty_no_${i}`;
          const no_of_packageKey = `no_of_package_${i}`;
          const pay_type_nameKey = `pay_type_name_${i}`;
          const total_amountKey = `total_amount_${i}`;
          const bilty_dateKey = `bilty_date_${i}`;
          extraDataObject[consignorKey] =
            apiInputData.bilty_nos[i].consignor_name;
          extraDataObject[consigneeKey] =
            apiInputData.bilty_nos[i].consignee_name;
          extraDataObject[suffixKey] = apiInputData.bilty_nos[i].suffix;
          extraDataObject[bilty_noKey] = apiInputData.bilty_nos[i].bilty_no;
          extraDataObject[no_of_packageKey] =
            apiInputData.bilty_nos[i].no_of_package;
          extraDataObject[pay_type_nameKey] =
            apiInputData.bilty_nos[i].pay_type_name;
          extraDataObject[total_amountKey] =
            apiInputData.bilty_nos[i].total_amount;
          extraDataObject[bilty_dateKey] = formatDateToDDMMYYYY(
            apiInputData.bilty_nos[i].bilty_date
          );
        }
        extraDataObject.total_amount_words = `${convertAmountToWords(
          submitApiState.data.apiInputData.total_amount
        )} only`;
      } else if (["avr", "std", "bgtc","bbac", "jtsa"].includes(process.env.REACT_APP_CLIENT)) {
        url = NEW_PRINT + "/bilty/print/";
        extraDataObject.client_name =
          process.env.REACT_APP_CLIENT_NAME_FOR_BILTY_PRINT;
        extraDataObject.file_name = "moneyreceipt";
        extraDataObject.mr_date = formatDateToDDMMYYYY(apiInputData.mr_date);
        extraDataObject.user_name = sessionObject.sessionVariables.user_name;
        extraDataObject.branch_name =
          sessionObject.sessionVariables.branch_name;
        extraDataObject.branch_mobile =
          sessionObject.sessionVariables.branch_mobile;
        for (let i = 0; i < apiInputData.bilty_nos.length; i++) {
          const consignorKey = `consignor_name_${i}`;
          const consigneeKey = `consignee_name_${i}`;
          const suffixKey = `suffix_${i}`;
          const bilty_noKey = `bilty_no_${i}`;
          const no_of_packageKey = `no_of_package_${i}`;
          const pay_type_nameKey = `pay_type_name_${i}`;
          const total_amountKey = `total_amount_${i}`;
          const pfKey = `pf_${i}`;
          const bilty_dateKey = `bilty_date_${i}`;
          extraDataObject[consignorKey] =
            apiInputData.bilty_nos[i].consignor_name;
          extraDataObject[consigneeKey] =
            apiInputData.bilty_nos[i].consignee_name;
          extraDataObject[suffixKey] = apiInputData.bilty_nos[i].suffix;
          extraDataObject[bilty_noKey] = apiInputData.bilty_nos[i].bilty_no;
          extraDataObject[no_of_packageKey] =
            apiInputData.bilty_nos[i].no_of_package;
          extraDataObject[pay_type_nameKey] =
            apiInputData.bilty_nos[i].pay_type_name;
          extraDataObject[total_amountKey] =
            apiInputData.bilty_nos[i].total_amount;
          extraDataObject[bilty_dateKey] = formatDateToDDMMYYYY(
            apiInputData.bilty_nos[i].bilty_date
          );
          extraDataObject[pfKey] = apiInputData.bilty_nos[i].pf;
        }
        extraDataObject.total_amount_words = `${convertAmountToWords(
          submitApiState.data.apiInputData.total_amount
        )} only`;
      } else if (process.env.REACT_APP_CLIENT == "nptc") {
        url = NEW_PRINT + "/bilty/print/";
        extraDataObject.client_name =
          process.env.REACT_APP_CLIENT_NAME_FOR_BILTY_PRINT;
        extraDataObject.file_name = "moneyreceipt";
        extraDataObject.mr_date = formatDateToDDMMYYYY(apiInputData.mr_date);
        extraDataObject.user_name = sessionObject.sessionVariables.user_name;
        extraDataObject.branch_name =
          sessionObject.sessionVariables.branch_name;
        extraDataObject.branch_mobile =
          sessionObject.sessionVariables.branch_mobile;
        for (let i = 0; i < apiInputData.bilty_nos.length; i++) {
          const consignorKey = `consignor_name_${i}`;
          const consigneeKey = `consignee_name_${i}`;
          const suffixKey = `suffix_${i}`;
          const bilty_noKey = `bilty_no_${i}`;
          const no_of_packageKey = `no_of_package_${i}`;
          const pay_type_nameKey = `pay_type_name_${i}`;
          const total_amountKey = `total_amount_${i}`;
          const pfKey = `pf_${i}`;
          const bilty_dateKey = `bilty_date_${i}`;
          extraDataObject[consignorKey] =
            apiInputData.bilty_nos[i].consignor_name;
          extraDataObject[consigneeKey] =
            apiInputData.bilty_nos[i].consignee_name;
          extraDataObject[suffixKey] = apiInputData.bilty_nos[i].suffix;
          extraDataObject[bilty_noKey] = apiInputData.bilty_nos[i].bilty_no;
          extraDataObject[no_of_packageKey] =
            apiInputData.bilty_nos[i].no_of_package;
          extraDataObject[pay_type_nameKey] =
            apiInputData.bilty_nos[i].pay_type_name;
          extraDataObject[total_amountKey] =
            apiInputData.bilty_nos[i].total_amount;
          extraDataObject[bilty_dateKey] = formatDateToDDMMYYYY(
            apiInputData.bilty_nos[i].bilty_date
          );
          extraDataObject[pfKey] = apiInputData.bilty_nos[i].pf;
        }
        extraDataObject.total_amount_words = `${convertAmountToWords(
          submitApiState.data.apiInputData.total_amount
        )} only`;
      } else if (process.env.REACT_APP_CLIENT == "arbuda") {
        url = NEW_PRINT + "/bilty/print/";

        extraDataObject.client_name =
          process.env.REACT_APP_CLIENT_NAME_FOR_BILTY_PRINT;

        extraDataObject.file_name = "moneyreceipt";

        extraDataObject.user_name =
          sessionObject.sessionVariables.user_name;

        extraDataObject.branch_name =
          sessionObject.sessionVariables.branch_name;

        extraDataObject.branch_mobile =
          sessionObject.sessionVariables.branch_mobile;

        if (apiInputData.bilty_nos && apiInputData.bilty_nos.length > 0) {
          const bilty = apiInputData.bilty_nos[0];

          Object.keys(bilty).forEach((key) => {
            if (
              key !== "mr_date" &&
              key !== "total_amount" &&
              key !== "hamali"
            ) {
              if (key === "bilty_date") {
                extraDataObject.bilty_date = formatDateToDDMMYYYY(bilty.bilty_date);
              } else {
                extraDataObject[key] = bilty[key];
              }
            }
          });
          extraDataObject.item_name = bilty.item_info?.[0]?.item_name || "";
        }

        const rawDate = apiInputData?.mr_date;
        const rawDateTime = apiInputData?.bilty_nos?.[0]?.mr_date;

        extraDataObject.mr_date = formatDateToDDMMYYYY(rawDate);

        // time → fallback to bilty if needed
        extraDataObject.mr_time = formatDateToDDMMYYYY(rawDateTime);

        extraDataObject.total_amount_words = `${convertAmountToWords(
          submitApiState.data.apiInputData.total_amount
        )} only`;
      } else if (process.env.REACT_APP_CLIENT == "sangam") {
        url = NEW_PRINT + "/bilty/print/";

        extraDataObject.client_name =
          process.env.REACT_APP_CLIENT_NAME_FOR_BILTY_PRINT;

        extraDataObject.file_name = "moneyreceipt";

        extraDataObject.user_name =
          sessionObject.sessionVariables.user_name;

        extraDataObject.branch_name =
          sessionObject.sessionVariables.branch_name;

        extraDataObject.branch_mobile =
          sessionObject.sessionVariables.branch_mobile;

        if (apiInputData.bilty_nos && apiInputData.bilty_nos.length > 0) {
          const bilty = apiInputData.bilty_nos[0];

          extraDataObject.bilty_total_amount = bilty.total_amount;

          Object.keys(bilty).forEach((key) => {
            if (
              key !== "mr_date" &&
              key !== "total_amount" &&
              key !== "hamali"
            ) {
              if (key === "bilty_date") {
                extraDataObject.bilty_date = formatDateToDDMMYYYY(
                  bilty.bilty_date
                );
              } else {
                extraDataObject[key] = bilty[key];
              }
            }
          });

          extraDataObject.item_name =
            bilty.item_info?.[0]?.item_name || "";
        }

        const rawDate = apiInputData?.mr_date;
        const rawDateTime = apiInputData?.bilty_nos?.[0]?.mr_date;

        extraDataObject.mr_date = formatDateToDDMMYYYY(rawDate);

        // time → fallback to bilty if needed
        extraDataObject.mr_time = formatDateToDDMMYYYY(rawDateTime);

        extraDataObject.total_amount_words = `${convertAmountToWords(
          submitApiState.data.apiInputData.total_amount
        )} only`;
      }
      if (pageMode == "write") {
        extraDataObject.mr_no = submitApiState.data.response.mr_no;
      }
      extraDataObject.id = parseInt(submitApiState.data.response.mr_id);

    } else if (formName == "CONSIGNORBILLING") {
      ["NRAB", "SYT"].includes(
        process.env.REACT_APP_CLIENT_NAME_FOR_BILTY_PRINT
      )
        ? (url = SERVER_URL + "/tbb_billing_statement/print_nrab/")
        : (url = SERVER_URL + "/tbb_billing_statement/print/");
      if (process.env.REACT_APP_CLIENT == "guru") {
        url = NEW_PRINT + "/bilty/print_table/";
        extraDataObject.client_name =
          process.env.REACT_APP_CLIENT_NAME_FOR_BILTY_PRINT;
        extraDataObject.user_name = sessionObject.sessionVariables.user_name;
        extraDataObject.branch_name =
          sessionObject.sessionVariables.branch_name;
        extraDataObject.branch_mobile =
          sessionObject.sessionVariables.branch_mobile;
        extraDataObject.bill_date = formatDateToDDMMYYYY(
          apiInputData.bill_date
        );
        extraDataObject.consignor_name = pageState.consignor_name;
        extraDataObject.consignor_gst = pageState.consignor_gst;
        if (pageState.extra_print) {
          extraDataObject.file_name = "gstbill";
        } else {
          extraDataObject.file_name = "bill";
        }
        extraDataObject.gst_amount_words = `${convertAmountToWords(
          submitApiState.data.apiInputData.gst_amount
        )} only`;
        extraDataObject.net_amount_words = `${convertAmountToWords(
          submitApiState.data.apiInputData.net_amount
        )} only`;
        for (let i = 0; i < apiInputData.bilty_info.length; i++) {
          const consignorKey = `consignor_name_${i}`;
          extraDataObject[consignorKey] =
            apiInputData.bilty_info[i].consignor_name;
        }
        extraDataObject.data = [];
        extraDataObject.data = [...apiInputData.bilty_info];
        extraDataObject.data = apiInputData.bilty_info.map((info) => {
          let newInfo = { ...info };
          return newInfo;
        });
      }
      if (process.env.REACT_APP_CLIENT == "bgtc") {
        url = NEW_PRINT + "/bilty/print_table/";
        extraDataObject.client_name =
          process.env.REACT_APP_CLIENT_NAME_FOR_BILTY_PRINT;
        extraDataObject.user_name = sessionObject.sessionVariables.user_name;
        extraDataObject.branch_name =
          sessionObject.sessionVariables.branch_name;
        extraDataObject.branch_mobile =
          sessionObject.sessionVariables.branch_mobile;
        extraDataObject.bill_date = formatDateToDDMMYYYY(
          apiInputData.bill_date
        );
        extraDataObject.date_from = formatDateToDDMMYYYY(pageState.input_date_from);
        extraDataObject.date_to = formatDateToDDMMYYYY(pageState.input_date);
        extraDataObject.consignor_name = pageState.consignor_name;
        extraDataObject.consignor_gst = pageState.consignor_gst;
        if (pageState.extra_print) {
          extraDataObject.file_name = "gstbill";
        } else {
          extraDataObject.file_name = "freight_bill";
        }
        extraDataObject.gst_amount_words = `${convertAmountToWords(
          submitApiState.data.apiInputData.gst_amount
        )} only`;
        extraDataObject.net_amount_words = `${convertAmountToWords(
          submitApiState.data.apiInputData.net_amount
        )} only`;
        for (let i = 0; i < apiInputData.bilty_info.length; i++) {
          const consignorKey = `consignor_name_${i}`;
          extraDataObject[consignorKey] =
            apiInputData.bilty_info[i].consignor_name;
        }
        extraDataObject.data = [];
        extraDataObject.data = [...apiInputData.bilty_info];
        extraDataObject.data = apiInputData.bilty_info.map((info) => {
          let newInfo = { ...info };
          return newInfo;
        });
      }

      if (process.env.REACT_APP_CLIENT == "bbac") {
        url = NEW_PRINT + "/bilty/print_table/";
        extraDataObject.client_name =
          process.env.REACT_APP_CLIENT_NAME_FOR_BILTY_PRINT;
        extraDataObject.user_name = sessionObject.sessionVariables.user_name;
        extraDataObject.branch_name =
          sessionObject.sessionVariables.branch_name;
        extraDataObject.branch_mobile =
          sessionObject.sessionVariables.branch_mobile;
        extraDataObject.bill_date = formatDateToDDMMYYYY(
          apiInputData.bill_date
        );
        extraDataObject.date_from = formatDateToDDMMYYYY(pageState.input_date_from);
        extraDataObject.date_to = formatDateToDDMMYYYY(pageState.input_date);
        extraDataObject.consignor_name = pageState.consignor_name;
        extraDataObject.consignor_gst = pageState.consignor_gst;
        extraDataObject.bill_name = submitApiState.data.apiInputData.bill_name;
        if (pageState.extra_print) {
          extraDataObject.file_name = "gstbill";
        } else {
          extraDataObject.file_name = "freight_bill";
        }
        extraDataObject.gst_amount_words = `${convertAmountToWords(
          submitApiState.data.apiInputData.gst_amount
        )} only`;
        extraDataObject.net_amount_words = `${convertAmountToWords(
          submitApiState.data.apiInputData.net_amount
        )} only`;
        extraDataObject.amount_in_words = `${convertAmountToWords(
          Number(submitApiState.data.apiInputData.total_amount)
        )} only`;
        for (let i = 0; i < apiInputData.bilty_info.length; i++) {
          const consignorKey = `consignor_name_${i}`;
          extraDataObject[consignorKey] =
            apiInputData.bilty_info[i].consignor_name;
        }
        extraDataObject.data = [];
        extraDataObject.data = [...apiInputData.bilty_info];
        extraDataObject.data = apiInputData.bilty_info.map((info) => {
          let newInfo = { ...info };
          return newInfo;
        });
      }

      if (pageMode == "write" || pageMode == "view" || pageMode == "edit") {
        console.log("Submit api satt", submitApiState.data);
        extraDataObject.bill_no = submitApiState.data.response.id;
        extraDataObject.id = submitApiState.data.response.id;
      }
    } else if (formName == "CROSSINGBILLING") {
      if (pageState.type == "1") {
        url = SERVER_URL + "/crossing_bill_in/print_data/";
      } else {
        // if (process.env.REACT_APP_CLIENT == "nrab") {
        url = NEW_PRINT + "/bilty/print_table/";
        // } else {
        //   url = SERVER_URL + "/crossing_bill_out/print_data/";
        // }
      }
      if (pageMode == "write" || pageMode == "view" || pageMode == "edit") {
        console.log("Submit api satt", submitApiState.data);
        extraDataObject.bill_no = submitApiState.data.response.bill_no;
        extraDataObject.id = submitApiState.data.response.bill_no;
        extraDataObject.branch_id = pageState.created_from;
        if (
          process.env.REACT_APP_CLIENT == "nrab" ||
          process.env.REACT_APP_CLIENT == "syt" ||
          process.env.REACT_APP_CLIENT == "sangam" ||
          process.env.REACT_APP_CLIENT == "guru"
        ) {
          extraDataObject.file_name = "crssoing_out_bill";
          extraDataObject.client_name =
            process.env.REACT_APP_CLIENT_NAME_FOR_BILTY_PRINT;
          extraDataObject.bill_date = formatDateToDDMMYYYY(
            apiInputData.bill_date
          );
          extraDataObject.transporter_name =
            submitApiState.data.apiInputData.transporter_name;
          extraDataObject.transporter_gst =
            submitApiState.data.apiInputData.transporter_gst;
          extraDataObject.user_name = sessionObject.sessionVariables.user_name;
          extraDataObject.branch_name =
            sessionObject.sessionVariables.branch_name;
          extraDataObject.branch_mobile =
            sessionObject.sessionVariables.branch_mobile;
          extraDataObject.data = [...apiInputData.crossing_info];
          delete apiInputData.crossing_info;

        } else if (["avr", "std", "bgtc", "arbuda", "bbac", "jtsa"].includes(process.env.REACT_APP_CLIENT)) {
          url = NEW_PRINT + "/bilty/print_table/";

          extraDataObject.file_name = "crossingoutwardbill";
          extraDataObject.client_name =
            process.env.REACT_APP_CLIENT_NAME_FOR_BILTY_PRINT;
          extraDataObject.bill_date = formatDateToDDMMYYYY(apiInputData.bill_date);
          extraDataObject.transporter_name =
            submitApiState.data.apiInputData.transporter_name;
          extraDataObject.transporter_gst =
            submitApiState.data.apiInputData.transporter_gst;
          extraDataObject.user_name = sessionObject.sessionVariables.user_name;
          extraDataObject.branch_mobile =
            sessionObject.sessionVariables.branch_mobile;
          extraDataObject.created_from = apiInputData.crossing_info[0].created_from;
          extraDataObject.date_from = formatDateToDDMMYYYY(apiInputData.date_from);
          extraDataObject.date_to = formatDateToDDMMYYYY(apiInputData.date_to);

          extraDataObject.data = apiInputData.crossing_info.map((item, index) => ({
            sr_no: index + 1,
            ...item,
          }));

          delete apiInputData.crossing_info;
        }
      }
    } else if (formName == "Trip") {
      if (process.env.REACT_APP_CLIENT == "gdala_log") {
        url =
          SERVER_URL +
          "/trip/print_trip/" +
          String(submitApiState.data.response.trip_no) +
          "?branch_id=" +
          String(pageState.created_from);
      } else if (process.env.REACT_APP_CLIENT == "arbuda") {
        console.log("Submit api satt", submitApiState.data);

        url = NEW_PRINT + "/bilty/print_table/";
        (extraDataObject.client_name =
          process.env.REACT_APP_CLIENT_NAME_FOR_BILTY_PRINT),
          (extraDataObject.file_name = "trip");
        extraDataObject.vehicle_no = pageState.vehicle_no;
        extraDataObject.trip_date = formatDateToDDMMYYYY(
          submitApiState.data.apiInputData.input_date
        );
        extraDataObject.payable_branch_name = pageState.payable_branch_name;
        extraDataObject.balance_bhada_words = `${convertAmountToWords(
          submitApiState.data.apiInputData.balance_bhada
        )} only`;
        submitApiState.data.apiInputData.challan_ids.forEach(
          (challan_id, index) => {
            Object.keys(challan_id).forEach((key) => {
              extraDataObject[key] = challan_id[key];
            });
          }
        );
        extraDataObject.remarks = submitApiState.data.apiInputData.remarks;
        extraDataObject.owner_name = submitApiState.data.apiInputData.owner_name;

        extraDataObject.data = submitApiState.data.apiInputData.challan_ids;

      } else if (process.env.REACT_APP_CLIENT == "guru") {
        url = NEW_PRINT + "/bilty/print/";
        (extraDataObject.client_name =
          process.env.REACT_APP_CLIENT_NAME_FOR_BILTY_PRINT),
          (extraDataObject.file_name = "bhadachitthi");
        extraDataObject.vehicle_no = pageState.vehicle_no;
        extraDataObject.trip_date = formatDateToDDMMYYYY(
          submitApiState.data.apiInputData.input_date
        );
        extraDataObject.payable_branch_name = pageState.payable_branch_name;
        extraDataObject.balance_bhada_words = `${convertAmountToWords(
          submitApiState.data.apiInputData.balance_bhada
        )} only`;
        submitApiState.data.apiInputData.challan_ids.forEach(
          (challan_id, index) => {
            Object.keys(challan_id).forEach((key) => {
              extraDataObject[key] = challan_id[key];
            });
          }
        );
        extraDataObject.remarks = submitApiState.data.apiInputData.remarks;
      } else if (process.env.REACT_APP_CLIENT == "sangam") {
        console.log("Submit api satt", submitApiState.data);

        url = NEW_PRINT + "/bilty/print_table/";
        (extraDataObject.client_name =
          process.env.REACT_APP_CLIENT_NAME_FOR_BILTY_PRINT),
          (extraDataObject.file_name = "trip");
        extraDataObject.vehicle_no = pageState.vehicle_no;
        extraDataObject.trip_date = formatDateToDDMMYYYY(
          submitApiState.data.apiInputData.input_date
        );
        extraDataObject.payable_branch_name = pageState.payable_branch_name;
        extraDataObject.balance_bhada_words = `${convertAmountToWords(
          submitApiState.data.apiInputData.balance_bhada
        )} only`;
        submitApiState.data.apiInputData.challan_ids.forEach(
          (challan_id, index) => {
            Object.keys(challan_id).forEach((key) => {
              extraDataObject[key] = challan_id[key];
            });
          }
        );
        extraDataObject.remarks = submitApiState.data.apiInputData.remarks;
        extraDataObject.owner_name = submitApiState.data.apiInputData.owner_name;

        extraDataObject.data = submitApiState.data.apiInputData.challan_ids;

      } else {
        url =
          SERVER_URL +
          "/trip/print/" +
          String(submitApiState.data.response.trip_no) +
          "?branch_id=" +
          String(pageState.created_from);
      }

      if (pageMode == "write" || pageMode == "view" || pageMode == "edit") {
        extraDataObject.trip_no = submitApiState.data.response.trip_no;
        extraDataObject.id = submitApiState.data.response.id || submitApiState.data.response.trip_no;
      }
      extraDataObject.user_role = pageState.role_id;
    } else if (formName == "AccountTransaction") {
      if (process.env.REACT_APP_CLIENT == "xpress") {
        url = NEW_PRINT + "/bilty/print/";
        apiInputData = submitApiState.data.apiInputData;
        extraDataObject.client_name =
          process.env.REACT_APP_CLIENT_NAME_FOR_BILTY_PRINT;
        pageState.isChequePrint
          ? (extraDataObject.file_name = "cheque")
          : (extraDataObject.file_name = "voucher");
        const totalAmount = parseFloat(
          submitApiState.data.apiInputData.total_amount
        );
        extraDataObject.id = submitApiState.data.response.id;
        extraDataObject.total_amount_words =
          convertAmountToWords(totalAmount).toUpperCase();
        submitApiState.data.apiInputData.account_transaction_info.forEach(
          (transaction, index) => {
            for (const key in transaction) {
              const dynamicKey = `${key}_${index}`;
              extraDataObject[dynamicKey] = transaction[key];
            }
          }
        );
        if (
          submitApiState.data.apiInputData.voucher_type == "jv" ||
          submitApiState.data.apiInputData.voucher_type == "cntr"
        ) {
          extraDataObject.consignor_name =
            submitApiState.data.apiInputData.account_transaction_info[0].consignor_name;
          extraDataObject.consignee_name =
            submitApiState.data.apiInputData.account_transaction_info[0].consignee_name;
        }
        if (submitApiState.data.apiInputData.voucher_type == "cp") {
          extraDataObject.consignee_name =
            submitApiState.data.apiInputData.account_transaction_info[0].consignee_name;
        }
        if (submitApiState.data.apiInputData.voucher_type == "cr") {
          extraDataObject.consignee_name =
            submitApiState.data.apiInputData.account_transaction_info[0].consignor_name;
          for (
            let i = 0;
            i <
            submitApiState.data.apiInputData.account_transaction_info.length;
            i++
          ) {
            const consigneeName =
              submitApiState.data.apiInputData.account_transaction_info[i]
                .consignee_name;
            extraDataObject[`consignor_name_${i}`] = consigneeName;
          }
        }
        var inputDate = apiInputData.input_date;
        var parts = inputDate.split("-");
        var year = parts[0];
        var month = parts[1];
        var day = parts[2];
        extraDataObject.input_date = day + "-" + month + "-" + year;
      } else {
        url = SERVER_URL + "/account_trans/print_jv_voucher/";
        const voucherId = submitApiState.data.response.id;
        const accountTransactionInfo =
          submitApiState.data.apiInputData.account_transaction_info;
        accountTransactionInfo.forEach((transaction) => {
          transaction.voucher_id = voucherId;
        });
        apiInputData =
          submitApiState.data.apiConfig.additionalFilterOnInput(apiInputData);
      }
    } else if (formName == "Marfatiya") {
      if (pageMode == "write" || pageMode == "edit") {

        url = NEW_PRINT + "/bilty/print_table/";
        console.log("Submit api satt", submitApiState.data);
        extraDataObject.file_name = "marfatiya";
        extraDataObject.client_name = "jagdish";
        extraDataObject.mf_no = submitApiState.data.response.mf_no;
        extraDataObject.id = submitApiState.data.response.mf_no;
        extraDataObject.mf_date = formatDate(submitApiState.data.apiInputData.mf_date);
        extraDataObject.driver_name = submitApiState.data.apiInputData.driver_name;
        extraDataObject.station_name = submitApiState.data.apiInputData.station_name;
        extraDataObject.vehicle_no = submitApiState.data.apiInputData.vehicle_no;

        if (apiInputData.bilty_ids) {
          extraDataObject.data = apiInputData.bilty_ids;
          delete apiInputData.bilty_ids;
        }
      }
      
    }

    let response = await fetch(url, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ ...apiInputData, ...extraDataObject }),
    }).then((r) => r.blob());
    print({
      printable: URL.createObjectURL(response),
      type: "pdf",
      showModal: false,
      onPrintDialogClose: () => {
        window.location.reload();
      },
    });
  };

  if (formName == "Bilty") {
    useEffect(
      // Effect for clearing out client side validation
      () => {
        refStoreObject.current["item_in"] = [];
        for (let index = 0; index < pageState.item_in.length; index++) {
          refStoreObject.current["item_in"].push({
            item_name: null,
            unit: null,
            pkgs: null,
            weight: null,
            rate: null,
            amount: null,
            new_row: null,
            packing_type: null,
            truck_size: null,
          });
        }
        refStoreObject.current["eway_bill_no"] = [];
        for (let index = 0; index < pageState.eway_bill_no.length; index++) {
          refStoreObject.current["eway_bill_no"].push({
            eway_bill_no: null,
            new_row: null,
          });
        }
      },
      [pageState.item_in.length, pageState.eway_bill_no.length]
    );
  }

  const fetchLastData = async () => {
    
    const fyObj = JSON.parse(sessionStorage.getItem("financial_year_for_fetch") || "null");
    const fYear_fetch = fyObj?.financial_year_for_fetch || "";
    const companyId = pageState.company_id;

    const makeApiCall = async (url, errorField, successCallback) => {
      try {
        const response = await fetch(url);
        if (!response.ok) {
          if (errorField) {
            setPageStateByField(errorField, "Error");
          }
          return null;
        }
        const resp = await response.json();
        if (successCallback) {
          successCallback(resp);
        }
        return resp;
      } catch (error) {
        console.error(`API call failed for ${url}:`, error);
        if (errorField) {
          setPageStateByField(errorField, "Error");
        }
        return null;
      }
    };

    if (formName == "Bilty") {
      const url = SERVER_URL + "/bilty/last_bilty/" + pageState.created_from + "/" + pageState.created_by + "?companyId=" + companyId + "&fyear=" + fYear_fetch;
      
      await makeApiCall(url, "last_bilty_no", (resp) => {
        resp.last_suffix = resp.suffix;
        resp.eway_bill_no = [{ eway_bill_no: "", new_row: "N" }];
        
        if (
          ["nrab", "syt", "sangam"].includes(process.env.REACT_APP_CLIENT) &&
          resp.station_from
        ) {
          let newObj = {
            station_from: resp.station_from,
            station_from_name: resp.station_from_name,
          };

          if (window.location.href.includes("cross-bilty")) {
            newObj.suffix = resp.suffix;
          }

          setPageState((oldState) => ({ ...oldState, ...newObj }));
        }
        
        if (process.env.REACT_APP_CLIENT == "shubham") {
          resp.item_in = [{ amount: "0", item_name: "", pkgs: "", rate: "0", unit: "F", weight: "", new_row: "N", packing_type: "1", truck_size: "" }];
        } else if (process.env.REACT_APP_CLIENT == "g_trans") {
          resp.item_in = [{ amount: "0", item_name: "", pkgs: "", rate: "0", unit: "F", weight: "", new_row: "N", packing_type: "1", truck_size: "" }];
        } else if (process.env.REACT_APP_CLIENT == "nptc") {
          resp.item_in = [{ amount: "", item_name: "", pkgs: "", rate: "", unit: "T", weight: "", new_row: "N", packing_type: "1", truck_size: "9mt" }]; 
        } else if (process.env.REACT_APP_CLIENT == "syt" || process.env.REACT_APP_CLIENT == "sangam") {
          resp.item_in = [{ amount: "0", item_name: "", pkgs: "", rate: "0", unit: "C", weight: "0", new_row: "N", packing_type: "1", truck_size: ""}];
        } else if (process.env.REACT_APP_CLIENT == "nrab") {
          resp.item_in = [{ amount: "0", item_name: "", pkgs: "", rate: "0", unit: "C", weight: "0", new_row: "N", packing_type: "1", truck_size: "" }];
        } else if (process.env.REACT_APP_CLIENT == "jncargo") {
          resp.item_in = [{ amount: "0", item_name: "", pkgs: "", rate: "6", unit: "W", weight: "0", new_row: "N", packing_type: "11", truck_size: "" }];
        } else if (process.env.REACT_APP_CLIENT == "bgtc") {
          resp.item_in = [{ amount: "", item_name: "", pkgs: "", rate: "", unit: "C", weight: "0", new_row: "N", packing_type: "1", truck_size: "" }];
        } else if (process.env.REACT_APP_CLIENT == "bbac") {
          resp.item_in = [{ amount: "", item_name: "", pkgs: "", rate: "", unit: "T", weight: "0", new_row: "N", packing_type: "1", truck_size: "9mt" }];
        } else {
          resp.item_in = [{ amount: "", item_name: "", pkgs: "", rate: "", unit: "C", weight: "", new_row: "N", packing_type: "1", truck_size: "9mt" }];
        }
        
        delete resp.suffix;
        delete resp.station_from;
        delete resp.station_from_name;
        
        let idClearanceDummy = {};
        if ("consignor_name" in resp) {
          idClearanceDummy.consignor_name = { value: resp.consignor_name, fieldToClear: "consignor_id" };
        }
        if ("consignor_gst" in resp) {
          idClearanceDummy.consignor_gst = { value: resp.consignor_gst, fieldToClear: "consignor_id" };
        }
        setIdClearancState({ ...idClearancState, ...idClearanceDummy });
        
        const clientsToClearConsignor = [
          "gdala_log",
          "shubham",
          "nrab",
          "syt",
          "sangam",
          "xpress",
          "sra",
          "guru",
          "g_trans",
          "bgtc",
          "arbuda",
          "bbac",
          "jtsa"
        ];

        if (["bgtc", "bbac", "jtsa"].includes(process.env.REACT_APP_CLIENT)) {
          delete resp.pay_type;
        }

        if (clientsToClearConsignor.includes(process.env.REACT_APP_CLIENT)) {
          let newObj = { 
            consignor_name: "", 
            consignor_gst: "",
            consignor_id: ""
          };

          setPageState((oldState) => ({ ...oldState, ...resp, ...newObj }));
        } else {
          setPageState((oldState) => ({ ...oldState, ...resp }));
        }
      });
    }

    if (formName == "Challan") {
      const url = SERVER_URL + "/challan/last_chalan/" + pageState.created_from + "/" + pageState.created_by + "?companyId=" + companyId + "&fyear=" + fYear_fetch;
      
      await makeApiCall(url, "last_challan_no", (resp) => {
        setPageState({ ...pageState, last_challan_no: resp.last_booking_chalan_no, input_date: new Date(resp.current_date) });
      });
    }

    if (formName == "FleetManagement") {
      const url = SERVER_URL + "/fleet_master/last/?user_id=" + pageState.created_by + "&branch_id=" + pageState.created_from + "&companyId=" + companyId + "&fyear=" + fYear_fetch;
      
      await makeApiCall(url, "last_fleet_no", (resp) => {
        setPageState({ ...pageState, last_fleet_no: resp.last_fleet_no });
      });
    }

    if (formName == "StockOutward") {
      const url = SERVER_URL + "/stock_register/last/2";
      
      await makeApiCall(url, "last_register_no", (resp) => {
        setPageState({ ...pageState, last_register_no: resp });
      });
    }

    if (formName == "StockInward") {
      const url = SERVER_URL + "/stock_register/last/1";
      
      await makeApiCall(url, "last_register_no", (resp) => {
        setPageState({ ...pageState, last_register_no: resp });
      });
    }

    if (formName == "SeparateEwb") {
      const url = SERVER_URL + "/separate-ewb/last_chalan/" + pageState.created_from + "/" + pageState.created_by;
      
      await makeApiCall(url, "last_challan_no", (resp) => {
        setPageState({ ...pageState, last_challan_no: resp.last_booking_chalan_no, input_date: new Date(resp.current_date) });
      });
    }

    if (formName == "MRBILLING") {
      // const url =
      //     SERVER_URL + "/tbb_billing_statement/last/" + pageState.created_from
      //     + "?companyId=" + companyId +
      //     "&fyear=" + fYear_fetch;
      // const response = await fetch(url);
      // if (!response.ok) {
      //     setPageStateByField("last_consignor_bill_no", "Error");
      //     return;
      // } else {
      //     let resp = await response.json();
      //     if (resp != null) {
      //         //  Below line commented for getting last_bill_no of ASALALI
      //         setPageStateByField("last_consignor_bill_no", resp.last_no);
      //         // setPageStateByField("last_consignor_bill_no", resp.bill_no);
      //     }
      // }
    }

    if (formName == "CONSIGNORBILLING") {
      const url = SERVER_URL + "/tbb_billing_statement/last/" + pageState.created_from + "?companyId=" + companyId + "&fyear=" + fYear_fetch;
      
      await makeApiCall(url, "last_consignor_bill_no", (resp) => {
        if (resp != null) {
          setPageStateByField("last_consignor_bill_no", resp.bill_no);
        }
      });
    }

    if (formName == "CROSSINGBILLING") {
      const url = SERVER_URL + "/crossing_bill_in/last/" + pageState.created_from + "?companyId=" + companyId + "&fyear=" + fYear_fetch;
      
      await makeApiCall(url, "last_consignor_bill_no", (resp) => {
        if (resp != null) {
          setPageStateByField("last_consignor_bill_no", resp.bill_no);
        }
      });
    }

    if (formName == "PODSTATEMENT") {
      const url = SERVER_URL + "/pod_statement/last/" + pageState.created_from + "?companyId=" + companyId + "&fyear=" + fYear_fetch;
      
      await makeApiCall(url, "last_consignor_bill_no", (resp) => {
        if (resp != null) {
          setPageStateByField("last_consignor_bill_no", resp.pod_statement_no);
        }
      });
    }

    if (formName == "PodChallan") {
      const url = SERVER_URL + "/pod/last_pod/" + pageState.created_from + "/" + pageState.created_by + "?companyId=" + companyId + "&fyear=" + fYear_fetch;
      
      await makeApiCall(url, "last_challan_no", (resp) => {
        setPageStateByField("last_challan_no", resp.last_pod_chalan_no);
      });
    }

    if (formName == "BiltyStatement") {
      // const url =
      //   SERVER_URL + "/bilty/paid_statement/" + pageState.created_from;
      // const response = await fetch(url);
      // if (!response.ok) {
      // } else {
      //   var resp = await response.json();

      //   let total_biltys = 0;
      //   let total_packages = 0;
      //   let total_weight = 0;
      //   let total_freight = 0;
      //   // console.log("112", newState.bilty_info_list);
      //   for (let biltys in resp["bilty_info_list"]) {
      //     total_biltys += 1;

      //     if (
      //       resp["bilty_info_list"][biltys].no_of_package != "" &&
      //       resp["bilty_info_list"][biltys].no_of_package != null
      //     ) {
      //       total_packages += parseInt(
      //         resp["bilty_info_list"][biltys].no_of_package
      //       );
      //     }
      //     console.log("weight", resp["bilty_info_list"][biltys].charge_weight);
      //     if (
      //       resp["bilty_info_list"][biltys].charge_weight != "" &&
      //       resp["bilty_info_list"][biltys].charge_weight != null
      //     ) {
      //       console.log("in");
      //       total_weight += parseInt(
      //         resp["bilty_info_list"][biltys].charge_weight
      //       );
      //     }

      //     if (
      //       resp["bilty_info_list"][biltys].freight != "" &&
      //       resp["bilty_info_list"][biltys].freight != null
      //     ) {
      //       total_freight += parseInt(resp["bilty_info_list"][biltys].total_amount);
      //     }
      //   }
      //   pageState.bilty_count = total_biltys;
      //   pageState.no_of_articles = total_packages;
      //   pageState.weight = total_weight;
      //   pageState.total_amount = total_freight;

      //   console.log("New state", total_biltys);
      //   // setPageStateByField("amount_list", resp["amount_list"]);

      //   // setPageStateByField("bilty_info_list", resp["bilty_info_list"]);
      // }

      let last_url = SERVER_URL + "/paid_statement/last/" + pageState.created_from;
      last_url += "?companyId=" + companyId + "&fyear=" + fYear_fetch;
      
      const resp = await makeApiCall(last_url, "last_bilty_statement_no", null);
      
      let newState;
      if (resp == null) {
        newState = { last_bilty_statement_no: "" };
      } else {
        newState = { last_bilty_statement_no: resp["paid_statement_no"] };
      }

      // if (!response.ok) {
      //   // var newState = {
      //   //   last_bilty_statement_no: "",
      //   // };
      // } else {
      //   // newState.amount_list = resp["amount_list"]
      //   // newState.bilty_info_list = resp["bilty_info_list"]
      // }

      setPageState({ ...pageState, ...newState });
    }

    if (formName == "MrStatement") {
      const url = SERVER_URL + "/money_receipt/mr_statement/" + pageState.created_from + "?companyId=" + companyId + "&fyear=" + fYear_fetch;
      
      const resp = await makeApiCall(url, null, (resp) => {
        let total_mrs = 0;
        let total_amounts = 0;
        // console.log("112", newState.mr_info_list);
        for (let mrs in resp["mr_info_list"]) {
          total_mrs += 1;

          if (resp["mr_info_list"][mrs].total_amount != "" && resp["mr_info_list"][mrs].total_amount != null) {
            total_amounts += parseInt(resp["mr_info_list"][mrs].total_amount);
            // console.log("This is the final total amount -> ", parseInt(resp["mr_info_list"][mrs].total_amount));
          }
        }
        // pageState.mr_count = total_mrs;
        // pageState.total_amount = total_amounts;
      });

      const last_url = SERVER_URL + "/mr_statement/last/" + pageState.created_from + "?companyId=" + companyId + "&fyear=" + fYear_fetch;
      
      const last_resp = await makeApiCall(last_url, "last_mr_statement_no", null);
      
      let newState;
      if (!last_resp) {
        if (!resp) {
          newState = { last_mr_statement_no: "" };
        } else {
          newState = { mr_info_list: resp["mr_info_list"] };
        }
      } else {
        newState = { last_mr_statement_no: last_resp["mr_statement_no"] };
      }
      
      if (resp) {
        // newState.mr_info_list = resp["mr_info_list"]
      }
      
      setPageState({ ...pageState, ...newState });
    }

    if (formName == "VehicleRegister") {
      const url = SERVER_URL + "/vehicleregister/last/" + pageState.created_from + "?companyId=" + pageState.company_id + "&fyear=" + fYear_fetch;
      
      await makeApiCall(url, "last_entry_no", (resp) => {
        if (resp != null) {
          setPageStateByField("last_entry_no", resp.vr_no);
        }
      });
    }

    if (formName == "MrPendingAmount") {
      const url = SERVER_URL + "/pending_mr_payment/last/" + pageState.created_from + "?companyId=" + companyId + "&fyear=" + fYear_fetch;
      
      await makeApiCall(url, "last_entry_no", (resp) => {
        setPageStateByField("last_entry_no", resp);
      });
    }

    if (formName == "Trip") {
      const url = SERVER_URL + "/trip/last_trip/" + pageState.created_from + "/" + pageState.created_by + "?companyId=" + companyId + "&fyear=" + fYear_fetch;
      
      await makeApiCall(url, "last_trip_no", (resp) => {
        setPageState((pageState) => ({
          ...pageState,
          last_trip_no: resp.last_trip_no,
          input_date: formatDate(new Date(resp.current_date)),
        }));
      });
    }

    // if (formName == "VehicleRegister") {
    //   const url =
    //     SERVER_URL +
    //     "/vehicleregister/last/" +
    //     pageState.created_from +
    //     "/" +
    //     pageState.created_by;
    //   const response = await fetch(url);
    //   if (!response.ok) {
    //     setPageStateByField("last_trip_no", "Error");
    //     return;
    //   } else {
    //     let resp = await response.json();
    //     setPageStateByField("last_trip_no", resp.last_trip_no);
    //   }
    // }

    if (formName == "MR") {
      const url = SERVER_URL + "/money_receipt/last_mr/" + pageState.created_from + "/" + pageState.created_by + "?companyId=" + companyId + "&fyear=" + fYear_fetch;
      
      await makeApiCall(url, "last_mr_no", (resp) => {
        setPageStateByField("last_mr_no", resp.last_mr_no);
      });
    }

    if (formName == "CROSSINGIN") {
      const url = SERVER_URL + "/crossing_inward/last/?branch_id=" + pageState.created_from + "&user_id=" + pageState.created_by + "&companyId=" + companyId + "&fyear=" + fYear_fetch;
      
      await makeApiCall(url, "last_crossing_no", (resp) => {
        setPageStateByField("last_crossing_no", resp.crossing_inward_no);
      });
    }

    if (formName == "CROSSINGOUT") {
      const url = SERVER_URL + "/crossing_outward/last/?branch_id=" + pageState.created_from + "&user_id=" + pageState.created_by + "&companyId=" + companyId + "&fyear=" + fYear_fetch;
      
      await makeApiCall(url, "last_crossing_no", (resp) => {
        setPageStateByField("last_crossing_no", resp.crossing_outward_no);
      });
    }

    if (formName == "ChallanInward") {
      const url = SERVER_URL + "/challan/all_challan/" + pageState.created_from + "?companyId=" + companyId + "&fyear=" + fYear_fetch;
      
      await makeApiCall(url, "last_crossing_no", (resp) => {
        console.log("reeeesspooonse", resp);
        setPageStateByField("challan_ids", resp);
      });
    }

    if (formName == "PodChallanInward") {
      const url = SERVER_URL + "/pod/all_pod/" + pageState.created_from + "?companyId=" + companyId + "&fyear=" + fYear_fetch;
      
      await makeApiCall(url, "last_crossing_no", (resp) => {
        console.log("reeeesspooonse", resp);
        setPageStateByField("pod_info_list", resp);
      });
    }

    if (formName == "TRIPIN") {
      const url = SERVER_URL + "/trip/all_trip/" + pageState.created_from;
      
      await makeApiCall(url, "last_crossing_no", (resp) => {
        setPageStateByField("trip_ids", resp);
      });
    }

    if (formName == "EwbEx") {
      const url = SERVER_URL + "/trip/all_trip/" + pageState.created_from;
      
      await makeApiCall(url, "last_crossing_no", (resp) => {
        setPageStateByField("trip_ids", resp);
      });
    }

    if (formName == "TripBhada") {
      const url = SERVER_URL + "/trip/all_payable/" + pageState.created_from + "?companyId=" + companyId + "&fyear=" + fYear_fetch;
      
      await makeApiCall(url, null, (resp) => {
        setPageStateByField("trip_info", resp);
      });
    }

    if (formName == "Marfatiya") {
      const url =
          SERVER_URL +
          "/marfatiyaget_last_mf_no" +
          "?branch_id=" + pageState.created_from +
          "&fyear=" + fYear_fetch +
          "&companyId=" + companyId;
      const response = await fetch(url);
      if (!response.ok) {
        setPageStateByField("last_mf_no", "Error");
        return;
      } else {
        let resp = await response.json();
        if (resp != null) {
          setPageStateByField("last_mf_no", resp.last_mf_no);
        }
      }
    }
  };

  useEffect(
    // Effect for Focus
    () => {
      let focusTimer = null;
      
      if (formName == "Bilty" && "is_crossing" in refStoreObject.current) {
        refStoreObject.current["is_crossing"].focus();
      }
      if (
        process.env.REACT_APP_CLIENT === "bgtc" &&
        formName === "Bilty" &&
        refStoreObject.current["reference_no"]
      ) {
        refStoreObject.current["reference_no"].focus();
      }
      if (
        ["shubham", "nrab", "syt", "sangam", "sra"].includes(process.env.REACT_APP_CLIENT) &&
        formName === "Bilty" &&
        refStoreObject.current["bilty_no"]
      ) {
        refStoreObject.current["bilty_no"].focus();
      }
      if (formName == "Challan" && "challan_no" in refStoreObject.current) {
        refStoreObject.current["challan_no"].focus();
      }
      if (formName == "MRBILLING" && "bill_no" in refStoreObject.current) {
        refStoreObject.current["bill_no"].focus();
      }
      if (
        formName == "PodChallan" &&
        "pod_challan_no" in refStoreObject.current
      ) {
        refStoreObject.current["pod_challan_no"].focus();
      }
      if (formName == "StationMaster" && "name" in refStoreObject.current) {
        refStoreObject.current["is_branch"].focus();
      }
      if (
        formName == "BiltyStatement" &&
        "paid_statement_no" in refStoreObject.current
      ) {
        refStoreObject.current["paid_statement_no"].focus();
      }
      if (
        formName == "MrStatement" &&
        "mr_statement_no" in refStoreObject.current
      ) {
        refStoreObject.current["mr_statement_no"].focus();
      }
      if (formName == "ItemMaster" && "name" in refStoreObject.current) {
        refStoreObject.current["name"].focus();
      }
      if (
        formName == "PodChallanInward" &&
        "pod_challan_no" in refStoreObject.current
      ) {
        refStoreObject.current["pod_challan_no"].focus();
      }
      if (
        formName == "MR" &&
        !["guru", "bgtc", "arbuda"].includes(process.env.REACT_APP_CLIENT) &&
        "mr_no" in refStoreObject.current
      ) {
        refStoreObject.current["mr_no"].focus();
      }
      // if (
      //   ["guru", "bgtc"].includes(process.env.REACT_APP_CLIENT) &&
      //   formName === "MR" &&
      //   refStoreObject.current["bilty_no"]?.focus
      // ) {
      //   refStoreObject.current["bilty_no"]?.focus();
      // }
      if (
        formName == "BillPaid" &&
        "station_to_name" in refStoreObject.current
      ) {
        refStoreObject.current["station_to_name"].focus();
      }
      if (formName == "Trip" && "trip_no" in refStoreObject.current) {
        refStoreObject.current["trip_no"].focus();
      }
      if (
        formName == "VehicleRegister" &&
        "vehicle_register_id" in refStoreObject.current
      ) {
        refStoreObject.current["vehicle_register_id"].focus();
      }
      if (formName == "Vehicle" && "vehicle_no" in refStoreObject.current) {
        refStoreObject.current["vehicle_no"].focus();
      }
      if (
        formName == "ChallanInward" &&
        "challan_no" in refStoreObject.current
      ) {
        refStoreObject.current["challan_no"].focus();
      }
      if (
        formName == "CONSIGNORBILLING" &&
        "bill_no" in refStoreObject.current
      ) {
        refStoreObject.current["bill_no"].focus();
      }
      if (
        formName == "PodChallanInward" &&
        "challan_no" in refStoreObject.current
      ) {
        refStoreObject.current["challan_no"].focus();
      }
      if (
        formName == "CROSSINGIN" &&
        "crossing_in_no" in refStoreObject.current
      ) {
        refStoreObject.current["crossing_in_no"].focus();
      }
      if (
        formName == "CROSSINGOUT" &&
        "crossing_out_no" in refStoreObject.current
      ) {
        refStoreObject.current["crossing_out_no"].focus();
      }
      if (formName == "TRIPIN" && "trip_no" in refStoreObject.current) {
        refStoreObject.current["trip_no"].focus();
      }
      if (
        formName == "TripBhada" &&
        "station_from_name" in refStoreObject.current
      ) {
        refStoreObject.current["station_from_name"].focus();
      }
      if (formName == "CROSSINGBILLING" && "type" in refStoreObject.current) {
        refStoreObject.current["type"].focus();
      }
      if (
        formName == "PARTYRATEMASTER" &&
        "consignor_name" in refStoreObject.current
      ) {
        refStoreObject.current["consignor_name"].focus();
      }
      if (
        formName == "GENERALRATEMASTER" &&
        "station_from_name" in refStoreObject.current
      ) {
        refStoreObject.current["station_from_name"].focus();
      }
      if (formName == "CONSIGNORBILLING" && "id" in refStoreObject.current) {
        refStoreObject.current["id"].focus();
      }
      if (formName == "PODSTATEMENT" && "id" in refStoreObject.current) {
        refStoreObject.current["id"].focus();
      }
      if (
        formName == "Bilty Inquiry" &&
        "is_crossing" in refStoreObject.current
      ) {
        refStoreObject.current["is_crossing"].focus();
      }
      if (formName == "AccountMaster" && "name" in refStoreObject.current) {
        refStoreObject.current["name"].focus();
      }
      if (formName == "Marfatiya" && "mf_no" in refStoreObject.current) {
        refStoreObject.current["mf_no"].focus();
      }
      fetchLastData();

      if (
        ["guru", "bgtc", "arbuda"].includes(process.env.REACT_APP_CLIENT) &&
        formName === "MR" &&
        refStoreObject.current["bilty_no"]
      ) {
        focusTimer = setTimeout(() => {
          refStoreObject.current["bilty_no"]?.focus();
        }, 150);
      }

      return () => {
        if (focusTimer) clearTimeout(focusTimer);
      };
    },
    []
  );

  useEffect(
    // Effect for clearing out server side validation
    () => {
      if (submitApiState.error) {
        if (overlay) {
          setOverlay(false);
        }
        console.log("Hoooooo", submitApiState.error.msg);
        setPreviousPageMode(pageMode);
        setPageMode("error");
        if ("save_button" in refStoreObject.current) {
          refStoreObject.current["save_button"].removeAttribute("disabled");
        }
        if ("print_button" in refStoreObject.current) {
          refStoreObject.current["print_button"].removeAttribute("disabled");
        }
        setPopupError(submitApiState.error.msg);
        clearSubmitApiState();
      }
      if (submitApiState.data) {
        if (overlay) {
          setOverlay(false);
        }
        if (
          ["nrab", "syt", "sangam"].includes(process.env.REACT_APP_CLIENT) &&
          formName == "Bilty"
        ) {
          let apiObjGeneralRate = {
            url: SERVER_URL + "/general_rate/add_general_rate",
            apiConfig: apiConfig.saveGeneralRateMaster,
            keysToSend: [
              "station_from",
              "station_to",
              "unit",
              "item_id",
              "rate",
              "consignor",
              "consignee",
            ],
          };

          (async () => {
            const filteredData = Object.fromEntries(
              apiObjGeneralRate.keysToSend.map((key) => {
                if (key === "consignor") {
                  return [
                    "consignor",
                    submitApiState.data.response["consignor_id"],
                  ];
                } else if (key === "consignee") {
                  return [
                    "consignee",
                    submitApiState.data.response["consignee_id"],
                  ];
                } else {
                  return [key, pageState[key]];
                }
              })
            );

            const response = await fetch(apiObjGeneralRate.url, {
              method: "POST",
              headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
              },
              body: JSON.stringify(filteredData),
            });

            if (!response.ok) {
              throw new Error("Network response was not ok");
            }

            const data = await response.json();
            return data;
          })();
        }
        if (serverPrintNeeded) {
          console.log("In Print");
          executeServerPrint(submitApiState.data);
        }
        // refStoreObject.current["save_button"].removeAttribute("disabled");
        // refStoreObject.current["print_button"].removeAttribute("disabled");
        setPageState({
          ...pageState,
          ...submitApiState.data.response,
        });
        if (clearDataOnSave) {
          setClearDataOnSave(false);
          window.location.reload();
        }
        setPageMode("submitted");
        clearSubmitApiState();
      }
    },
    [submitApiState]
  );

  useEffect(
    // Effect for handling Api response
    () => {
      console.log({ suggestionApiState });
      // Suggestion Api response handeling
      if (
        suggestionApiState.data &&
        suggestionApiState.data.apiType == "SugesstionValue"
      ) {
        if (overlay) {
          setOverlay(false);
        }
        let text = {
          responseForFrontend: {},
        };
        if (formName == "Vehicle") {
          if ("modified_date" in suggestionApiState.data.response) {
            suggestionApiState.data.response.modified_date = formatDate(
              new Date(suggestionApiState.data.response.entry_date)
            );
          }
          if ("second_owner_entry_date" in suggestionApiState.data.response) {
            suggestionApiState.data.response.second_owner_entry_date =
              formatDate(
                new Date(
                  suggestionApiState.data.response.second_owner_entry_date
                )
              );
          }
          if ("third_owner_entry_date" in suggestionApiState.data.response) {
            suggestionApiState.data.response.third_owner_entry_date =
              formatDate(
                new Date(
                  suggestionApiState.data.response.third_owner_entry_date
                )
              );
          }
          if ("effective" in suggestionApiState.data.response) {
            suggestionApiState.data.response.effective_date = formatDate(
              new Date(suggestionApiState.data.response.effective_date)
            );
          }
        }
        for (let key in suggestionApiState.data.suggestionSchema) {
          if (process.env.REACT_APP_CLIENT == "ravechi") {
            if (suggestionApiState.data.response[key] == null) {
              continue;
            }
          } else {
            if (suggestionApiState.data.response[key] == null) {
              text.responseForFrontend[
                suggestionApiState.data.suggestionSchema[key]
              ] = "";
              continue;
            }
          }
          text.responseForFrontend[
            suggestionApiState.data.suggestionSchema[key]
          ] = suggestionApiState.data.response[key];
        }
        if (
          suggestionApiState.data.fieldInfoObject
            .valueVerificationFromSuggestionNeeded
        ) {
          setValueVerificationState({
            ...valueVerificationState,
            ...text.responseForFrontend,
          });
        }

        if (
          "idClearanceNeeded" in suggestionApiState.data.fieldInfoObject &&
          suggestionApiState.data.fieldInfoObject.idClearanceNeeded != ""
        ) {
          let idClearanceObject = {};
          for (let key in text.responseForFrontend) {
            if (
              "onChangeIgnoreClearance" in
              suggestionApiState.data.fieldInfoObject
            ) {
              if (
                !suggestionApiState.data.fieldInfoObject.onChangeIgnoreClearance.includes(
                  key
                )
              ) {
                idClearanceObject[key] = {};
                idClearanceObject[key].value = text.responseForFrontend[key];
                idClearanceObject[key].fieldToClear =
                  suggestionApiState.data.fieldInfoObject.idClearanceNeeded;
              }
            } else {
              idClearanceObject[key] = {};
              idClearanceObject[key].value = text.responseForFrontend[key];
              idClearanceObject[key].fieldToClear =
                suggestionApiState.data.fieldInfoObject.idClearanceNeeded;
            }
          }
          if (
            "isTable" in suggestionApiState.data.fieldInfoObject &&
            suggestionApiState.data.fieldInfoObject.isTable
          ) {
            let parentFieldName =
              suggestionApiState.data.fieldInfoObject.parentName;
            updateObjectInListInIdClearanceState(
              suggestionApiState.data.index,
              idClearanceObject,
              parentFieldName
            );
          } else {
            setIdClearancState({
              ...idClearancState,
              ...idClearanceObject,
            });
          }
        }

        if (
          "isTable" in suggestionApiState.data.fieldInfoObject &&
          suggestionApiState.data.fieldInfoObject.isTable
        ) {
          let parentFieldName =
            suggestionApiState.data.fieldInfoObject.parentName;
          updateObjectInListInPageState(
            suggestionApiState.data.index,
            text.responseForFrontend,
            parentFieldName
          );
        } else {
          setPageState({
            ...pageState,
            ...text.responseForFrontend,
          });
        }
      }
      // Get Bilty Api response handeling
      if (
        suggestionApiState.data &&
        (suggestionApiState.data.apiType == "getBilty" ||
          suggestionApiState.data.apiType == "getMrInquiry" ||
          suggestionApiState.data.apiType == "getBiltyInquiry" ||
          suggestionApiState.data.apiType == "getChallan" ||
          suggestionApiState.data.apiType == "getFleet" ||
          suggestionApiState.data.apiType == "getStockOutward" ||
          suggestionApiState.data.apiType == "getStockInward" ||
          suggestionApiState.data.apiType == "getTrip" ||
          suggestionApiState.data.apiType == "getVehicleRegister" ||
          suggestionApiState.data.apiType == "getMrPending" ||
          suggestionApiState.data.apiType == "getVehicle" ||
          suggestionApiState.data.apiType == "getCrossingIn" ||
          suggestionApiState.data.apiType == "getCrossingOut" ||
          suggestionApiState.data.apiType == "getCrossingBill" ||
          suggestionApiState.data.apiType == "getTripBhada" ||
          suggestionApiState.data.apiType == "getPage" ||
          suggestionApiState.data.apiType == "getMr" ||
          suggestionApiState.data.apiType == "getMarfatiya")
      ) {
        if (overlay) {
          setOverlay(false);
        }
        if (
          "is_deleted" in suggestionApiState.data.response &&
          suggestionApiState.data.response.is_deleted == "1"
        ) {
          clearSuggestionApiState();
          return;
        }

        if (suggestionApiState.data.apiType == "getChallan") {
          clearSuggestionApiState();
          console.log("assa", suggestionApiState.data.response);
          if ("multiple_manual_chalan" in suggestionApiState.data.response) {
            console.log("Hererer");
            let dummyObject = {
              multiple_popup: "1",
              multiple_popup_data:
                suggestionApiState.data.response["multiple_manual_chalan"],
            };
            console.log(dummyObject, "asdfdgh");
            // myForm.setPageStateByField("multiple_popup", "1")
            setPageState({
              ...pageState,
              ...dummyObject,
            });
            return;
          }
        }
        if (formName == "VehicleRegister") {
          if ("received_date" in suggestionApiState.data.response) {
            suggestionApiState.data.response.received_date = formatDate(
              new Date(suggestionApiState.data.response.received_date)
            );
          }
          if ("register_date" in suggestionApiState.data.response) {
            suggestionApiState.data.response.register_date = formatDate(
              new Date(suggestionApiState.data.response.register_date)
            );
          }
          if ("x_date" in suggestionApiState.data.response) {
            suggestionApiState.data.response.x_date = formatDate(
              new Date(suggestionApiState.data.response.x_date)
            );
          }
        }

        if (formName == "FleetManagement") {
          let tmp = suggestionApiState.data.response.arrive_date.split("T")[0];
          suggestionApiState.data.response.arrive_date = tmp;

          tmp = suggestionApiState.data.response.depart_date.split("T")[0];
          suggestionApiState.data.response.depart_date = tmp;

          tmp = suggestionApiState.data.response.fleet_date.split("T")[0];
          suggestionApiState.data.response.fleet_date = tmp;

          suggestionApiState.data.response.trip_info =
            suggestionApiState.data.response.trip_info.map((row) => {
              for (let key in row) {
                if (row[key] == null) {
                  row[key] = "";
                }
                if (key == "trip_date") {
                  row[key] = row[key].split("T")[0];
                }
              }

              return row;
            });
        }
        if (formName == "CROSSINGBILLING") {
          let tmp = suggestionApiState.data.response.input_date.split("T")[0];
          suggestionApiState.data.response.input_date = tmp;
        }
        if (formName == "StockOutward") {
          let tmp = suggestionApiState.data.response.outward_date.split("T")[0];
          suggestionApiState.data.response.outward_date = tmp;
        }
        if (formName == "StockInward") {
          let tmp = suggestionApiState.data.response.inward_date.split("T")[0];
          suggestionApiState.data.response.inward_date = tmp;

          suggestionApiState.data.response.item_info =
            suggestionApiState.data.response.item_info.map((item) => {
              item.valid_upto = item.valid_upto?.split("T")[0];
              return item;
            });
        }

        if ("input_date" in suggestionApiState.data.response) {
          if (
            formName == "CROSSINGIN" ||
            formName == "CONSIGNORBILLING" ||
            formName == "MRBILLING" ||
            formName == "AccountTransaction" ||
            formName == "Trip" ||
            formName == "MrPendingAmount" ||
            formName == "TripBhada"
          ) {
            suggestionApiState.data.response.input_date = formatDate(
              new Date(suggestionApiState.data.response.input_date)
            );
          } else if (formName == "MR") {
          } else {
            suggestionApiState.data.response.input_date = new Date(
              suggestionApiState.data.response.input_date
            );
          }
        }

        if (formName == "PODSTATEMENT") {
          if (
            "pod_statement_receive_date" in suggestionApiState.data.response
          ) {
            suggestionApiState.data.response.pod_statement_receive_date =
              new Date(
                suggestionApiState.data.response.pod_statement_receive_date
              );
          }
        }

        if (formName == "CROSSINGBILLING") {
          if ("date_to" in suggestionApiState.data.response) {
            suggestionApiState.data.response.date_to = new Date(
              suggestionApiState.data.response.date_to
            );
            console.log("HERE");
          }
          if ("date_from" in suggestionApiState.data.response) {
            suggestionApiState.data.response.date_from = new Date(
              suggestionApiState.data.response.date_from
            );
          }
        }
        if ("bhada_paid_date" in suggestionApiState.data.response) {
          if (formName == "TripBhada" || formName == "Trip") {
            if (suggestionApiState.data.response.bhada_paid_date) {
              suggestionApiState.data.response.bhada_paid_date = formatDate(
                suggestionApiState.data.response.bhada_paid_date
              );
            }
          } else {
            suggestionApiState.data.response.bhada_paid_date = new Date(
              suggestionApiState.data.response.bhada_paid_date
            );
          }
        }
        if ("bill_date" in suggestionApiState.data.response) {
          suggestionApiState.data.response.bill_date = formatDate(
            new Date(suggestionApiState.data.response.bill_date)
          );
        }
        /**
         * Convert value of items into string.
         */
        if ("item_in" in suggestionApiState.data.response) {
          for (
            let index = 0;
            index < suggestionApiState.data.response["item_in"].length;
            index++
          ) {
            for (let key in suggestionApiState.data.response["item_in"][
              index
            ]) {
              suggestionApiState.data.response["item_in"][index][key] = String(
                suggestionApiState.data.response["item_in"][index][key]
              );
            }
            if (
              index ==
              suggestionApiState.data.response["item_in"].length - 1
            ) {
              suggestionApiState.data.response["item_in"][index]["new_row"] =
                "N";
            } else {
              suggestionApiState.data.response["item_in"][index]["new_row"] =
                "Y";
            }
          }
        }
        if ("eway_bill_no" in suggestionApiState.data.response) {
          for (
            let index = 0;
            index < suggestionApiState.data.response["eway_bill_no"].length;
            index++
          ) {
            for (let key in suggestionApiState.data.response["eway_bill_no"][
              index
            ]) {
              suggestionApiState.data.response["eway_bill_no"][index][key] =
                String(
                  suggestionApiState.data.response["eway_bill_no"][index][key]
                );
            }
            if (
              index ==
              suggestionApiState.data.response["eway_bill_no"].length - 1
            ) {
              suggestionApiState.data.response["eway_bill_no"][index][
                "new_row"
              ] = "N";
            } else {
              suggestionApiState.data.response["eway_bill_no"][index][
                "new_row"
              ] = "Y";
            }
          }
        }
        if (
          "transporter_id" in suggestionApiState.data.response &&
          suggestionApiState.data.apiType == "getBilty" &&
          suggestionApiState.data.response.transporter_id != null &&
          suggestionApiState.data.response.transporter_id != ""
        ) {
          suggestionApiState.data.response.is_crossing = "Y";
        }
        /**
         *Set hooks.
         */
        if (formName == "Bilty") {
          let verificationObject = {};
          let idClearanceObject = {};
          for (let key in BiltyDataObjectForVerificationFromSuggestion) {
            if (BiltyDataObjectForVerificationFromSuggestion[key]) {
              verificationObject[key] = suggestionApiState.data.response[key];
            }
          }
          for (let key in BiltyDataObjectForIdClearance) {
            idClearanceObject[key] = {};
            idClearanceObject[key].value =
              suggestionApiState.data.response[key];
            idClearanceObject[key].fieldToClear =
              BiltyDataObjectForIdClearance[key].fieldToClear;
          }
          setValueVerificationState({
            ...valueVerificationState,
            ...verificationObject,
          });
          setIdClearancState({
            ...idClearancState,
            ...idClearanceObject,
          });
        }
        if (formName == "Challan") {
          (suggestionApiState.data.response.No = ""),
            (suggestionApiState.data.response.bilty_type = "D");
        }
        setPageMode("view");
        setPageState({
          ...pageState,
          ...suggestionApiState.data.response,
        });
        // NEW CODE FOR SENDING CLERANCE STATUS

        if (formName == "AccountTransaction") {
          setInitialPageState({
            ...initialpageState,
            ...suggestionApiState.data.response,
          });
        }
        // END
      }
      if (
        suggestionApiState.data &&
        (suggestionApiState.data.apiType == "getEwbInfo" ||
          suggestionApiState.data.apiType == "generateCwb")
      ) {
        if (overlay) {
          setOverlay(false);
        }
        if (suggestionApiState.data.apiType == "getEwbInfo") {
          makeFocusOnParticularField("station_from_name");
        }
        let idClearanceDummy = {
          consignor_gst: {
            value: suggestionApiState.data.response.consignor_gst,
            fieldToClear: "consignor_id",
          },
          consignor_name: {
            value: suggestionApiState.data.response.consignor_name,
            fieldToClear: "consignor_id",
          },
        };
        setIdClearancState({
          ...idClearancState,
          ...idClearanceDummy,
        });
        setPageState({
          ...pageState,
          ...suggestionApiState.data.response,
        });
      }
    },
    [suggestionApiState.data]
  );

  useEffect(
    // Effect for handling Api response
    () => {
      // if(overlay){
      //   setOverlay(false);
      // }
      // Get Bilty Api response handeling
      if (
        suggestionApiState.error &&
        suggestionApiState.error.data.apiType == "getBilty"
      ) {
        if (overlay) {
          setOverlay(false);
        }
        let urlTailString = suggestionApiState.error.data.apiUrlTail;
        let bilty_no = urlTailString.split("?")[0];
        // console.log("Bilt no", bilty_no);
        // if (bilty_no.length == 8 || bilty_no.length == 9) {
        //   setPageMode("error");
        //   setPopupError(
        //     "Bilty number you are trying to fetch is invalid automatic bilty."
        //   );
        //   return;
        // }
        if (process.env.REACT_APP_CLIENT != "sra") {
          makeFocusOnParticularFieldForItem("eway_bill_no", 0, "eway_bill_no");
        }
        // makeFocusOnParticularField("is_crossing");
      }

      if (
        suggestionApiState.error &&
        suggestionApiState.error.data.apiType == "getChallan"
      ) {
        if (overlay) {
          setOverlay(false);
        }
        // let urlTailString = suggestionApiState.error.data.apiUrlTail;
        // let bilty_no = urlTailString.split("?")[0];
        makeFocusOnParticularField("vehicle_no");
      }
      if (
        suggestionApiState.error &&
        suggestionApiState.error.data.apiType == "getFleet"
      ) {
        if (overlay) {
          setOverlay(false);
        }
        // let urlTailString = suggestionApiState.error.data.apiUrlTail;
        // let bilty_no = urlTailString.split("?")[0];
        makeFocusOnParticularField("fleet_no");
      }
      if (
        suggestionApiState.error &&
        (suggestionApiState.error.data.apiType == "getStockOutward" ||
          suggestionApiState.error.data.apiType == "getStockInward")
      ) {
        if (overlay) {
          setOverlay(false);
        }
        // let urlTailString = suggestionApiState.error.data.apiUrlTail;
        // let bilty_no = urlTailString.split("?")[0];
        makeFocusOnParticularField("register_no");
      }

      if (
        suggestionApiState.error &&
        suggestionApiState.error.data.apiType == "getCrossingBill"
      ) {
        if (overlay) {
          setOverlay(false);
        }
        // let urlTailString = suggestionApiState.error.data.apiUrlTail;
        // let bilty_no = urlTailString.split("?")[0];
        // makeFocusOnParticularField("bill_no")
      }

      if (
        suggestionApiState.error &&
        suggestionApiState.error.data.apiType == "getVehicleRegister"
      ) {
        if (overlay) {
          setOverlay(false);
        }
        // let urlTailString = suggestionApiState.error.data.apiUrlTail;
        // let bilty_no = urlTailString.split("?")[0];
        makeFocusOnParticularField("letter_no");
      }

      // Get Ewb error popup
      if (
        suggestionApiState.error &&
        suggestionApiState.error.data.apiType == "getEwbInfo"
      ) {
        if (overlay) {
          setOverlay(false);
        }
        setPageMode("error");
        setPopupError(suggestionApiState.error.msg);
        makeFocusOnParticularFieldForItem("eway_bill_no", 0, "eway_bill_no");
      }

      // if (
      //   suggestionApiState.error &&
      //   suggestionApiState.error.data.apiType == "getPodChallan"
      // ) {
      //   setPageMode("error");
      //   setPopupError(
      //     "Ewb Entered is either invalid or not for this transporter."
      //   );
      // }
    },
    [suggestionApiState.error]
  );

  if (formName == "Bilty") {
    useEffect(() => {
      let needsUpdate = false;
      let updatedPageStateTotal = {};

      if (isFreightEditable) {
        const currentItemsSerialized = JSON.stringify(pageState.item_in);
        if (prevItemInRef.current && freightOverriddenRef.current) {
          if (currentItemsSerialized !== prevItemInRef.current) {
            freightOverriddenRef.current = false;
          }
        }
        prevItemInRef.current = currentItemsSerialized;
      }

      let freightOverridden = freightOverriddenRef.current;

      if (pageMode !== prevPageModeRef.current) {
        freightOverriddenRef.current = false;
        prevItemInRef.current = null;
        loadedBiltyIdRef.current = null;
        prevPageModeRef.current = pageMode;
      }

      if (isFreightEditable && pageState.bilty_id && pageState.bilty_id !== "" &&
          pageState.freight !== "" && pageState.freight !== "0" &&
          pageState.bilty_id !== loadedBiltyIdRef.current) {
        freightOverridden = true;
        freightOverriddenRef.current = true;
        loadedBiltyIdRef.current = pageState.bilty_id;
      }

      [needsUpdate, updatedPageStateTotal] =
        biltyAutoUpdationEffectsDummy(pageState, isFreightEditable, freightOverridden);

      if ("item_in" in updatedPageStateTotal) {
        updatedPageStateTotal.item_in = updatedPageStateTotal.item_in.map((item) => {
          if (item.pkgs == "undefined") {
            return { ...item, pkgs: "0" };
          }
          return item;
        });
      }

      if (needsUpdate) {
        setPageState((oldState) => ({ ...oldState, ...updatedPageStateTotal }));
      }
    }, [pageState]);
  }

  if (formName == "MR") {
    useEffect(() => {
      let needsUpdate = false;
      let updatedPageStateTotal = {};
      [needsUpdate, updatedPageStateTotal] =
        mrAutoUpdationEffectsDummy(pageState);
      if (needsUpdate) {
        setPageState({ ...pageState, ...updatedPageStateTotal });
      }
    }, [pageState]);
  }

  if (formName == "Trip") {
    useEffect(() => {
      let labour = parseFloat(pageState.labour) || 0;
      let other_charge = parseFloat(pageState.other_charge) || 0;
      let amount = parseFloat(pageState.amount) || 0;
      let extra_charge = parseFloat(pageState.extra_charge) || 0;
      let detention_charge = parseFloat(pageState.detention_charge) || 0;
      let shortage_charge = parseFloat(pageState.shortage_charge) || 0;
      let other_deduction_charge =
        parseFloat(pageState.other_deduction_charge) || 0;
      let advance_bhada = parseFloat(pageState.advance_bhada) || 0;
      let balance_bhada = parseFloat(pageState.balance_bhada) || 0;
      let tds_rate = parseFloat(pageState.tds_rate) || 0;
      let tds_amount = parseFloat(pageState.tds_amount) || 0;

      let balance =
        amount +
        extra_charge +
        detention_charge -
        shortage_charge -
        other_deduction_charge -
        advance_bhada +
        other_charge +
        labour;
      let tdsAmount = (amount * tds_rate) / 100;
      let netBalance = balance - tdsAmount;

      let objectToUpdate = {
        balance_bhada: String(balance),
        tds_amount: tdsAmount,
        net_balance: netBalance,
      };
      if (balance_bhada != balance || tdsAmount != tds_amount) {
        // setPageState({ ...pageState, ...objectToUpdate });
        // setPageStateByField("balance_bhada", String(newAmount));
        setPageState((oldState) => ({
          ...oldState,
          ...objectToUpdate,
        }));
      }
    }, [
      pageState.other_charge,
      pageState.labour,
      pageState.amount,
      pageState.extra_charge,
      pageState.detention_charge,
      pageState.shortage_charge,
      pageState.other_deduction_charge,
      pageState.advance_bhada,
      pageState.tds_rate,
    ]);
  }

  if (
    formName == "CONSIGNORBILLING" ||
    formName == "MRBILLING" ||
    formName == "CROSSINGBILLING"
  ) {
    useEffect(() => {
      let needsUpdate = false;
      let objectToUpdate = {};
      let total_amount = parseInt(pageState.total_amount) || 0;
      let service_charge = parseInt(pageState.service_charge) || 0;
      let lc_amount = parseInt(pageState.lc_charge) || 0;
      let add = parseInt(pageState.add) || 0;
      let net_amount = parseInt(pageState.net_amount) || 0;
      let gross_amount = parseInt(pageState.gross_amount) || 0;
      let amt1 = parseInt(pageState.amt1) || 0;
      let amt2 = parseInt(pageState.amt2) || 0;
      let amt3 = parseInt(pageState.amt3) || 0;
      let cgst = parseFloat(pageState.cgst) || 0;
      let igst = parseFloat(pageState.igst) || 0;
      let sgst = parseFloat(pageState.sgst) || 0;
      let gst_amount = parseInt(pageState.gst_amount) || 0;
      let extra_hamali = parseInt(pageState.extra_hamali) || 0;
      let hamali = parseInt(pageState.hamali) || 0;
      let door_del_charge = parseInt(pageState.door_del_charge) || 0;
      let bilty_charge = parseInt(pageState.bilty_charge) || 0;
      let extra_percentage = parseInt(pageState.extra_percentage) || 0;
      let extra_percentage_amount =
        parseInt(pageState.extra_percentage_amount) || 0;
      // let extra = gross_amount*extra_percentage/100 + gross_amount

      // Check if extra amount needs to be updated or not.
      if (
        extra_percentage_amount !=
        parseInt((gross_amount * extra_percentage) / 100)
      ) {
        needsUpdate = true;
        console.log(
          "In extra percentage",
          extra_percentage_amount,
          (gross_amount * extra_percentage) / 100
        );
        objectToUpdate.extra_percentage_amount =
          (gross_amount * extra_percentage) / 100;
      }
      if (process.env.REACT_APP_CLIENT === "g_trans") {
        const calculatedNetAmount =
          gross_amount +
          extra_hamali +
          bilty_charge +
          door_del_charge +
          lc_amount +
          service_charge;

        if (pageState.net_amount !== calculatedNetAmount) {
          needsUpdate = true;
          objectToUpdate.net_amount = calculatedNetAmount;
        }
      } else if (process.env.REACT_APP_CLIENT == "shubham") {
        if (
          net_amount !=
          total_amount +
            add +
            extra_percentage_amount +
            amt1 +
            amt2 +
            amt3 +
            extra_hamali
        ) {
          needsUpdate = true;
          objectToUpdate.net_amount =
            total_amount +
            add +
            extra_percentage_amount +
            amt1 +
            amt2 +
            amt3 +
            extra_hamali;
        }
      } else if (process.env.REACT_APP_CLIENT == "nrab" || process.env.REACT_APP_CLIENT == "syt" || process.env.REACT_APP_CLIENT == "sangam") {
        if (formName == "CROSSINGBILLING") {
          if (net_amount != add + total_amount) {
            needsUpdate = true;
            objectToUpdate.net_amount = add + total_amount;
          }
        } else {
          if (
            net_amount !=
            gross_amount +
              add +
              extra_percentage_amount +
              amt1 +
              amt2 +
              hamali +
              bilty_charge +
              door_del_charge
          ) {
            needsUpdate = true;
            objectToUpdate.net_amount =
              gross_amount +
              add +
              extra_percentage_amount +
              amt1 +
              amt2 +
              hamali +
              bilty_charge +
              door_del_charge;
          }
        }
      } else if (
        process.env.REACT_APP_CLIENT === "guru" &&
        formName === "CONSIGNORBILLING"
      ) {
        let calculatedNetAmount =
          total_amount +
          add +
          extra_percentage_amount +
          amt1 +
          amt2 +
          cgst +
          sgst +
          igst;

        if (net_amount !== calculatedNetAmount) {
          needsUpdate = true;
          objectToUpdate.net_amount = Math.round(calculatedNetAmount);
          objectToUpdate.gst_amount =
            total_amount + add + extra_percentage_amount + amt1 + amt2;
        }
      } else {
        if (
          net_amount !=
          total_amount + add + extra_percentage_amount + amt1 + amt2
        ) {
          needsUpdate = true;
          console.log(
            "In net amount",
            net_amount,
            total_amount + add + extra_percentage_amount
          );
          objectToUpdate.net_amount =
            total_amount + add + extra_percentage_amount + amt1 + amt2;
        }
      }
      console.log("Needs Flag last", needsUpdate);
      if (needsUpdate) {
        console.log("Net Amount", objectToUpdate);
        // objectToUpdate.net_amount = String(parseInt(objectToUpdate.net_amount) + parseInt(objectToUpdate.extra_percentage_amount))
        setPageState((pageStateOld) => ({
          ...pageStateOld,
          ...objectToUpdate,
        }));
      }
      // else if(extra_percentage > 0){
      // objectToUpdate.net_amount = String(parseInt(net_amount) + parseInt(extra))
      // setPageState({ ...pageState, ...objectToUpdate });
      // }
    }, [
      formName,
      pageState.total_amount,
      pageState.add,
      pageState.net_amount,
      pageState.amt1,
      pageState.amt2,
      pageState.amt3,
      pageState.cgst,
      pageState.sgst,
      pageState.igst,
      pageState.extra_percentage_amount,
      pageState.door_del_charge,
      pageState.hamali,
      pageState.bilty_charge,
      pageState.extra_percentage,
      pageState.extra_hamali,
      pageState.gross_amount,
    ]);
  }

  if (formName == "BillPaid") {
    useEffect(() => {
      let needsUpdate = false;
      let objectToUpdate = {};
      let net_amount = parseInt(pageState.net_amount) || 0;
      let tds_per = parseInt(pageState.tds_per) || 0;
      let tds = parseInt(pageState.tds) || 0;
      let gst_amount = parseInt(pageState.gst_amount) || 0;
      // let extra = gross_amount*extra_percentage/100 + gross_amount
      let baseAmount = process.env.REACT_APP_CLIENT === "guru" ? gst_amount : net_amount;
      let calculatedTds = (baseAmount * tds_per) / 100;
      // Check if extra amount needs to be updated or not.
      if (tds !== parseInt(calculatedTds)) {
        needsUpdate = true;
        console.log("In tds percentage", tds, calculatedTds);
        objectToUpdate.tds = calculatedTds;
      }
      // if (
      //   net_amount !=
      //   total_amount + add + extra_percentage_amount + amt1 + amt2
      // ) {
      //   needsUpdate = true;
      //   console.log(
      //     "In net amount",
      //     net_amount,
      //     total_amount + add + extra_percentage_amount
      //   );
      //   objectToUpdate.net_amount =
      //     total_amount + add + extra_percentage_amount + amt1 + amt2;
      // }
      // console.log("Needs Flag last", needsUpdate);
      if (needsUpdate) {
        console.log("Net Amount", objectToUpdate);
        // objectToUpdate.net_amount = String(parseInt(objectToUpdate.net_amount) + parseInt(objectToUpdate.extra_percentage_amount))
        setPageState({ ...pageState, ...objectToUpdate });
      }
      // else if(extra_percentage > 0){
      // objectToUpdate.net_amount = String(parseInt(net_amount) + parseInt(extra))
      // setPageState({ ...pageState, ...objectToUpdate });
      // }
    }, [pageState]);
  }

  return {
    pageState,
    setPageState,
    internalValidationErrors,
    setInternalValidationErrors,
    submitApiState,
    performSubmission,
    suggestionApiState,
    performSuggestions,
    suggestions,
    setSuggestions,
    handleChange,
    handleChangeForSelect,
    getSuggestionValue,
    renderSuggestion,
    onSuggestionsFetchRequested,
    onSuggestionsClearRequested,
    onChangeAutoSuggest,
    handleSuccess,
    suggestionFetchApi,
    setPageStateByField,
    handleSubmit,
    isSubmitting,
    handleValueUpdate,
    renderSubmitApiResponseStatus,
    onKeyChange,
    onblurValidator,
    getPageOnKeyEnter,
    pageMode,
    setPageMode,
    refStoreObject,
    storeInputReference,
    makeFocusOnParticularField,
    onKeyPressForKeyNav,
    updatePageStateForGetSuggestion,
    valueVerificationState,
    makeFocusOnParticularFieldForItem,
    storeInputReferenceForSelect,
    idClearancState,
    setIdClearancState,
    onblurValidatorForTable,
    storeInputReferenceForSelectForDynamicTable,
    popupError,
    setPopupError,
    serverPrintNeeded,
    setServerPrintNeeded,
    previousPageMode,
    setPreviousPageMode,
    synchronousSave,
    deletePopup,
    setDeletePopup,
    clearDataOnSave,
    setClearDataOnSave,
    onSuggestionsFetchRequestedDebounced,
    overlay,
    setOverlay,
    getFyearsOnKeyEnter,
    displayFyearPopup,
    getSuffixesOfBilty,
    initialpageState, //NEW CODE FOR SENDING CLERANCE STATUS
  };
};

export default useForm;
